import { useMutation, useQuery, UseMutationOptions, UseQueryOptions } from 'react-query';
import { gqlFetcher } from '../lib/fetcher';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Array: any;
  JsonArgument: any;
  Upload: any;
};

export type AssetContainer = {
  __typename?: 'AssetContainer';
  handle: Scalars['String'];
  title: Scalars['String'];
};

export type AssetInterface = {
  blueprint?: Maybe<Scalars['String']>;
  container: AssetContainer;
  edit_url?: Maybe<Scalars['String']>;
  extension: Scalars['String'];
  focus_css?: Maybe<Scalars['String']>;
  folder?: Maybe<Scalars['String']>;
  height?: Maybe<Scalars['Float']>;
  id: Scalars['String'];
  is_audio?: Maybe<Scalars['Boolean']>;
  is_image?: Maybe<Scalars['Boolean']>;
  is_video?: Maybe<Scalars['Boolean']>;
  last_modified?: Maybe<Scalars['String']>;
  orientation?: Maybe<Scalars['String']>;
  path: Scalars['String'];
  permalink?: Maybe<Scalars['String']>;
  ratio?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['String']>;
  size_b?: Maybe<Scalars['Int']>;
  size_bytes?: Maybe<Scalars['Int']>;
  size_gb?: Maybe<Scalars['Float']>;
  size_gigabytes?: Maybe<Scalars['Float']>;
  size_kb?: Maybe<Scalars['Float']>;
  size_kilobytes?: Maybe<Scalars['Float']>;
  size_mb?: Maybe<Scalars['Float']>;
  size_megabytes?: Maybe<Scalars['Float']>;
  url?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Float']>;
};

export type AssetInterfacePagination = {
  __typename?: 'AssetInterfacePagination';
  /** Current page of the cursor */
  current_page: Scalars['Int'];
  /** List of items on the current page */
  data?: Maybe<Array<Maybe<AssetInterface>>>;
  /** Number of the first item returned */
  from?: Maybe<Scalars['Int']>;
  /** Determines if cursor has more pages after the current page */
  has_more_pages: Scalars['Boolean'];
  /** The last page (number of pages) */
  last_page: Scalars['Int'];
  /** Number of items returned per page */
  per_page: Scalars['Int'];
  /** Number of the last item returned */
  to?: Maybe<Scalars['Int']>;
  /** Number of total items selected by the query */
  total: Scalars['Int'];
};

export type Asset_Assets = AssetInterface & {
  __typename?: 'Asset_Assets';
  alt?: Maybe<Scalars['String']>;
  blueprint?: Maybe<Scalars['String']>;
  container: AssetContainer;
  edit_url?: Maybe<Scalars['String']>;
  extension: Scalars['String'];
  focus_css?: Maybe<Scalars['String']>;
  folder?: Maybe<Scalars['String']>;
  height?: Maybe<Scalars['Float']>;
  id: Scalars['String'];
  is_audio?: Maybe<Scalars['Boolean']>;
  is_image?: Maybe<Scalars['Boolean']>;
  is_video?: Maybe<Scalars['Boolean']>;
  last_modified?: Maybe<Scalars['String']>;
  orientation?: Maybe<Scalars['String']>;
  path: Scalars['String'];
  permalink?: Maybe<Scalars['String']>;
  ratio?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['String']>;
  size_b?: Maybe<Scalars['Int']>;
  size_bytes?: Maybe<Scalars['Int']>;
  size_gb?: Maybe<Scalars['Float']>;
  size_gigabytes?: Maybe<Scalars['Float']>;
  size_kb?: Maybe<Scalars['Float']>;
  size_kilobytes?: Maybe<Scalars['Float']>;
  size_mb?: Maybe<Scalars['Float']>;
  size_megabytes?: Maybe<Scalars['Float']>;
  url?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Float']>;
};

export type Asset_Downloads = AssetInterface & {
  __typename?: 'Asset_Downloads';
  blueprint?: Maybe<Scalars['String']>;
  container: AssetContainer;
  description?: Maybe<Scalars['String']>;
  download_url?: Maybe<Scalars['String']>;
  edit_url?: Maybe<Scalars['String']>;
  extension: Scalars['String'];
  focus_css?: Maybe<Scalars['String']>;
  folder?: Maybe<Scalars['String']>;
  height?: Maybe<Scalars['Float']>;
  id: Scalars['String'];
  is_audio?: Maybe<Scalars['Boolean']>;
  is_image?: Maybe<Scalars['Boolean']>;
  is_video?: Maybe<Scalars['Boolean']>;
  last_modified?: Maybe<Scalars['String']>;
  orientation?: Maybe<Scalars['String']>;
  path: Scalars['String'];
  permalink?: Maybe<Scalars['String']>;
  ratio?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['String']>;
  size_b?: Maybe<Scalars['Int']>;
  size_bytes?: Maybe<Scalars['Int']>;
  size_gb?: Maybe<Scalars['Float']>;
  size_gigabytes?: Maybe<Scalars['Float']>;
  size_kb?: Maybe<Scalars['Float']>;
  size_kilobytes?: Maybe<Scalars['Float']>;
  size_mb?: Maybe<Scalars['Float']>;
  size_megabytes?: Maybe<Scalars['Float']>;
  title: Scalars['String'];
  url?: Maybe<Scalars['String']>;
  user_groups?: Maybe<Array<Maybe<UserGroup>>>;
  users?: Maybe<Array<Maybe<User>>>;
  width?: Maybe<Scalars['Float']>;
};

export type Asset_PostAssets = AssetInterface & {
  __typename?: 'Asset_PostAssets';
  alt?: Maybe<Scalars['String']>;
  blueprint?: Maybe<Scalars['String']>;
  container: AssetContainer;
  edit_url?: Maybe<Scalars['String']>;
  extension: Scalars['String'];
  focus_css?: Maybe<Scalars['String']>;
  folder?: Maybe<Scalars['String']>;
  height?: Maybe<Scalars['Float']>;
  id: Scalars['String'];
  is_audio?: Maybe<Scalars['Boolean']>;
  is_image?: Maybe<Scalars['Boolean']>;
  is_video?: Maybe<Scalars['Boolean']>;
  last_modified?: Maybe<Scalars['String']>;
  orientation?: Maybe<Scalars['String']>;
  path: Scalars['String'];
  permalink?: Maybe<Scalars['String']>;
  ratio?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['String']>;
  size_b?: Maybe<Scalars['Int']>;
  size_bytes?: Maybe<Scalars['Int']>;
  size_gb?: Maybe<Scalars['Float']>;
  size_gigabytes?: Maybe<Scalars['Float']>;
  size_kb?: Maybe<Scalars['Float']>;
  size_kilobytes?: Maybe<Scalars['Float']>;
  size_mb?: Maybe<Scalars['Float']>;
  size_megabytes?: Maybe<Scalars['Float']>;
  url?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Float']>;
};

export type Asset_UploadedAssets = AssetInterface & {
  __typename?: 'Asset_UploadedAssets';
  alt?: Maybe<Scalars['String']>;
  blueprint?: Maybe<Scalars['String']>;
  container: AssetContainer;
  edit_url?: Maybe<Scalars['String']>;
  extension: Scalars['String'];
  focus_css?: Maybe<Scalars['String']>;
  folder?: Maybe<Scalars['String']>;
  height?: Maybe<Scalars['Float']>;
  id: Scalars['String'];
  is_audio?: Maybe<Scalars['Boolean']>;
  is_image?: Maybe<Scalars['Boolean']>;
  is_video?: Maybe<Scalars['Boolean']>;
  last_modified?: Maybe<Scalars['String']>;
  orientation?: Maybe<Scalars['String']>;
  path: Scalars['String'];
  permalink?: Maybe<Scalars['String']>;
  ratio?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['String']>;
  size_b?: Maybe<Scalars['Int']>;
  size_bytes?: Maybe<Scalars['Int']>;
  size_gb?: Maybe<Scalars['Float']>;
  size_gigabytes?: Maybe<Scalars['Float']>;
  size_kb?: Maybe<Scalars['Float']>;
  size_kilobytes?: Maybe<Scalars['Float']>;
  size_mb?: Maybe<Scalars['Float']>;
  size_megabytes?: Maybe<Scalars['Float']>;
  url?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Float']>;
};

export type Asset_UserAssets = AssetInterface & {
  __typename?: 'Asset_UserAssets';
  alt?: Maybe<Scalars['String']>;
  blueprint?: Maybe<Scalars['String']>;
  container: AssetContainer;
  edit_url?: Maybe<Scalars['String']>;
  extension: Scalars['String'];
  focus_css?: Maybe<Scalars['String']>;
  folder?: Maybe<Scalars['String']>;
  height?: Maybe<Scalars['Float']>;
  id: Scalars['String'];
  is_audio?: Maybe<Scalars['Boolean']>;
  is_image?: Maybe<Scalars['Boolean']>;
  is_video?: Maybe<Scalars['Boolean']>;
  last_modified?: Maybe<Scalars['String']>;
  orientation?: Maybe<Scalars['String']>;
  path: Scalars['String'];
  permalink?: Maybe<Scalars['String']>;
  ratio?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['String']>;
  size_b?: Maybe<Scalars['Int']>;
  size_bytes?: Maybe<Scalars['Int']>;
  size_gb?: Maybe<Scalars['Float']>;
  size_gigabytes?: Maybe<Scalars['Float']>;
  size_kb?: Maybe<Scalars['Float']>;
  size_kilobytes?: Maybe<Scalars['Float']>;
  size_mb?: Maybe<Scalars['Float']>;
  size_megabytes?: Maybe<Scalars['Float']>;
  url?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Float']>;
};

export type BardText = {
  __typename?: 'BardText';
  text?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export type Code = {
  __typename?: 'Code';
  code: Scalars['String'];
  mode: Scalars['String'];
};

export type Collection = {
  __typename?: 'Collection';
  handle: Scalars['String'];
  structure?: Maybe<CollectionStructure>;
  title: Scalars['String'];
};

export type CollectionStructure = {
  __typename?: 'CollectionStructure';
  expects_root: Scalars['Boolean'];
  handle: Scalars['String'];
  max_depth?: Maybe<Scalars['Int']>;
  title: Scalars['String'];
  tree?: Maybe<Array<Maybe<CollectionTreeBranch>>>;
};


export type CollectionStructureTreeArgs = {
  site?: InputMaybe<Scalars['String']>;
};

export type CollectionTreeBranch = {
  __typename?: 'CollectionTreeBranch';
  children?: Maybe<Array<Maybe<CollectionTreeBranch>>>;
  depth: Scalars['Int'];
  entry?: Maybe<EntryInterface>;
  /** @deprecated Replaced by `entry` */
  page?: Maybe<EntryInterface>;
};

export type DateRange = {
  __typename?: 'DateRange';
  end?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['String']>;
};


export type DateRangeEndArgs = {
  format?: InputMaybe<Scalars['String']>;
};


export type DateRangeStartArgs = {
  format?: InputMaybe<Scalars['String']>;
};

export type EntryInterface = {
  blueprint?: Maybe<Scalars['String']>;
  collection: Collection;
  date?: Maybe<Scalars['String']>;
  edit_url: Scalars['String'];
  id: Scalars['ID'];
  last_modified?: Maybe<Scalars['String']>;
  locale: Scalars['String'];
  parent?: Maybe<EntryInterface>;
  permalink?: Maybe<Scalars['String']>;
  private: Scalars['Boolean'];
  published: Scalars['Boolean'];
  site: Site;
  slug: Scalars['String'];
  status: Scalars['String'];
  title: Scalars['String'];
  uri?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};


export type EntryInterfaceDateArgs = {
  format?: InputMaybe<Scalars['String']>;
};


export type EntryInterfaceLast_ModifiedArgs = {
  format?: InputMaybe<Scalars['String']>;
};

export type EntryInterfacePagination = {
  __typename?: 'EntryInterfacePagination';
  /** Current page of the cursor */
  current_page: Scalars['Int'];
  /** List of items on the current page */
  data?: Maybe<Array<Maybe<EntryInterface>>>;
  /** Number of the first item returned */
  from?: Maybe<Scalars['Int']>;
  /** Determines if cursor has more pages after the current page */
  has_more_pages: Scalars['Boolean'];
  /** The last page (number of pages) */
  last_page: Scalars['Int'];
  /** Number of items returned per page */
  per_page: Scalars['Int'];
  /** Number of the last item returned */
  to?: Maybe<Scalars['Int']>;
  /** Number of total items selected by the query */
  total: Scalars['Int'];
};

export type Entry_Events_Event = EntryInterface & {
  __typename?: 'Entry_Events_Event';
  blueprint?: Maybe<Scalars['String']>;
  collection: Collection;
  date?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  edit_url: Scalars['String'];
  event_types?: Maybe<Array<Maybe<TermInterface>>>;
  id: Scalars['ID'];
  image?: Maybe<AssetInterface>;
  last_modified?: Maybe<Scalars['String']>;
  locale: Scalars['String'];
  location?: Maybe<Scalars['String']>;
  location_link?: Maybe<Scalars['String']>;
  parent?: Maybe<EntryInterface>;
  permalink?: Maybe<Scalars['String']>;
  private: Scalars['Boolean'];
  published: Scalars['Boolean'];
  site: Site;
  slug: Scalars['String'];
  status: Scalars['String'];
  tickets_link?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  uri?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};


export type Entry_Events_EventDateArgs = {
  format?: InputMaybe<Scalars['String']>;
};


export type Entry_Events_EventLast_ModifiedArgs = {
  format?: InputMaybe<Scalars['String']>;
};

export type Entry_Lotteries_ExternalLottery = EntryInterface & {
  __typename?: 'Entry_Lotteries_ExternalLottery';
  blueprint?: Maybe<Scalars['String']>;
  collection: Collection;
  date?: Maybe<Scalars['String']>;
  edit_url: Scalars['String'];
  id: Scalars['ID'];
  last_modified?: Maybe<Scalars['String']>;
  link?: Maybe<Scalars['String']>;
  locale: Scalars['String'];
  parent?: Maybe<EntryInterface>;
  permalink?: Maybe<Scalars['String']>;
  private: Scalars['Boolean'];
  published: Scalars['Boolean'];
  site: Site;
  slug: Scalars['String'];
  status: Scalars['String'];
  text?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  uri?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  window?: Maybe<DateRange>;
};


export type Entry_Lotteries_ExternalLotteryDateArgs = {
  format?: InputMaybe<Scalars['String']>;
};


export type Entry_Lotteries_ExternalLotteryLast_ModifiedArgs = {
  format?: InputMaybe<Scalars['String']>;
};

export type Entry_Pages_Contact = EntryInterface & {
  __typename?: 'Entry_Pages_Contact';
  background_color: LabeledValue;
  blueprint?: Maybe<Scalars['String']>;
  button_text?: Maybe<Scalars['String']>;
  collection: Collection;
  components?: Maybe<Array<Maybe<Sets_Components>>>;
  components_section?: Maybe<Scalars['String']>;
  confirm_text?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['String']>;
  edit_url: Scalars['String'];
  error_text?: Maybe<Scalars['String']>;
  form?: Maybe<Form>;
  id: Scalars['ID'];
  image?: Maybe<AssetInterface>;
  intro_text?: Maybe<Scalars['String']>;
  last_modified?: Maybe<Scalars['String']>;
  locale: Scalars['String'];
  parent?: Maybe<EntryInterface>;
  permalink?: Maybe<Scalars['String']>;
  private: Scalars['Boolean'];
  published: Scalars['Boolean'];
  seo_description?: Maybe<Scalars['String']>;
  seo_hidden?: Maybe<Scalars['Boolean']>;
  seo_image?: Maybe<AssetInterface>;
  seo_title?: Maybe<Scalars['String']>;
  site: Site;
  slug: Scalars['String'];
  status: Scalars['String'];
  thank_you_text?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  uri?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};


export type Entry_Pages_ContactDateArgs = {
  format?: InputMaybe<Scalars['String']>;
};


export type Entry_Pages_ContactLast_ModifiedArgs = {
  format?: InputMaybe<Scalars['String']>;
};

export type Entry_Pages_News = EntryInterface & {
  __typename?: 'Entry_Pages_News';
  aside_components?: Maybe<Array<Maybe<Sets_AsideComponents>>>;
  blueprint?: Maybe<Scalars['String']>;
  collection: Collection;
  date?: Maybe<Scalars['String']>;
  edit_url: Scalars['String'];
  id: Scalars['ID'];
  insert_components?: Maybe<Array<Maybe<Sets_InsertComponents>>>;
  last_modified?: Maybe<Scalars['String']>;
  locale: Scalars['String'];
  parent?: Maybe<EntryInterface>;
  permalink?: Maybe<Scalars['String']>;
  private: Scalars['Boolean'];
  published: Scalars['Boolean'];
  seo_description?: Maybe<Scalars['String']>;
  seo_hidden?: Maybe<Scalars['Boolean']>;
  seo_image?: Maybe<AssetInterface>;
  seo_title?: Maybe<Scalars['String']>;
  site: Site;
  slug: Scalars['String'];
  status: Scalars['String'];
  title: Scalars['String'];
  title_link?: Maybe<Scalars['String']>;
  title_link_text?: Maybe<Scalars['String']>;
  uri?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};


export type Entry_Pages_NewsDateArgs = {
  format?: InputMaybe<Scalars['String']>;
};


export type Entry_Pages_NewsLast_ModifiedArgs = {
  format?: InputMaybe<Scalars['String']>;
};

export type Entry_Pages_Page = EntryInterface & {
  __typename?: 'Entry_Pages_Page';
  background_color: LabeledValue;
  blueprint?: Maybe<Scalars['String']>;
  collection: Collection;
  components?: Maybe<Array<Maybe<Sets_Components>>>;
  components_section?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['String']>;
  edit_url: Scalars['String'];
  hero_image?: Maybe<AssetInterface>;
  hero_link?: Maybe<Scalars['String']>;
  hero_link_text?: Maybe<Scalars['String']>;
  hero_section?: Maybe<Scalars['String']>;
  hero_text?: Maybe<Array<Maybe<Sets_HeroText>>>;
  hero_type?: Maybe<LabeledValue>;
  id: Scalars['ID'];
  last_modified?: Maybe<Scalars['String']>;
  locale: Scalars['String'];
  parent?: Maybe<EntryInterface>;
  permalink?: Maybe<Scalars['String']>;
  private: Scalars['Boolean'];
  published: Scalars['Boolean'];
  seo_description?: Maybe<Scalars['String']>;
  seo_hidden?: Maybe<Scalars['Boolean']>;
  seo_image?: Maybe<AssetInterface>;
  seo_title?: Maybe<Scalars['String']>;
  site: Site;
  slug: Scalars['String'];
  status: Scalars['String'];
  title: Scalars['String'];
  uri?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};


export type Entry_Pages_PageDateArgs = {
  format?: InputMaybe<Scalars['String']>;
};


export type Entry_Pages_PageLast_ModifiedArgs = {
  format?: InputMaybe<Scalars['String']>;
};

export type Entry_Posts_Post = EntryInterface & {
  __typename?: 'Entry_Posts_Post';
  allow_sharing_with_third_parties?: Maybe<Scalars['Boolean']>;
  allow_sharing_with_we_publish?: Maybe<Scalars['Boolean']>;
  author: User;
  blueprint?: Maybe<Scalars['String']>;
  categories?: Maybe<Array<Maybe<TermInterface>>>;
  collection: Collection;
  content?: Maybe<Array<Maybe<Sets_Content>>>;
  content_section?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['String']>;
  edit_url: Scalars['String'];
  format?: Maybe<TermInterface>;
  id: Scalars['ID'];
  last_modified?: Maybe<Scalars['String']>;
  liked_at?: Maybe<Scalars['String']>;
  locale: Scalars['String'];
  number_of_likes?: Maybe<Scalars['Int']>;
  parent?: Maybe<EntryInterface>;
  permalink?: Maybe<Scalars['String']>;
  private: Scalars['Boolean'];
  published: Scalars['Boolean'];
  sharing_with_third_parties_section?: Maybe<Scalars['String']>;
  site: Site;
  slug: Scalars['String'];
  status: Scalars['String'];
  tags?: Maybe<Array<Maybe<TermInterface>>>;
  text?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  unpublished_reason?: Maybe<LabeledValue>;
  uri?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  usage_on_social_media_section?: Maybe<Scalars['String']>;
  used_in_newsletter?: Maybe<Scalars['Boolean']>;
  used_on_facebook?: Maybe<Scalars['Boolean']>;
  used_on_instagram?: Maybe<Scalars['Boolean']>;
};


export type Entry_Posts_PostCreated_AtArgs = {
  format?: InputMaybe<Scalars['String']>;
};


export type Entry_Posts_PostDateArgs = {
  format?: InputMaybe<Scalars['String']>;
};


export type Entry_Posts_PostLast_ModifiedArgs = {
  format?: InputMaybe<Scalars['String']>;
};


export type Entry_Posts_PostLiked_AtArgs = {
  format?: InputMaybe<Scalars['String']>;
};

export type Entry_Posts_PostPagination = {
  __typename?: 'Entry_Posts_PostPagination';
  /** Current page of the cursor */
  current_page: Scalars['Int'];
  /** List of items on the current page */
  data?: Maybe<Array<Maybe<Entry_Posts_Post>>>;
  /** Number of the first item returned */
  from?: Maybe<Scalars['Int']>;
  /** Determines if cursor has more pages after the current page */
  has_more_pages: Scalars['Boolean'];
  /** The last page (number of pages) */
  last_page: Scalars['Int'];
  /** Number of items returned per page */
  per_page: Scalars['Int'];
  /** Number of the last item returned */
  to?: Maybe<Scalars['Int']>;
  /** Number of total items selected by the query */
  total: Scalars['Int'];
};

export type Entry_Team_TeamMember = EntryInterface & {
  __typename?: 'Entry_Team_TeamMember';
  author: User;
  biography?: Maybe<Scalars['String']>;
  blueprint?: Maybe<Scalars['String']>;
  collection: Collection;
  components_section?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['String']>;
  edit_url: Scalars['String'];
  facebook?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  image?: Maybe<AssetInterface>;
  instagram?: Maybe<Scalars['String']>;
  last_modified?: Maybe<Scalars['String']>;
  linkedin?: Maybe<Scalars['String']>;
  links_section?: Maybe<Scalars['String']>;
  locale: Scalars['String'];
  member_since: Scalars['String'];
  parent?: Maybe<EntryInterface>;
  permalink?: Maybe<Scalars['String']>;
  private: Scalars['Boolean'];
  published: Scalars['Boolean'];
  quote?: Maybe<Scalars['String']>;
  seo_description?: Maybe<Scalars['String']>;
  seo_hidden?: Maybe<Scalars['Boolean']>;
  seo_image?: Maybe<AssetInterface>;
  seo_title?: Maybe<Scalars['String']>;
  site: Site;
  slug: Scalars['String'];
  status: Scalars['String'];
  team_formats?: Maybe<Array<Maybe<TermInterface>>>;
  team_member_components?: Maybe<Array<Maybe<Sets_TeamMemberComponents>>>;
  title: Scalars['String'];
  twitter?: Maybe<Scalars['String']>;
  uri?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  website?: Maybe<Scalars['String']>;
};


export type Entry_Team_TeamMemberDateArgs = {
  format?: InputMaybe<Scalars['String']>;
};


export type Entry_Team_TeamMemberLast_ModifiedArgs = {
  format?: InputMaybe<Scalars['String']>;
};


export type Entry_Team_TeamMemberMember_SinceArgs = {
  format?: InputMaybe<Scalars['String']>;
};

export type Entry_Votings_ExternalVoting = EntryInterface & {
  __typename?: 'Entry_Votings_ExternalVoting';
  blueprint?: Maybe<Scalars['String']>;
  collection: Collection;
  date?: Maybe<Scalars['String']>;
  edit_url: Scalars['String'];
  id: Scalars['ID'];
  last_modified?: Maybe<Scalars['String']>;
  link?: Maybe<Scalars['String']>;
  locale: Scalars['String'];
  parent?: Maybe<EntryInterface>;
  permalink?: Maybe<Scalars['String']>;
  private: Scalars['Boolean'];
  published: Scalars['Boolean'];
  site: Site;
  slug: Scalars['String'];
  status: Scalars['String'];
  text?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  uri?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  window?: Maybe<DateRange>;
};


export type Entry_Votings_ExternalVotingDateArgs = {
  format?: InputMaybe<Scalars['String']>;
};


export type Entry_Votings_ExternalVotingLast_ModifiedArgs = {
  format?: InputMaybe<Scalars['String']>;
};

export type Entry_Votings_Voting = EntryInterface & {
  __typename?: 'Entry_Votings_Voting';
  blueprint?: Maybe<Scalars['String']>;
  collection: Collection;
  confirmation_cancelbutton_text?: Maybe<Scalars['String']>;
  confirmation_submitbutton_text?: Maybe<Scalars['String']>;
  confirmation_text?: Maybe<Scalars['String']>;
  confirmation_title?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['String']>;
  edit_url: Scalars['String'];
  formats?: Maybe<Array<Maybe<GridItem_Formats>>>;
  id: Scalars['ID'];
  last_modified?: Maybe<Scalars['String']>;
  locale: Scalars['String'];
  parent?: Maybe<EntryInterface>;
  permalink?: Maybe<Scalars['String']>;
  private: Scalars['Boolean'];
  published: Scalars['Boolean'];
  seo_description?: Maybe<Scalars['String']>;
  seo_hidden?: Maybe<Scalars['Boolean']>;
  seo_image?: Maybe<AssetInterface>;
  seo_title?: Maybe<Scalars['String']>;
  site: Site;
  slug: Scalars['String'];
  status: Scalars['String'];
  thankyou_text?: Maybe<Scalars['String']>;
  thankyou_title?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  uri?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  welcome_startbutton_text?: Maybe<Scalars['String']>;
  welcome_subtitle?: Maybe<Scalars['String']>;
  welcome_text?: Maybe<Scalars['String']>;
  welcome_title?: Maybe<Scalars['String']>;
};


export type Entry_Votings_VotingDateArgs = {
  format?: InputMaybe<Scalars['String']>;
};


export type Entry_Votings_VotingLast_ModifiedArgs = {
  format?: InputMaybe<Scalars['String']>;
};

export type Field = {
  __typename?: 'Field';
  config?: Maybe<Scalars['Array']>;
  display: Scalars['String'];
  handle: Scalars['String'];
  instructions?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  width?: Maybe<Scalars['Int']>;
};

export type Form = {
  __typename?: 'Form';
  fields?: Maybe<Array<Maybe<Field>>>;
  handle: Scalars['String'];
  honeypot?: Maybe<Scalars['String']>;
  rules?: Maybe<Scalars['Array']>;
  title: Scalars['String'];
};

export type GlobalSetInterface = {
  handle: Scalars['String'];
  site: Site;
  title: Scalars['String'];
};

export type GlobalSet_DefaultTeaser = GlobalSetInterface & {
  __typename?: 'GlobalSet_DefaultTeaser';
  handle: Scalars['String'];
  link?: Maybe<Scalars['String']>;
  link_text?: Maybe<Scalars['String']>;
  site: Site;
  text?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type GlobalSet_Emails = GlobalSetInterface & {
  __typename?: 'GlobalSet_Emails';
  activate_artist_account_section?: Maybe<Scalars['String']>;
  activate_artist_account_subject: Scalars['String'];
  activate_artist_account_text: Scalars['String'];
  activate_member_account_section?: Maybe<Scalars['String']>;
  activate_member_account_subject: Scalars['String'];
  activate_member_account_text: Scalars['String'];
  activate_patron_account_section?: Maybe<Scalars['String']>;
  activate_patron_account_subject: Scalars['String'];
  activate_patron_account_text: Scalars['String'];
  handle: Scalars['String'];
  site: Site;
  title: Scalars['String'];
};

export type GlobalSet_Footer = GlobalSetInterface & {
  __typename?: 'GlobalSet_Footer';
  copyright_text?: Maybe<Scalars['String']>;
  facebook?: Maybe<Scalars['String']>;
  handle: Scalars['String'];
  instagram?: Maybe<Scalars['String']>;
  linkedin?: Maybe<Scalars['String']>;
  newsletter_button_text?: Maybe<Scalars['String']>;
  newsletter_section?: Maybe<Scalars['String']>;
  newsletter_thank_you_text?: Maybe<Scalars['String']>;
  newsletter_title?: Maybe<Scalars['String']>;
  site: Site;
  sm_links_section?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  twitter?: Maybe<Scalars['String']>;
};

export type GlobalSet_LoginSectionCoupons = GlobalSetInterface & {
  __typename?: 'GlobalSet_LoginSectionCoupons';
  handle: Scalars['String'];
  personal_coupon_image?: Maybe<AssetInterface>;
  personal_coupon_section?: Maybe<Scalars['String']>;
  personal_coupon_text?: Maybe<Scalars['String']>;
  personal_coupon_title?: Maybe<Scalars['String']>;
  section_title: Scalars['String'];
  site: Site;
  text?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type GlobalSet_LoginSectionCreatePost = GlobalSetInterface & {
  __typename?: 'GlobalSet_LoginSectionCreatePost';
  allow_sharing_with_third_parties_description?: Maybe<Scalars['String']>;
  allow_sharing_with_we_publish_description?: Maybe<Scalars['String']>;
  handle: Scalars['String'];
  section_title: Scalars['String'];
  sharing_with_third_parties_section?: Maybe<Scalars['String']>;
  sharing_with_we_publish_section?: Maybe<Scalars['String']>;
  show_allow_sharing_with_third_parties_field?: Maybe<Scalars['Boolean']>;
  show_allow_sharing_with_we_publish_field?: Maybe<Scalars['Boolean']>;
  site: Site;
  text?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type GlobalSet_LoginSectionDownloads = GlobalSetInterface & {
  __typename?: 'GlobalSet_LoginSectionDownloads';
  handle: Scalars['String'];
  section_title: Scalars['String'];
  site: Site;
  text?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type GlobalSet_LoginSectionLogin = GlobalSetInterface & {
  __typename?: 'GlobalSet_LoginSectionLogin';
  handle: Scalars['String'];
  login_button_text?: Maybe<Scalars['String']>;
  login_title: Scalars['String'];
  register_text?: Maybe<Array<Maybe<Sets_RegisterText>>>;
  register_title: Scalars['String'];
  site: Site;
  title: Scalars['String'];
};

export type GlobalSet_LoginSectionLotteries = GlobalSetInterface & {
  __typename?: 'GlobalSet_LoginSectionLotteries';
  handle: Scalars['String'];
  section_title: Scalars['String'];
  site: Site;
  text?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type GlobalSet_LoginSectionMembership = GlobalSetInterface & {
  __typename?: 'GlobalSet_LoginSectionMembership';
  handle: Scalars['String'];
  section_title: Scalars['String'];
  site: Site;
  text?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type GlobalSet_LoginSectionNewsletter = GlobalSetInterface & {
  __typename?: 'GlobalSet_LoginSectionNewsletter';
  handle: Scalars['String'];
  section_title: Scalars['String'];
  site: Site;
  text?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type GlobalSet_LoginSectionProfile = GlobalSetInterface & {
  __typename?: 'GlobalSet_LoginSectionProfile';
  current_lottery_background_color?: Maybe<LabeledValue>;
  current_lottery_link_text?: Maybe<Scalars['String']>;
  current_lottery_section?: Maybe<Scalars['String']>;
  current_lottery_title?: Maybe<Scalars['String']>;
  current_voting_background_color?: Maybe<LabeledValue>;
  current_voting_link_text?: Maybe<Scalars['String']>;
  current_voting_section?: Maybe<Scalars['String']>;
  current_voting_title?: Maybe<Scalars['String']>;
  handle: Scalars['String'];
  section_title: Scalars['String'];
  site: Site;
  title: Scalars['String'];
};

export type GlobalSet_LoginSectionVotings = GlobalSetInterface & {
  __typename?: 'GlobalSet_LoginSectionVotings';
  handle: Scalars['String'];
  section_title: Scalars['String'];
  site: Site;
  text?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type GlobalSet_Shopify = GlobalSetInterface & {
  __typename?: 'GlobalSet_Shopify';
  base_url?: Maybe<Scalars['String']>;
  handle: Scalars['String'];
  site: Site;
  title: Scalars['String'];
};

export type GridItem_Formats = {
  __typename?: 'GridItem_Formats';
  format: TermInterface;
  number_of_spots: Scalars['Int'];
};

export type GridItem_History = {
  __typename?: 'GridItem_History';
  amount?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  processedAt?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['String']>;
  purchaseId?: Maybe<Scalars['String']>;
  validity?: Maybe<DateRange>;
};


export type GridItem_HistoryCreatedAtArgs = {
  format?: InputMaybe<Scalars['String']>;
};


export type GridItem_HistoryProcessedAtArgs = {
  format?: InputMaybe<Scalars['String']>;
};

export type LabeledValue = {
  __typename?: 'LabeledValue';
  label?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  createLike?: Maybe<Entry_Posts_Post>;
  createPost: Entry_Posts_Post;
  deleteLike?: Maybe<Entry_Posts_Post>;
  parseMarkdown?: Maybe<Scalars['String']>;
  subscribeToNewsletter?: Maybe<NewsletterSubscriptionResultType>;
  subscribeToNewsletterList?: Maybe<NewsletterSubscriptionResultType>;
  unsubscribeFromNewsletterList?: Maybe<NewsletterSubscriptionResultType>;
  updateUser: User;
  updateUserPassword: User;
  uploadFile: Asset_UploadedAssets;
};


export type MutationCreateLikeArgs = {
  entry_id: Scalars['ID'];
};


export type MutationCreatePostArgs = {
  allow_sharing_with_third_parties?: InputMaybe<Scalars['Boolean']>;
  allow_sharing_with_we_publish?: InputMaybe<Scalars['Boolean']>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  format?: InputMaybe<Scalars['String']>;
  media?: InputMaybe<Array<InputMaybe<UploadedPostMediaWrapper>>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  text?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};


export type MutationDeleteLikeArgs = {
  entry_id: Scalars['ID'];
};


export type MutationParseMarkdownArgs = {
  text?: InputMaybe<Scalars['String']>;
};


export type MutationSubscribeToNewsletterArgs = {
  email: Scalars['String'];
  name: Scalars['String'];
};


export type MutationSubscribeToNewsletterListArgs = {
  id: Scalars['String'];
};


export type MutationUnsubscribeFromNewsletterListArgs = {
  id: Scalars['String'];
};


export type MutationUpdateUserArgs = {
  city?: InputMaybe<Scalars['String']>;
  firstname?: InputMaybe<Scalars['String']>;
  lastname?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  salutation?: InputMaybe<Scalars['String']>;
  street?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateUserPasswordArgs = {
  current_password?: InputMaybe<Scalars['String']>;
  new_password?: InputMaybe<Scalars['String']>;
  new_password_confirmation?: InputMaybe<Scalars['String']>;
  username?: InputMaybe<Scalars['String']>;
};


export type MutationUploadFileArgs = {
  file?: InputMaybe<Scalars['Upload']>;
};

export type NavBasicPage_FooterMainNavigation = NavPage_FooterMainNavigation & PageInterface & {
  __typename?: 'NavBasicPage_FooterMainNavigation';
  bugfix?: Maybe<Scalars['String']>;
  entry_id?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  permalink?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type NavBasicPage_FooterSecondaryNavigation = NavPage_FooterSecondaryNavigation & PageInterface & {
  __typename?: 'NavBasicPage_FooterSecondaryNavigation';
  bugfix?: Maybe<Scalars['String']>;
  entry_id?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  permalink?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type NavBasicPage_MainNavigation = NavPage_MainNavigation & PageInterface & {
  __typename?: 'NavBasicPage_MainNavigation';
  entry_id?: Maybe<Scalars['ID']>;
  highlight?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  permalink?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type NavEntryPage_FooterMainNavigation_Pages_Contact = EntryInterface & NavPage_FooterMainNavigation & PageInterface & {
  __typename?: 'NavEntryPage_FooterMainNavigation_Pages_Contact';
  background_color: LabeledValue;
  blueprint?: Maybe<Scalars['String']>;
  bugfix?: Maybe<Scalars['String']>;
  button_text?: Maybe<Scalars['String']>;
  collection: Collection;
  components?: Maybe<Array<Maybe<Sets_Components>>>;
  components_section?: Maybe<Scalars['String']>;
  confirm_text?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['String']>;
  edit_url: Scalars['String'];
  entry_id?: Maybe<Scalars['ID']>;
  error_text?: Maybe<Scalars['String']>;
  form?: Maybe<Form>;
  id: Scalars['ID'];
  image?: Maybe<AssetInterface>;
  intro_text?: Maybe<Scalars['String']>;
  last_modified?: Maybe<Scalars['String']>;
  locale: Scalars['String'];
  parent?: Maybe<EntryInterface>;
  permalink?: Maybe<Scalars['String']>;
  private: Scalars['Boolean'];
  published: Scalars['Boolean'];
  seo_description?: Maybe<Scalars['String']>;
  seo_hidden?: Maybe<Scalars['Boolean']>;
  seo_image?: Maybe<AssetInterface>;
  seo_title?: Maybe<Scalars['String']>;
  site: Site;
  slug: Scalars['String'];
  status: Scalars['String'];
  thank_you_text?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  uri?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};


export type NavEntryPage_FooterMainNavigation_Pages_ContactDateArgs = {
  format?: InputMaybe<Scalars['String']>;
};


export type NavEntryPage_FooterMainNavigation_Pages_ContactLast_ModifiedArgs = {
  format?: InputMaybe<Scalars['String']>;
};

export type NavEntryPage_FooterMainNavigation_Pages_News = EntryInterface & NavPage_FooterMainNavigation & PageInterface & {
  __typename?: 'NavEntryPage_FooterMainNavigation_Pages_News';
  aside_components?: Maybe<Array<Maybe<Sets_AsideComponents>>>;
  blueprint?: Maybe<Scalars['String']>;
  bugfix?: Maybe<Scalars['String']>;
  collection: Collection;
  date?: Maybe<Scalars['String']>;
  edit_url: Scalars['String'];
  entry_id?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  insert_components?: Maybe<Array<Maybe<Sets_InsertComponents>>>;
  last_modified?: Maybe<Scalars['String']>;
  locale: Scalars['String'];
  parent?: Maybe<EntryInterface>;
  permalink?: Maybe<Scalars['String']>;
  private: Scalars['Boolean'];
  published: Scalars['Boolean'];
  seo_description?: Maybe<Scalars['String']>;
  seo_hidden?: Maybe<Scalars['Boolean']>;
  seo_image?: Maybe<AssetInterface>;
  seo_title?: Maybe<Scalars['String']>;
  site: Site;
  slug: Scalars['String'];
  status: Scalars['String'];
  title: Scalars['String'];
  title_link?: Maybe<Scalars['String']>;
  title_link_text?: Maybe<Scalars['String']>;
  uri?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};


export type NavEntryPage_FooterMainNavigation_Pages_NewsDateArgs = {
  format?: InputMaybe<Scalars['String']>;
};


export type NavEntryPage_FooterMainNavigation_Pages_NewsLast_ModifiedArgs = {
  format?: InputMaybe<Scalars['String']>;
};

export type NavEntryPage_FooterMainNavigation_Pages_Page = EntryInterface & NavPage_FooterMainNavigation & PageInterface & {
  __typename?: 'NavEntryPage_FooterMainNavigation_Pages_Page';
  background_color: LabeledValue;
  blueprint?: Maybe<Scalars['String']>;
  bugfix?: Maybe<Scalars['String']>;
  collection: Collection;
  components?: Maybe<Array<Maybe<Sets_Components>>>;
  components_section?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['String']>;
  edit_url: Scalars['String'];
  entry_id?: Maybe<Scalars['ID']>;
  hero_image?: Maybe<AssetInterface>;
  hero_link?: Maybe<Scalars['String']>;
  hero_link_text?: Maybe<Scalars['String']>;
  hero_section?: Maybe<Scalars['String']>;
  hero_text?: Maybe<Array<Maybe<Sets_HeroText>>>;
  hero_type?: Maybe<LabeledValue>;
  id: Scalars['ID'];
  last_modified?: Maybe<Scalars['String']>;
  locale: Scalars['String'];
  parent?: Maybe<EntryInterface>;
  permalink?: Maybe<Scalars['String']>;
  private: Scalars['Boolean'];
  published: Scalars['Boolean'];
  seo_description?: Maybe<Scalars['String']>;
  seo_hidden?: Maybe<Scalars['Boolean']>;
  seo_image?: Maybe<AssetInterface>;
  seo_title?: Maybe<Scalars['String']>;
  site: Site;
  slug: Scalars['String'];
  status: Scalars['String'];
  title: Scalars['String'];
  uri?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};


export type NavEntryPage_FooterMainNavigation_Pages_PageDateArgs = {
  format?: InputMaybe<Scalars['String']>;
};


export type NavEntryPage_FooterMainNavigation_Pages_PageLast_ModifiedArgs = {
  format?: InputMaybe<Scalars['String']>;
};

export type NavEntryPage_FooterSecondaryNavigation_Pages_Contact = EntryInterface & NavPage_FooterSecondaryNavigation & PageInterface & {
  __typename?: 'NavEntryPage_FooterSecondaryNavigation_Pages_Contact';
  background_color: LabeledValue;
  blueprint?: Maybe<Scalars['String']>;
  bugfix?: Maybe<Scalars['String']>;
  button_text?: Maybe<Scalars['String']>;
  collection: Collection;
  components?: Maybe<Array<Maybe<Sets_Components>>>;
  components_section?: Maybe<Scalars['String']>;
  confirm_text?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['String']>;
  edit_url: Scalars['String'];
  entry_id?: Maybe<Scalars['ID']>;
  error_text?: Maybe<Scalars['String']>;
  form?: Maybe<Form>;
  id: Scalars['ID'];
  image?: Maybe<AssetInterface>;
  intro_text?: Maybe<Scalars['String']>;
  last_modified?: Maybe<Scalars['String']>;
  locale: Scalars['String'];
  parent?: Maybe<EntryInterface>;
  permalink?: Maybe<Scalars['String']>;
  private: Scalars['Boolean'];
  published: Scalars['Boolean'];
  seo_description?: Maybe<Scalars['String']>;
  seo_hidden?: Maybe<Scalars['Boolean']>;
  seo_image?: Maybe<AssetInterface>;
  seo_title?: Maybe<Scalars['String']>;
  site: Site;
  slug: Scalars['String'];
  status: Scalars['String'];
  thank_you_text?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  uri?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};


export type NavEntryPage_FooterSecondaryNavigation_Pages_ContactDateArgs = {
  format?: InputMaybe<Scalars['String']>;
};


export type NavEntryPage_FooterSecondaryNavigation_Pages_ContactLast_ModifiedArgs = {
  format?: InputMaybe<Scalars['String']>;
};

export type NavEntryPage_FooterSecondaryNavigation_Pages_News = EntryInterface & NavPage_FooterSecondaryNavigation & PageInterface & {
  __typename?: 'NavEntryPage_FooterSecondaryNavigation_Pages_News';
  aside_components?: Maybe<Array<Maybe<Sets_AsideComponents>>>;
  blueprint?: Maybe<Scalars['String']>;
  bugfix?: Maybe<Scalars['String']>;
  collection: Collection;
  date?: Maybe<Scalars['String']>;
  edit_url: Scalars['String'];
  entry_id?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  insert_components?: Maybe<Array<Maybe<Sets_InsertComponents>>>;
  last_modified?: Maybe<Scalars['String']>;
  locale: Scalars['String'];
  parent?: Maybe<EntryInterface>;
  permalink?: Maybe<Scalars['String']>;
  private: Scalars['Boolean'];
  published: Scalars['Boolean'];
  seo_description?: Maybe<Scalars['String']>;
  seo_hidden?: Maybe<Scalars['Boolean']>;
  seo_image?: Maybe<AssetInterface>;
  seo_title?: Maybe<Scalars['String']>;
  site: Site;
  slug: Scalars['String'];
  status: Scalars['String'];
  title: Scalars['String'];
  title_link?: Maybe<Scalars['String']>;
  title_link_text?: Maybe<Scalars['String']>;
  uri?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};


export type NavEntryPage_FooterSecondaryNavigation_Pages_NewsDateArgs = {
  format?: InputMaybe<Scalars['String']>;
};


export type NavEntryPage_FooterSecondaryNavigation_Pages_NewsLast_ModifiedArgs = {
  format?: InputMaybe<Scalars['String']>;
};

export type NavEntryPage_FooterSecondaryNavigation_Pages_Page = EntryInterface & NavPage_FooterSecondaryNavigation & PageInterface & {
  __typename?: 'NavEntryPage_FooterSecondaryNavigation_Pages_Page';
  background_color: LabeledValue;
  blueprint?: Maybe<Scalars['String']>;
  bugfix?: Maybe<Scalars['String']>;
  collection: Collection;
  components?: Maybe<Array<Maybe<Sets_Components>>>;
  components_section?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['String']>;
  edit_url: Scalars['String'];
  entry_id?: Maybe<Scalars['ID']>;
  hero_image?: Maybe<AssetInterface>;
  hero_link?: Maybe<Scalars['String']>;
  hero_link_text?: Maybe<Scalars['String']>;
  hero_section?: Maybe<Scalars['String']>;
  hero_text?: Maybe<Array<Maybe<Sets_HeroText>>>;
  hero_type?: Maybe<LabeledValue>;
  id: Scalars['ID'];
  last_modified?: Maybe<Scalars['String']>;
  locale: Scalars['String'];
  parent?: Maybe<EntryInterface>;
  permalink?: Maybe<Scalars['String']>;
  private: Scalars['Boolean'];
  published: Scalars['Boolean'];
  seo_description?: Maybe<Scalars['String']>;
  seo_hidden?: Maybe<Scalars['Boolean']>;
  seo_image?: Maybe<AssetInterface>;
  seo_title?: Maybe<Scalars['String']>;
  site: Site;
  slug: Scalars['String'];
  status: Scalars['String'];
  title: Scalars['String'];
  uri?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};


export type NavEntryPage_FooterSecondaryNavigation_Pages_PageDateArgs = {
  format?: InputMaybe<Scalars['String']>;
};


export type NavEntryPage_FooterSecondaryNavigation_Pages_PageLast_ModifiedArgs = {
  format?: InputMaybe<Scalars['String']>;
};

export type NavEntryPage_MainNavigation_Pages_Contact = EntryInterface & NavPage_MainNavigation & PageInterface & {
  __typename?: 'NavEntryPage_MainNavigation_Pages_Contact';
  background_color: LabeledValue;
  blueprint?: Maybe<Scalars['String']>;
  button_text?: Maybe<Scalars['String']>;
  collection: Collection;
  components?: Maybe<Array<Maybe<Sets_Components>>>;
  components_section?: Maybe<Scalars['String']>;
  confirm_text?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['String']>;
  edit_url: Scalars['String'];
  entry_id?: Maybe<Scalars['ID']>;
  error_text?: Maybe<Scalars['String']>;
  form?: Maybe<Form>;
  highlight?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  image?: Maybe<AssetInterface>;
  intro_text?: Maybe<Scalars['String']>;
  last_modified?: Maybe<Scalars['String']>;
  locale: Scalars['String'];
  parent?: Maybe<EntryInterface>;
  permalink?: Maybe<Scalars['String']>;
  private: Scalars['Boolean'];
  published: Scalars['Boolean'];
  seo_description?: Maybe<Scalars['String']>;
  seo_hidden?: Maybe<Scalars['Boolean']>;
  seo_image?: Maybe<AssetInterface>;
  seo_title?: Maybe<Scalars['String']>;
  site: Site;
  slug: Scalars['String'];
  status: Scalars['String'];
  thank_you_text?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  uri?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};


export type NavEntryPage_MainNavigation_Pages_ContactDateArgs = {
  format?: InputMaybe<Scalars['String']>;
};


export type NavEntryPage_MainNavigation_Pages_ContactLast_ModifiedArgs = {
  format?: InputMaybe<Scalars['String']>;
};

export type NavEntryPage_MainNavigation_Pages_News = EntryInterface & NavPage_MainNavigation & PageInterface & {
  __typename?: 'NavEntryPage_MainNavigation_Pages_News';
  aside_components?: Maybe<Array<Maybe<Sets_AsideComponents>>>;
  blueprint?: Maybe<Scalars['String']>;
  collection: Collection;
  date?: Maybe<Scalars['String']>;
  edit_url: Scalars['String'];
  entry_id?: Maybe<Scalars['ID']>;
  highlight?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  insert_components?: Maybe<Array<Maybe<Sets_InsertComponents>>>;
  last_modified?: Maybe<Scalars['String']>;
  locale: Scalars['String'];
  parent?: Maybe<EntryInterface>;
  permalink?: Maybe<Scalars['String']>;
  private: Scalars['Boolean'];
  published: Scalars['Boolean'];
  seo_description?: Maybe<Scalars['String']>;
  seo_hidden?: Maybe<Scalars['Boolean']>;
  seo_image?: Maybe<AssetInterface>;
  seo_title?: Maybe<Scalars['String']>;
  site: Site;
  slug: Scalars['String'];
  status: Scalars['String'];
  title: Scalars['String'];
  title_link?: Maybe<Scalars['String']>;
  title_link_text?: Maybe<Scalars['String']>;
  uri?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};


export type NavEntryPage_MainNavigation_Pages_NewsDateArgs = {
  format?: InputMaybe<Scalars['String']>;
};


export type NavEntryPage_MainNavigation_Pages_NewsLast_ModifiedArgs = {
  format?: InputMaybe<Scalars['String']>;
};

export type NavEntryPage_MainNavigation_Pages_Page = EntryInterface & NavPage_MainNavigation & PageInterface & {
  __typename?: 'NavEntryPage_MainNavigation_Pages_Page';
  background_color: LabeledValue;
  blueprint?: Maybe<Scalars['String']>;
  collection: Collection;
  components?: Maybe<Array<Maybe<Sets_Components>>>;
  components_section?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['String']>;
  edit_url: Scalars['String'];
  entry_id?: Maybe<Scalars['ID']>;
  hero_image?: Maybe<AssetInterface>;
  hero_link?: Maybe<Scalars['String']>;
  hero_link_text?: Maybe<Scalars['String']>;
  hero_section?: Maybe<Scalars['String']>;
  hero_text?: Maybe<Array<Maybe<Sets_HeroText>>>;
  hero_type?: Maybe<LabeledValue>;
  highlight?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  last_modified?: Maybe<Scalars['String']>;
  locale: Scalars['String'];
  parent?: Maybe<EntryInterface>;
  permalink?: Maybe<Scalars['String']>;
  private: Scalars['Boolean'];
  published: Scalars['Boolean'];
  seo_description?: Maybe<Scalars['String']>;
  seo_hidden?: Maybe<Scalars['Boolean']>;
  seo_image?: Maybe<AssetInterface>;
  seo_title?: Maybe<Scalars['String']>;
  site: Site;
  slug: Scalars['String'];
  status: Scalars['String'];
  title: Scalars['String'];
  uri?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};


export type NavEntryPage_MainNavigation_Pages_PageDateArgs = {
  format?: InputMaybe<Scalars['String']>;
};


export type NavEntryPage_MainNavigation_Pages_PageLast_ModifiedArgs = {
  format?: InputMaybe<Scalars['String']>;
};

export type NavPage_FooterMainNavigation = {
  bugfix?: Maybe<Scalars['String']>;
};

export type NavPage_FooterSecondaryNavigation = {
  bugfix?: Maybe<Scalars['String']>;
};

export type NavPage_MainNavigation = {
  highlight?: Maybe<Scalars['Boolean']>;
};

export type NavTreeBranch = {
  __typename?: 'NavTreeBranch';
  children?: Maybe<Array<Maybe<NavTreeBranch>>>;
  depth: Scalars['Int'];
  page?: Maybe<PageInterface>;
};

export type Navigation = {
  __typename?: 'Navigation';
  expects_root: Scalars['Boolean'];
  handle: Scalars['String'];
  max_depth?: Maybe<Scalars['Int']>;
  title: Scalars['String'];
  tree?: Maybe<Array<Maybe<NavTreeBranch>>>;
};


export type NavigationTreeArgs = {
  site?: InputMaybe<Scalars['String']>;
};

export type NewsletterList = {
  __typename?: 'NewsletterList';
  id: Scalars['String'];
  name: Scalars['String'];
  subscribed: Scalars['Boolean'];
};

export type NewsletterSubscriptionResultType = {
  __typename?: 'NewsletterSubscriptionResultType';
  message?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type PageInterface = {
  entry_id?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  permalink?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type Query = {
  __typename?: 'Query';
  asset?: Maybe<AssetInterface>;
  assetContainer?: Maybe<AssetContainer>;
  assetContainers?: Maybe<Array<Maybe<AssetContainer>>>;
  assets?: Maybe<AssetInterfacePagination>;
  collection?: Maybe<Collection>;
  collections?: Maybe<Array<Maybe<Collection>>>;
  entries?: Maybe<EntryInterfacePagination>;
  entry?: Maybe<EntryInterface>;
  filteredPosts?: Maybe<Entry_Posts_PostPagination>;
  globalSet?: Maybe<GlobalSetInterface>;
  globalSets?: Maybe<Array<Maybe<GlobalSetInterface>>>;
  me?: Maybe<User>;
  nav?: Maybe<Navigation>;
  navs?: Maybe<Array<Maybe<Navigation>>>;
  newsletterLists?: Maybe<Array<Maybe<NewsletterList>>>;
  ping?: Maybe<Scalars['String']>;
  similarPosts?: Maybe<Entry_Posts_PostPagination>;
  sitemap?: Maybe<Array<Maybe<SitemapEntry>>>;
  taxonomies?: Maybe<Array<Maybe<Taxonomy>>>;
  taxonomy?: Maybe<Taxonomy>;
  term?: Maybe<TermInterface>;
  terms?: Maybe<TermInterfacePagination>;
  user?: Maybe<User>;
  users?: Maybe<UserPagination>;
};


export type QueryAssetArgs = {
  container?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  path?: InputMaybe<Scalars['String']>;
};


export type QueryAssetContainerArgs = {
  handle?: InputMaybe<Scalars['String']>;
};


export type QueryAssetsArgs = {
  container: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryCollectionArgs = {
  handle?: InputMaybe<Scalars['String']>;
};


export type QueryEntriesArgs = {
  collection?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  filter?: InputMaybe<Scalars['JsonArgument']>;
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryEntryArgs = {
  collection?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<Scalars['JsonArgument']>;
  id?: InputMaybe<Scalars['String']>;
  site?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  uri?: InputMaybe<Scalars['String']>;
};


export type QueryFilteredPostsArgs = {
  filter?: InputMaybe<Scalars['JsonArgument']>;
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryGlobalSetArgs = {
  handle?: InputMaybe<Scalars['String']>;
  site?: InputMaybe<Scalars['String']>;
};


export type QueryNavArgs = {
  handle?: InputMaybe<Scalars['String']>;
};


export type QuerySimilarPostsArgs = {
  filter?: InputMaybe<Scalars['JsonArgument']>;
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  post_id: Scalars['ID'];
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryTaxonomyArgs = {
  handle?: InputMaybe<Scalars['String']>;
};


export type QueryTermArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryTermsArgs = {
  filter?: InputMaybe<Scalars['JsonArgument']>;
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  taxonomy?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryUserArgs = {
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
};


export type QueryUsersArgs = {
  filter?: InputMaybe<Scalars['JsonArgument']>;
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Role = {
  __typename?: 'Role';
  handle?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type Set_AsideComponents_AsideTeaser = {
  __typename?: 'Set_AsideComponents_AsideTeaser';
  background_color?: Maybe<LabeledValue>;
  image?: Maybe<AssetInterface>;
  link?: Maybe<Scalars['String']>;
  link_text?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export type Set_AsideComponents_Banner = {
  __typename?: 'Set_AsideComponents_Banner';
  background_color?: Maybe<LabeledValue>;
  button_link?: Maybe<Scalars['String']>;
  button_text?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export type Set_AsideComponents_Newsletter = {
  __typename?: 'Set_AsideComponents_Newsletter';
  button_text?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  thank_you_text?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export type Set_AsideComponents_Post = {
  __typename?: 'Set_AsideComponents_Post';
  post?: Maybe<EntryInterface>;
  title?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export type Set_Components_Events = {
  __typename?: 'Set_Components_Events';
  background_color: LabeledValue;
  type: Scalars['String'];
};

export type Set_Components_ImageGallery = {
  __typename?: 'Set_Components_ImageGallery';
  background_color: LabeledValue;
  images?: Maybe<Array<Maybe<AssetInterface>>>;
  type: Scalars['String'];
};

export type Set_Components_ImageWithText = {
  __typename?: 'Set_Components_ImageWithText';
  background_color: LabeledValue;
  button_link?: Maybe<Scalars['String']>;
  button_text?: Maybe<Scalars['String']>;
  image?: Maybe<AssetInterface>;
  image_position?: Maybe<LabeledValue>;
  text?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export type Set_Components_Team = {
  __typename?: 'Set_Components_Team';
  background_color: LabeledValue;
  type: Scalars['String'];
};

export type Set_Components_Teaser = {
  __typename?: 'Set_Components_Teaser';
  link?: Maybe<Scalars['String']>;
  link_text?: Maybe<Scalars['String']>;
  override_default_component?: Maybe<Scalars['Boolean']>;
  text?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export type Set_Components_ThreeIconCards = {
  __typename?: 'Set_Components_ThreeIconCards';
  background_color: LabeledValue;
  icon_cards?: Maybe<Array<Maybe<Sets_IconCards>>>;
  type: Scalars['String'];
};

export type Set_Components_TitleWithText = {
  __typename?: 'Set_Components_TitleWithText';
  background_color: LabeledValue;
  subtitle?: Maybe<Scalars['String']>;
  text_components?: Maybe<Array<Maybe<Sets_TextComponents>>>;
  text_width?: Maybe<LabeledValue>;
  title?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export type Set_Content_Image = {
  __typename?: 'Set_Content_Image';
  image?: Maybe<AssetInterface>;
  logo_color: LabeledValue;
  logo_position: LabeledValue;
  type: Scalars['String'];
};

export type Set_Content_Text = {
  __typename?: 'Set_Content_Text';
  background_color: LabeledValue;
  text: Scalars['String'];
  type: Scalars['String'];
};

export type Set_Content_Video = {
  __typename?: 'Set_Content_Video';
  original_video?: Maybe<AssetInterface>;
  type: Scalars['String'];
  video?: Maybe<Scalars['String']>;
};

export type Set_HeroText_Newsletter = {
  __typename?: 'Set_HeroText_Newsletter';
  button_text?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  thank_you_text?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export type Set_IconCards_IconWithTextSection = {
  __typename?: 'Set_IconCards_IconWithTextSection';
  background_color: LabeledValue;
  icon?: Maybe<AssetInterface>;
  icon_hover?: Maybe<AssetInterface>;
  icon_text?: Maybe<Scalars['String']>;
  subtitle?: Maybe<Scalars['String']>;
  text_components?: Maybe<Array<Maybe<Sets_TextComponents>>>;
  text_section?: Maybe<Scalars['String']>;
  text_width?: Maybe<LabeledValue>;
  title?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export type Set_InsertComponents_Banner = {
  __typename?: 'Set_InsertComponents_Banner';
  background_color?: Maybe<LabeledValue>;
  button_link?: Maybe<Scalars['String']>;
  button_text?: Maybe<Scalars['String']>;
  posts_before_insert?: Maybe<Scalars['Int']>;
  text?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export type Set_InsertComponents_BannerWithImage = {
  __typename?: 'Set_InsertComponents_BannerWithImage';
  button_link?: Maybe<Scalars['String']>;
  button_text?: Maybe<Scalars['String']>;
  image?: Maybe<AssetInterface>;
  posts_before_insert?: Maybe<Scalars['Int']>;
  text?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export type Set_InsertComponents_Newsletter = {
  __typename?: 'Set_InsertComponents_Newsletter';
  button_text?: Maybe<Scalars['String']>;
  posts_before_insert?: Maybe<Scalars['Int']>;
  text?: Maybe<Scalars['String']>;
  thank_you_text?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export type Set_RegisterText_Button = {
  __typename?: 'Set_RegisterText_Button';
  level?: Maybe<LabeledValue>;
  link?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export type Set_RegisterText_Image = {
  __typename?: 'Set_RegisterText_Image';
  image?: Maybe<AssetInterface>;
  type: Scalars['String'];
};

export type Set_TeamMemberComponents_ImageGallery = {
  __typename?: 'Set_TeamMemberComponents_ImageGallery';
  background_color: LabeledValue;
  images?: Maybe<Array<Maybe<AssetInterface>>>;
  type: Scalars['String'];
};

export type Set_TeamMemberComponents_ImageWithText = {
  __typename?: 'Set_TeamMemberComponents_ImageWithText';
  background_color: LabeledValue;
  button_link?: Maybe<Scalars['String']>;
  button_text?: Maybe<Scalars['String']>;
  image?: Maybe<AssetInterface>;
  image_position?: Maybe<LabeledValue>;
  text?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export type Set_TeamMemberComponents_Posts = {
  __typename?: 'Set_TeamMemberComponents_Posts';
  background_color: LabeledValue;
  type: Scalars['String'];
};

export type Set_TeamMemberComponents_Teaser = {
  __typename?: 'Set_TeamMemberComponents_Teaser';
  link?: Maybe<Scalars['String']>;
  link_text?: Maybe<Scalars['String']>;
  override_default_component?: Maybe<Scalars['Boolean']>;
  text?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export type Set_TeamMemberComponents_TitleWithText = {
  __typename?: 'Set_TeamMemberComponents_TitleWithText';
  background_color: LabeledValue;
  subtitle?: Maybe<Scalars['String']>;
  text_components?: Maybe<Array<Maybe<Sets_TextComponents>>>;
  text_width?: Maybe<LabeledValue>;
  title?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export type Set_TextComponents_Button = {
  __typename?: 'Set_TextComponents_Button';
  level?: Maybe<LabeledValue>;
  link?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export type Set_TextComponents_Image = {
  __typename?: 'Set_TextComponents_Image';
  image?: Maybe<AssetInterface>;
  type: Scalars['String'];
};

export type Sets_AllowSharingWithThirdPartiesDescription = BardText;

export type Sets_AllowSharingWithWePublishDescription = BardText;

export type Sets_AsideComponents = Set_AsideComponents_AsideTeaser | Set_AsideComponents_Banner | Set_AsideComponents_Newsletter | Set_AsideComponents_Post;

export type Sets_Biography = BardText;

export type Sets_Components = Set_Components_Events | Set_Components_ImageGallery | Set_Components_ImageWithText | Set_Components_Team | Set_Components_Teaser | Set_Components_ThreeIconCards | Set_Components_TitleWithText;

export type Sets_ConfirmText = BardText;

export type Sets_ConfirmationText = BardText;

export type Sets_Content = Set_Content_Image | Set_Content_Text | Set_Content_Video;

export type Sets_Description = BardText;

export type Sets_ErrorText = BardText;

export type Sets_HeroText = BardText | Set_HeroText_Newsletter;

export type Sets_IconCards = Set_IconCards_IconWithTextSection;

export type Sets_InsertComponents = Set_InsertComponents_Banner | Set_InsertComponents_BannerWithImage | Set_InsertComponents_Newsletter;

export type Sets_IntroText = BardText;

export type Sets_NewsletterThankYouText = BardText;

export type Sets_PersonalCouponText = BardText;

export type Sets_Quote = BardText;

export type Sets_RegisterText = BardText | Set_RegisterText_Button | Set_RegisterText_Image;

export type Sets_TeamMemberComponents = Set_TeamMemberComponents_ImageGallery | Set_TeamMemberComponents_ImageWithText | Set_TeamMemberComponents_Posts | Set_TeamMemberComponents_Teaser | Set_TeamMemberComponents_TitleWithText;

export type Sets_Text = BardText;

export type Sets_TextComponents = BardText | Set_TextComponents_Button | Set_TextComponents_Image;

export type Sets_ThankYouText = BardText;

export type Sets_ThankyouText = BardText;

export type Sets_WelcomeSubtitle = BardText;

export type Sets_WelcomeText = BardText;

export type Site = {
  __typename?: 'Site';
  handle: Scalars['String'];
  locale: Scalars['String'];
  name: Scalars['String'];
  short_locale: Scalars['String'];
  url: Scalars['String'];
};

export type SitemapEntry = {
  __typename?: 'SitemapEntry';
  alternates?: Maybe<Array<Maybe<Scalars['String']>>>;
  change_frequency?: Maybe<Scalars['String']>;
  lastmod?: Maybe<Scalars['String']>;
  path: Scalars['String'];
  priority?: Maybe<Scalars['String']>;
  url: Scalars['String'];
};

export type TableRow = {
  __typename?: 'TableRow';
  cells?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Taxonomy = {
  __typename?: 'Taxonomy';
  handle: Scalars['String'];
  title: Scalars['String'];
};

export type TermInterface = {
  edit_url: Scalars['String'];
  id: Scalars['ID'];
  permalink?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  taxonomy: Taxonomy;
  title: Scalars['String'];
  uri?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type TermInterfacePagination = {
  __typename?: 'TermInterfacePagination';
  /** Current page of the cursor */
  current_page: Scalars['Int'];
  /** List of items on the current page */
  data?: Maybe<Array<Maybe<TermInterface>>>;
  /** Number of the first item returned */
  from?: Maybe<Scalars['Int']>;
  /** Determines if cursor has more pages after the current page */
  has_more_pages: Scalars['Boolean'];
  /** The last page (number of pages) */
  last_page: Scalars['Int'];
  /** Number of items returned per page */
  per_page: Scalars['Int'];
  /** Number of the last item returned */
  to?: Maybe<Scalars['Int']>;
  /** Number of total items selected by the query */
  total: Scalars['Int'];
};

export type Term_Categories_Category = TermInterface & {
  __typename?: 'Term_Categories_Category';
  edit_url: Scalars['String'];
  id: Scalars['ID'];
  permalink?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  taxonomy: Taxonomy;
  title: Scalars['String'];
  uri?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type Term_EventTypes_EventType = TermInterface & {
  __typename?: 'Term_EventTypes_EventType';
  edit_url: Scalars['String'];
  id: Scalars['ID'];
  permalink?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  taxonomy: Taxonomy;
  title: Scalars['String'];
  uri?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type Term_Formats_Format = TermInterface & {
  __typename?: 'Term_Formats_Format';
  edit_url: Scalars['String'];
  id: Scalars['ID'];
  permalink?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  taxonomy: Taxonomy;
  title: Scalars['String'];
  uri?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type Term_Tags_Tag = TermInterface & {
  __typename?: 'Term_Tags_Tag';
  edit_url: Scalars['String'];
  id: Scalars['ID'];
  permalink?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  taxonomy: Taxonomy;
  title: Scalars['String'];
  uri?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type Term_TeamFormats_TeamFormat = TermInterface & {
  __typename?: 'Term_TeamFormats_TeamFormat';
  edit_url: Scalars['String'];
  id: Scalars['ID'];
  permalink?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  taxonomy: Taxonomy;
  title: Scalars['String'];
  title_female: Scalars['String'];
  title_male: Scalars['String'];
  uri?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type UploadedPostMedia = {
  alt?: InputMaybe<Scalars['String']>;
  background_color?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<Scalars['String']>;
  logo_color?: InputMaybe<Scalars['String']>;
  logo_position?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
  video?: InputMaybe<Scalars['String']>;
};

export type UploadedPostMediaWrapper = {
  data?: InputMaybe<UploadedPostMedia>;
  type?: InputMaybe<Scalars['String']>;
};

export type User = {
  __typename?: 'User';
  artist_category?: Maybe<LabeledValue>;
  avatar?: Maybe<AssetInterface>;
  canton?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  coupon_code?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['String']>;
  edit_url?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  firstname?: Maybe<Scalars['String']>;
  groups?: Maybe<Array<Maybe<UserGroup>>>;
  guest_category?: Maybe<LabeledValue>;
  history?: Maybe<Array<Maybe<GridItem_History>>>;
  id?: Maybe<Scalars['String']>;
  initials?: Maybe<Scalars['String']>;
  lastname?: Maybe<Scalars['String']>;
  member_category?: Maybe<LabeledValue>;
  name?: Maybe<Scalars['String']>;
  patron_category?: Maybe<LabeledValue>;
  permissions?: Maybe<Array<Maybe<Scalars['String']>>>;
  phone?: Maybe<Scalars['String']>;
  price_rule_id?: Maybe<Scalars['String']>;
  roles?: Maybe<Array<Maybe<Role>>>;
  salutation?: Maybe<LabeledValue>;
  shopify_customer_id?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  team_member?: Maybe<Entry_Team_TeamMember>;
  username?: Maybe<Scalars['String']>;
  valid_membership_until?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};


export type UserCreated_AtArgs = {
  format?: InputMaybe<Scalars['String']>;
};


export type UserValid_Membership_UntilArgs = {
  format?: InputMaybe<Scalars['String']>;
};

export type UserGroup = {
  __typename?: 'UserGroup';
  handle?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type UserPagination = {
  __typename?: 'UserPagination';
  /** Current page of the cursor */
  current_page: Scalars['Int'];
  /** List of items on the current page */
  data?: Maybe<Array<Maybe<User>>>;
  /** Number of the first item returned */
  from?: Maybe<Scalars['Int']>;
  /** Determines if cursor has more pages after the current page */
  has_more_pages: Scalars['Boolean'];
  /** The last page (number of pages) */
  last_page: Scalars['Int'];
  /** Number of items returned per page */
  per_page: Scalars['Int'];
  /** Number of the last item returned */
  to?: Maybe<Scalars['Int']>;
  /** Number of total items selected by the query */
  total: Scalars['Int'];
};

export type CreatePostMutationVariables = Exact<{
  title: Scalars['String'];
  format: Scalars['String'];
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  allow_sharing_with_third_parties: Scalars['Boolean'];
  allow_sharing_with_we_publish: Scalars['Boolean'];
  text?: InputMaybe<Scalars['String']>;
  media?: InputMaybe<Array<InputMaybe<UploadedPostMediaWrapper>> | InputMaybe<UploadedPostMediaWrapper>>;
}>;


export type CreatePostMutation = { __typename?: 'Mutation', createPost: { __typename?: 'Entry_Posts_Post', id: string, title: string, slug: string } };

export type GetAuthorPostAmountsQueryVariables = Exact<{
  author?: InputMaybe<Scalars['String']>;
}>;


export type GetAuthorPostAmountsQuery = { __typename?: 'Query', publishedPosts?: { __typename?: 'Entry_Posts_PostPagination', total: number } | null, newPosts?: { __typename?: 'Entry_Posts_PostPagination', total: number } | null, reservedPosts?: { __typename?: 'Entry_Posts_PostPagination', total: number } | null };

export type GetAuthorsQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type GetAuthorsQuery = { __typename?: 'Query', entries?: { __typename?: 'EntryInterfacePagination', total: number, from?: number | null, to?: number | null, per_page: number, current_page: number, last_page: number, has_more_pages: boolean, data?: Array<{ __typename?: 'Entry_Events_Event', title: string, id: string, permalink?: string | null, url?: string | null, uri?: string | null, slug: string, date?: string | null, status: string, blueprint?: string | null } | { __typename?: 'Entry_Lotteries_ExternalLottery', title: string, id: string, permalink?: string | null, url?: string | null, uri?: string | null, slug: string, date?: string | null, status: string, blueprint?: string | null } | { __typename?: 'Entry_Pages_Contact', title: string, id: string, permalink?: string | null, url?: string | null, uri?: string | null, slug: string, date?: string | null, status: string, blueprint?: string | null } | { __typename?: 'Entry_Pages_News', title: string, id: string, permalink?: string | null, url?: string | null, uri?: string | null, slug: string, date?: string | null, status: string, blueprint?: string | null } | { __typename?: 'Entry_Pages_Page', title: string, id: string, permalink?: string | null, url?: string | null, uri?: string | null, slug: string, date?: string | null, status: string, blueprint?: string | null } | { __typename?: 'Entry_Posts_Post', title: string, id: string, permalink?: string | null, url?: string | null, uri?: string | null, slug: string, date?: string | null, status: string, blueprint?: string | null } | { __typename?: 'Entry_Team_TeamMember', id: string, title: string, permalink?: string | null, url?: string | null, uri?: string | null, slug: string, date?: string | null, status: string, blueprint?: string | null, image?: { __typename?: 'Asset_Assets', alt?: string | null, id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_Downloads', id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_PostAssets', alt?: string | null, id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_UploadedAssets', id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_UserAssets', alt?: string | null, id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | null, team_formats?: Array<{ __typename?: 'Term_Categories_Category', id: string, slug: string, title: string, url?: string | null } | { __typename?: 'Term_EventTypes_EventType', id: string, slug: string, title: string, url?: string | null } | { __typename?: 'Term_Formats_Format', id: string, slug: string, title: string, url?: string | null } | { __typename?: 'Term_Tags_Tag', id: string, slug: string, title: string, url?: string | null } | { __typename?: 'Term_TeamFormats_TeamFormat', id: string, title_female: string, title_male: string, slug: string, title: string, url?: string | null } | null> | null, author: { __typename?: 'User', id?: string | null, name?: string | null, salutation?: { __typename?: 'LabeledValue', value?: string | null, label?: string | null } | null, avatar?: { __typename?: 'Asset_Assets', alt?: string | null, id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_Downloads', id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_PostAssets', alt?: string | null, id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_UploadedAssets', id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_UserAssets', alt?: string | null, id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | null } } | { __typename?: 'Entry_Votings_ExternalVoting', title: string, id: string, permalink?: string | null, url?: string | null, uri?: string | null, slug: string, date?: string | null, status: string, blueprint?: string | null } | { __typename?: 'Entry_Votings_Voting', title: string, id: string, permalink?: string | null, url?: string | null, uri?: string | null, slug: string, date?: string | null, status: string, blueprint?: string | null } | { __typename?: 'NavEntryPage_FooterMainNavigation_Pages_Contact', title: string, id: string, permalink?: string | null, url?: string | null, uri?: string | null, slug: string, date?: string | null, status: string, blueprint?: string | null } | { __typename?: 'NavEntryPage_FooterMainNavigation_Pages_News', title: string, id: string, permalink?: string | null, url?: string | null, uri?: string | null, slug: string, date?: string | null, status: string, blueprint?: string | null } | { __typename?: 'NavEntryPage_FooterMainNavigation_Pages_Page', title: string, id: string, permalink?: string | null, url?: string | null, uri?: string | null, slug: string, date?: string | null, status: string, blueprint?: string | null } | { __typename?: 'NavEntryPage_FooterSecondaryNavigation_Pages_Contact', title: string, id: string, permalink?: string | null, url?: string | null, uri?: string | null, slug: string, date?: string | null, status: string, blueprint?: string | null } | { __typename?: 'NavEntryPage_FooterSecondaryNavigation_Pages_News', title: string, id: string, permalink?: string | null, url?: string | null, uri?: string | null, slug: string, date?: string | null, status: string, blueprint?: string | null } | { __typename?: 'NavEntryPage_FooterSecondaryNavigation_Pages_Page', title: string, id: string, permalink?: string | null, url?: string | null, uri?: string | null, slug: string, date?: string | null, status: string, blueprint?: string | null } | { __typename?: 'NavEntryPage_MainNavigation_Pages_Contact', title: string, id: string, permalink?: string | null, url?: string | null, uri?: string | null, slug: string, date?: string | null, status: string, blueprint?: string | null } | { __typename?: 'NavEntryPage_MainNavigation_Pages_News', title: string, id: string, permalink?: string | null, url?: string | null, uri?: string | null, slug: string, date?: string | null, status: string, blueprint?: string | null } | { __typename?: 'NavEntryPage_MainNavigation_Pages_Page', title: string, id: string, permalink?: string | null, url?: string | null, uri?: string | null, slug: string, date?: string | null, status: string, blueprint?: string | null } | null> | null } | null };

export type GetCategoriesQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type GetCategoriesQuery = { __typename?: 'Query', taxonomy?: { __typename?: 'Taxonomy', title: string, handle: string } | null, terms?: { __typename?: 'TermInterfacePagination', total: number, from?: number | null, to?: number | null, per_page: number, current_page: number, last_page: number, has_more_pages: boolean, data?: Array<{ __typename?: 'Term_Categories_Category', id: string, slug: string, title: string, url?: string | null } | { __typename?: 'Term_EventTypes_EventType', id: string, slug: string, title: string, url?: string | null } | { __typename?: 'Term_Formats_Format', id: string, slug: string, title: string, url?: string | null } | { __typename?: 'Term_Tags_Tag', id: string, slug: string, title: string, url?: string | null } | { __typename?: 'Term_TeamFormats_TeamFormat', id: string, slug: string, title: string, url?: string | null } | null> | null } | null };

export type GetCouponsGlobalQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCouponsGlobalQuery = { __typename?: 'Query', globalSet?: { __typename?: 'GlobalSet_DefaultTeaser', handle: string } | { __typename?: 'GlobalSet_Emails', handle: string } | { __typename?: 'GlobalSet_Footer', handle: string } | { __typename?: 'GlobalSet_LoginSectionCoupons', text?: string | null, personal_coupon_title?: string | null, personal_coupon_text?: string | null, handle: string, title: string, personal_coupon_image?: { __typename?: 'Asset_Assets', alt?: string | null, id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_Downloads', id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_PostAssets', alt?: string | null, id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_UploadedAssets', id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_UserAssets', alt?: string | null, id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | null } | { __typename?: 'GlobalSet_LoginSectionCreatePost', handle: string } | { __typename?: 'GlobalSet_LoginSectionDownloads', handle: string } | { __typename?: 'GlobalSet_LoginSectionLogin', handle: string } | { __typename?: 'GlobalSet_LoginSectionLotteries', handle: string } | { __typename?: 'GlobalSet_LoginSectionMembership', handle: string } | { __typename?: 'GlobalSet_LoginSectionNewsletter', handle: string } | { __typename?: 'GlobalSet_LoginSectionProfile', handle: string } | { __typename?: 'GlobalSet_LoginSectionVotings', handle: string } | { __typename?: 'GlobalSet_Shopify', handle: string } | null, shopify?: { __typename?: 'GlobalSet_DefaultTeaser', handle: string } | { __typename?: 'GlobalSet_Emails', handle: string } | { __typename?: 'GlobalSet_Footer', handle: string } | { __typename?: 'GlobalSet_LoginSectionCoupons', handle: string } | { __typename?: 'GlobalSet_LoginSectionCreatePost', handle: string } | { __typename?: 'GlobalSet_LoginSectionDownloads', handle: string } | { __typename?: 'GlobalSet_LoginSectionLogin', handle: string } | { __typename?: 'GlobalSet_LoginSectionLotteries', handle: string } | { __typename?: 'GlobalSet_LoginSectionMembership', handle: string } | { __typename?: 'GlobalSet_LoginSectionNewsletter', handle: string } | { __typename?: 'GlobalSet_LoginSectionProfile', handle: string } | { __typename?: 'GlobalSet_LoginSectionVotings', handle: string } | { __typename?: 'GlobalSet_Shopify', base_url?: string | null, handle: string } | null };

export type GetCreatePostGlobalQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCreatePostGlobalQuery = { __typename?: 'Query', globalSet?: { __typename?: 'GlobalSet_DefaultTeaser', handle: string } | { __typename?: 'GlobalSet_Emails', handle: string } | { __typename?: 'GlobalSet_Footer', handle: string } | { __typename?: 'GlobalSet_LoginSectionCoupons', handle: string } | { __typename?: 'GlobalSet_LoginSectionCreatePost', text?: string | null, show_allow_sharing_with_third_parties_field?: boolean | null, allow_sharing_with_third_parties_description?: string | null, show_allow_sharing_with_we_publish_field?: boolean | null, allow_sharing_with_we_publish_description?: string | null, handle: string, title: string } | { __typename?: 'GlobalSet_LoginSectionDownloads', handle: string } | { __typename?: 'GlobalSet_LoginSectionLogin', handle: string } | { __typename?: 'GlobalSet_LoginSectionLotteries', handle: string } | { __typename?: 'GlobalSet_LoginSectionMembership', handle: string } | { __typename?: 'GlobalSet_LoginSectionNewsletter', handle: string } | { __typename?: 'GlobalSet_LoginSectionProfile', handle: string } | { __typename?: 'GlobalSet_LoginSectionVotings', handle: string } | { __typename?: 'GlobalSet_Shopify', handle: string } | null };

export type GetCurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentUserQuery = { __typename?: 'Query', user?: { __typename?: 'User', id?: string | null, firstname?: string | null, lastname?: string | null, name?: string | null, email?: string | null, username?: string | null, initials?: string | null, phone?: string | null, street?: string | null, zip?: string | null, city?: string | null, created_at?: string | null, permissions?: Array<string | null> | null, coupon_code?: string | null, valid_membership_until?: string | null, salutation?: { __typename?: 'LabeledValue', value?: string | null, label?: string | null } | null, groups?: Array<{ __typename?: 'UserGroup', handle?: string | null, title?: string | null } | null> | null, member_category?: { __typename?: 'LabeledValue', value?: string | null, label?: string | null } | null, artist_category?: { __typename?: 'LabeledValue', value?: string | null, label?: string | null } | null, avatar?: { __typename?: 'Asset_Assets', alt?: string | null, id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_Downloads', id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_PostAssets', alt?: string | null, id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_UploadedAssets', id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_UserAssets', alt?: string | null, id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | null, history?: Array<{ __typename?: 'GridItem_History', productId?: string | null, purchaseId?: string | null, name: string, amount?: string | null, validity?: { __typename?: 'DateRange', start?: string | null, end?: string | null } | null } | null> | null } | null };

export type GetDownloadsGlobalQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDownloadsGlobalQuery = { __typename?: 'Query', globalSet?: { __typename?: 'GlobalSet_DefaultTeaser', handle: string } | { __typename?: 'GlobalSet_Emails', handle: string } | { __typename?: 'GlobalSet_Footer', handle: string } | { __typename?: 'GlobalSet_LoginSectionCoupons', handle: string } | { __typename?: 'GlobalSet_LoginSectionCreatePost', handle: string } | { __typename?: 'GlobalSet_LoginSectionDownloads', text?: string | null, handle: string, title: string } | { __typename?: 'GlobalSet_LoginSectionLogin', handle: string } | { __typename?: 'GlobalSet_LoginSectionLotteries', handle: string } | { __typename?: 'GlobalSet_LoginSectionMembership', handle: string } | { __typename?: 'GlobalSet_LoginSectionNewsletter', handle: string } | { __typename?: 'GlobalSet_LoginSectionProfile', handle: string } | { __typename?: 'GlobalSet_LoginSectionVotings', handle: string } | { __typename?: 'GlobalSet_Shopify', handle: string } | null };

export type GetDownloadsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDownloadsQuery = { __typename?: 'Query', assets?: { __typename?: 'AssetInterfacePagination', data?: Array<{ __typename?: 'Asset_Assets' } | { __typename?: 'Asset_Downloads', id: string, title: string, description?: string | null, path: string, download_url?: string | null } | { __typename?: 'Asset_PostAssets' } | { __typename?: 'Asset_UploadedAssets' } | { __typename?: 'Asset_UserAssets' } | null> | null } | null };

export type GetEventTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetEventTypesQuery = { __typename?: 'Query', taxonomy?: { __typename?: 'Taxonomy', title: string, handle: string } | null, terms?: { __typename?: 'TermInterfacePagination', total: number, from?: number | null, to?: number | null, per_page: number, current_page: number, last_page: number, has_more_pages: boolean, data?: Array<{ __typename?: 'Term_Categories_Category', id: string, slug: string, title: string, url?: string | null } | { __typename?: 'Term_EventTypes_EventType', id: string, slug: string, title: string, url?: string | null } | { __typename?: 'Term_Formats_Format', id: string, slug: string, title: string, url?: string | null } | { __typename?: 'Term_Tags_Tag', id: string, slug: string, title: string, url?: string | null } | { __typename?: 'Term_TeamFormats_TeamFormat', id: string, slug: string, title: string, url?: string | null } | null> | null } | null };

export type GetEventsQueryVariables = Exact<{
  filter?: InputMaybe<Scalars['JsonArgument']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  page?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type GetEventsQuery = { __typename?: 'Query', entries?: { __typename?: 'EntryInterfacePagination', total: number, from?: number | null, to?: number | null, per_page: number, current_page: number, last_page: number, has_more_pages: boolean, data?: Array<{ __typename?: 'Entry_Events_Event', id: string, description?: string | null, date?: string | null, location?: string | null, location_link?: string | null, tickets_link?: string | null, title: string, permalink?: string | null, url?: string | null, uri?: string | null, slug: string, status: string, blueprint?: string | null, event_types?: Array<{ __typename?: 'Term_Categories_Category', slug: string, title: string, permalink?: string | null, url?: string | null, uri?: string | null } | { __typename?: 'Term_EventTypes_EventType', slug: string, title: string, permalink?: string | null, url?: string | null, uri?: string | null } | { __typename?: 'Term_Formats_Format', slug: string, title: string, permalink?: string | null, url?: string | null, uri?: string | null } | { __typename?: 'Term_Tags_Tag', slug: string, title: string, permalink?: string | null, url?: string | null, uri?: string | null } | { __typename?: 'Term_TeamFormats_TeamFormat', slug: string, title: string, permalink?: string | null, url?: string | null, uri?: string | null } | null> | null, image?: { __typename?: 'Asset_Assets', alt?: string | null, id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_Downloads', id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_PostAssets', alt?: string | null, id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_UploadedAssets', id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_UserAssets', alt?: string | null, id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | null } | { __typename?: 'Entry_Lotteries_ExternalLottery', title: string, id: string, permalink?: string | null, url?: string | null, uri?: string | null, slug: string, date?: string | null, status: string, blueprint?: string | null } | { __typename?: 'Entry_Pages_Contact', title: string, id: string, permalink?: string | null, url?: string | null, uri?: string | null, slug: string, date?: string | null, status: string, blueprint?: string | null } | { __typename?: 'Entry_Pages_News', title: string, id: string, permalink?: string | null, url?: string | null, uri?: string | null, slug: string, date?: string | null, status: string, blueprint?: string | null } | { __typename?: 'Entry_Pages_Page', title: string, id: string, permalink?: string | null, url?: string | null, uri?: string | null, slug: string, date?: string | null, status: string, blueprint?: string | null } | { __typename?: 'Entry_Posts_Post', title: string, id: string, permalink?: string | null, url?: string | null, uri?: string | null, slug: string, date?: string | null, status: string, blueprint?: string | null } | { __typename?: 'Entry_Team_TeamMember', title: string, id: string, permalink?: string | null, url?: string | null, uri?: string | null, slug: string, date?: string | null, status: string, blueprint?: string | null } | { __typename?: 'Entry_Votings_ExternalVoting', title: string, id: string, permalink?: string | null, url?: string | null, uri?: string | null, slug: string, date?: string | null, status: string, blueprint?: string | null } | { __typename?: 'Entry_Votings_Voting', title: string, id: string, permalink?: string | null, url?: string | null, uri?: string | null, slug: string, date?: string | null, status: string, blueprint?: string | null } | { __typename?: 'NavEntryPage_FooterMainNavigation_Pages_Contact', title: string, id: string, permalink?: string | null, url?: string | null, uri?: string | null, slug: string, date?: string | null, status: string, blueprint?: string | null } | { __typename?: 'NavEntryPage_FooterMainNavigation_Pages_News', title: string, id: string, permalink?: string | null, url?: string | null, uri?: string | null, slug: string, date?: string | null, status: string, blueprint?: string | null } | { __typename?: 'NavEntryPage_FooterMainNavigation_Pages_Page', title: string, id: string, permalink?: string | null, url?: string | null, uri?: string | null, slug: string, date?: string | null, status: string, blueprint?: string | null } | { __typename?: 'NavEntryPage_FooterSecondaryNavigation_Pages_Contact', title: string, id: string, permalink?: string | null, url?: string | null, uri?: string | null, slug: string, date?: string | null, status: string, blueprint?: string | null } | { __typename?: 'NavEntryPage_FooterSecondaryNavigation_Pages_News', title: string, id: string, permalink?: string | null, url?: string | null, uri?: string | null, slug: string, date?: string | null, status: string, blueprint?: string | null } | { __typename?: 'NavEntryPage_FooterSecondaryNavigation_Pages_Page', title: string, id: string, permalink?: string | null, url?: string | null, uri?: string | null, slug: string, date?: string | null, status: string, blueprint?: string | null } | { __typename?: 'NavEntryPage_MainNavigation_Pages_Contact', title: string, id: string, permalink?: string | null, url?: string | null, uri?: string | null, slug: string, date?: string | null, status: string, blueprint?: string | null } | { __typename?: 'NavEntryPage_MainNavigation_Pages_News', title: string, id: string, permalink?: string | null, url?: string | null, uri?: string | null, slug: string, date?: string | null, status: string, blueprint?: string | null } | { __typename?: 'NavEntryPage_MainNavigation_Pages_Page', title: string, id: string, permalink?: string | null, url?: string | null, uri?: string | null, slug: string, date?: string | null, status: string, blueprint?: string | null } | null> | null } | null };

export type GetFormatsQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type GetFormatsQuery = { __typename?: 'Query', taxonomy?: { __typename?: 'Taxonomy', title: string, handle: string } | null, terms?: { __typename?: 'TermInterfacePagination', total: number, from?: number | null, to?: number | null, per_page: number, current_page: number, last_page: number, has_more_pages: boolean, data?: Array<{ __typename?: 'Term_Categories_Category', id: string, slug: string, title: string, url?: string | null } | { __typename?: 'Term_EventTypes_EventType', id: string, slug: string, title: string, url?: string | null } | { __typename?: 'Term_Formats_Format', id: string, slug: string, title: string, url?: string | null } | { __typename?: 'Term_Tags_Tag', id: string, slug: string, title: string, url?: string | null } | { __typename?: 'Term_TeamFormats_TeamFormat', id: string, slug: string, title: string, url?: string | null } | null> | null } | null };

export type GetGlobalsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetGlobalsQuery = { __typename?: 'Query', main_navigation?: { __typename?: 'Navigation', handle: string, title: string, tree?: Array<{ __typename?: 'NavTreeBranch', page?: { __typename?: 'NavBasicPage_FooterMainNavigation', id: string, entry_id?: string | null, title?: string | null, url?: string | null, permalink?: string | null } | { __typename?: 'NavBasicPage_FooterSecondaryNavigation', id: string, entry_id?: string | null, title?: string | null, url?: string | null, permalink?: string | null } | { __typename?: 'NavBasicPage_MainNavigation', highlight?: boolean | null, id: string, entry_id?: string | null, title?: string | null, url?: string | null, permalink?: string | null } | { __typename?: 'NavEntryPage_FooterMainNavigation_Pages_Contact', id: string, entry_id?: string | null, title: string, url?: string | null, permalink?: string | null } | { __typename?: 'NavEntryPage_FooterMainNavigation_Pages_News', id: string, entry_id?: string | null, title: string, url?: string | null, permalink?: string | null } | { __typename?: 'NavEntryPage_FooterMainNavigation_Pages_Page', id: string, entry_id?: string | null, title: string, url?: string | null, permalink?: string | null } | { __typename?: 'NavEntryPage_FooterSecondaryNavigation_Pages_Contact', id: string, entry_id?: string | null, title: string, url?: string | null, permalink?: string | null } | { __typename?: 'NavEntryPage_FooterSecondaryNavigation_Pages_News', id: string, entry_id?: string | null, title: string, url?: string | null, permalink?: string | null } | { __typename?: 'NavEntryPage_FooterSecondaryNavigation_Pages_Page', id: string, entry_id?: string | null, title: string, url?: string | null, permalink?: string | null } | { __typename?: 'NavEntryPage_MainNavigation_Pages_Contact', id: string, entry_id?: string | null, title: string, url?: string | null, permalink?: string | null } | { __typename?: 'NavEntryPage_MainNavigation_Pages_News', highlight?: boolean | null, id: string, entry_id?: string | null, title: string, url?: string | null, permalink?: string | null } | { __typename?: 'NavEntryPage_MainNavigation_Pages_Page', highlight?: boolean | null, id: string, entry_id?: string | null, title: string, url?: string | null, permalink?: string | null } | null, children?: Array<{ __typename?: 'NavTreeBranch', page?: { __typename?: 'NavBasicPage_FooterMainNavigation', id: string, entry_id?: string | null, title?: string | null, url?: string | null, permalink?: string | null } | { __typename?: 'NavBasicPage_FooterSecondaryNavigation', id: string, entry_id?: string | null, title?: string | null, url?: string | null, permalink?: string | null } | { __typename?: 'NavBasicPage_MainNavigation', highlight?: boolean | null, id: string, entry_id?: string | null, title?: string | null, url?: string | null, permalink?: string | null } | { __typename?: 'NavEntryPage_FooterMainNavigation_Pages_Contact', id: string, entry_id?: string | null, title: string, url?: string | null, permalink?: string | null } | { __typename?: 'NavEntryPage_FooterMainNavigation_Pages_News', id: string, entry_id?: string | null, title: string, url?: string | null, permalink?: string | null } | { __typename?: 'NavEntryPage_FooterMainNavigation_Pages_Page', id: string, entry_id?: string | null, title: string, url?: string | null, permalink?: string | null } | { __typename?: 'NavEntryPage_FooterSecondaryNavigation_Pages_Contact', id: string, entry_id?: string | null, title: string, url?: string | null, permalink?: string | null } | { __typename?: 'NavEntryPage_FooterSecondaryNavigation_Pages_News', id: string, entry_id?: string | null, title: string, url?: string | null, permalink?: string | null } | { __typename?: 'NavEntryPage_FooterSecondaryNavigation_Pages_Page', id: string, entry_id?: string | null, title: string, url?: string | null, permalink?: string | null } | { __typename?: 'NavEntryPage_MainNavigation_Pages_Contact', id: string, entry_id?: string | null, title: string, url?: string | null, permalink?: string | null } | { __typename?: 'NavEntryPage_MainNavigation_Pages_News', highlight?: boolean | null, id: string, entry_id?: string | null, title: string, url?: string | null, permalink?: string | null } | { __typename?: 'NavEntryPage_MainNavigation_Pages_Page', highlight?: boolean | null, id: string, entry_id?: string | null, title: string, url?: string | null, permalink?: string | null } | null } | null> | null } | null> | null } | null, footer_main_navigation?: { __typename?: 'Navigation', handle: string, title: string, tree?: Array<{ __typename?: 'NavTreeBranch', page?: { __typename?: 'NavBasicPage_FooterMainNavigation', id: string, entry_id?: string | null, title?: string | null, url?: string | null, permalink?: string | null } | { __typename?: 'NavBasicPage_FooterSecondaryNavigation', id: string, entry_id?: string | null, title?: string | null, url?: string | null, permalink?: string | null } | { __typename?: 'NavBasicPage_MainNavigation', id: string, entry_id?: string | null, title?: string | null, url?: string | null, permalink?: string | null } | { __typename?: 'NavEntryPage_FooterMainNavigation_Pages_Contact', id: string, entry_id?: string | null, title: string, url?: string | null, permalink?: string | null } | { __typename?: 'NavEntryPage_FooterMainNavigation_Pages_News', id: string, entry_id?: string | null, title: string, url?: string | null, permalink?: string | null } | { __typename?: 'NavEntryPage_FooterMainNavigation_Pages_Page', id: string, entry_id?: string | null, title: string, url?: string | null, permalink?: string | null } | { __typename?: 'NavEntryPage_FooterSecondaryNavigation_Pages_Contact', id: string, entry_id?: string | null, title: string, url?: string | null, permalink?: string | null } | { __typename?: 'NavEntryPage_FooterSecondaryNavigation_Pages_News', id: string, entry_id?: string | null, title: string, url?: string | null, permalink?: string | null } | { __typename?: 'NavEntryPage_FooterSecondaryNavigation_Pages_Page', id: string, entry_id?: string | null, title: string, url?: string | null, permalink?: string | null } | { __typename?: 'NavEntryPage_MainNavigation_Pages_Contact', id: string, entry_id?: string | null, title: string, url?: string | null, permalink?: string | null } | { __typename?: 'NavEntryPage_MainNavigation_Pages_News', id: string, entry_id?: string | null, title: string, url?: string | null, permalink?: string | null } | { __typename?: 'NavEntryPage_MainNavigation_Pages_Page', id: string, entry_id?: string | null, title: string, url?: string | null, permalink?: string | null } | null } | null> | null } | null, footer_secondary_navigation?: { __typename?: 'Navigation', handle: string, title: string, tree?: Array<{ __typename?: 'NavTreeBranch', page?: { __typename?: 'NavBasicPage_FooterMainNavigation', id: string, entry_id?: string | null, title?: string | null, url?: string | null, permalink?: string | null } | { __typename?: 'NavBasicPage_FooterSecondaryNavigation', id: string, entry_id?: string | null, title?: string | null, url?: string | null, permalink?: string | null } | { __typename?: 'NavBasicPage_MainNavigation', id: string, entry_id?: string | null, title?: string | null, url?: string | null, permalink?: string | null } | { __typename?: 'NavEntryPage_FooterMainNavigation_Pages_Contact', id: string, entry_id?: string | null, title: string, url?: string | null, permalink?: string | null } | { __typename?: 'NavEntryPage_FooterMainNavigation_Pages_News', id: string, entry_id?: string | null, title: string, url?: string | null, permalink?: string | null } | { __typename?: 'NavEntryPage_FooterMainNavigation_Pages_Page', id: string, entry_id?: string | null, title: string, url?: string | null, permalink?: string | null } | { __typename?: 'NavEntryPage_FooterSecondaryNavigation_Pages_Contact', id: string, entry_id?: string | null, title: string, url?: string | null, permalink?: string | null } | { __typename?: 'NavEntryPage_FooterSecondaryNavigation_Pages_News', id: string, entry_id?: string | null, title: string, url?: string | null, permalink?: string | null } | { __typename?: 'NavEntryPage_FooterSecondaryNavigation_Pages_Page', id: string, entry_id?: string | null, title: string, url?: string | null, permalink?: string | null } | { __typename?: 'NavEntryPage_MainNavigation_Pages_Contact', id: string, entry_id?: string | null, title: string, url?: string | null, permalink?: string | null } | { __typename?: 'NavEntryPage_MainNavigation_Pages_News', id: string, entry_id?: string | null, title: string, url?: string | null, permalink?: string | null } | { __typename?: 'NavEntryPage_MainNavigation_Pages_Page', id: string, entry_id?: string | null, title: string, url?: string | null, permalink?: string | null } | null } | null> | null } | null, footer?: { __typename?: 'GlobalSet_DefaultTeaser', handle: string } | { __typename?: 'GlobalSet_Emails', handle: string } | { __typename?: 'GlobalSet_Footer', copyright_text?: string | null, newsletter_title?: string | null, newsletter_button_text?: string | null, newsletter_thank_you_text?: string | null, facebook?: string | null, instagram?: string | null, linkedin?: string | null, twitter?: string | null, handle: string } | { __typename?: 'GlobalSet_LoginSectionCoupons', handle: string } | { __typename?: 'GlobalSet_LoginSectionCreatePost', handle: string } | { __typename?: 'GlobalSet_LoginSectionDownloads', handle: string } | { __typename?: 'GlobalSet_LoginSectionLogin', handle: string } | { __typename?: 'GlobalSet_LoginSectionLotteries', handle: string } | { __typename?: 'GlobalSet_LoginSectionMembership', handle: string } | { __typename?: 'GlobalSet_LoginSectionNewsletter', handle: string } | { __typename?: 'GlobalSet_LoginSectionProfile', handle: string } | { __typename?: 'GlobalSet_LoginSectionVotings', handle: string } | { __typename?: 'GlobalSet_Shopify', handle: string } | null };

export type GetLoginGlobalQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLoginGlobalQuery = { __typename?: 'Query', globalSet?: { __typename?: 'GlobalSet_DefaultTeaser', handle: string } | { __typename?: 'GlobalSet_Emails', handle: string } | { __typename?: 'GlobalSet_Footer', handle: string } | { __typename?: 'GlobalSet_LoginSectionCoupons', handle: string } | { __typename?: 'GlobalSet_LoginSectionCreatePost', handle: string } | { __typename?: 'GlobalSet_LoginSectionDownloads', handle: string } | { __typename?: 'GlobalSet_LoginSectionLogin', login_title: string, login_button_text?: string | null, register_title: string, handle: string, register_text?: Array<{ __typename?: 'BardText', type: string, text?: string | null } | { __typename?: 'Set_RegisterText_Button', type: string, link?: string | null, text?: string | null, level?: { __typename?: 'LabeledValue', value?: string | null, label?: string | null } | null } | { __typename?: 'Set_RegisterText_Image', type: string, image?: { __typename?: 'Asset_Assets', alt?: string | null, id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_Downloads', id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_PostAssets', alt?: string | null, id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_UploadedAssets', id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_UserAssets', alt?: string | null, id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | null } | null> | null } | { __typename?: 'GlobalSet_LoginSectionLotteries', handle: string } | { __typename?: 'GlobalSet_LoginSectionMembership', handle: string } | { __typename?: 'GlobalSet_LoginSectionNewsletter', handle: string } | { __typename?: 'GlobalSet_LoginSectionProfile', handle: string } | { __typename?: 'GlobalSet_LoginSectionVotings', handle: string } | { __typename?: 'GlobalSet_Shopify', handle: string } | null };

export type GetLotteriesGlobalQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLotteriesGlobalQuery = { __typename?: 'Query', globalSet?: { __typename?: 'GlobalSet_DefaultTeaser', handle: string } | { __typename?: 'GlobalSet_Emails', handle: string } | { __typename?: 'GlobalSet_Footer', handle: string } | { __typename?: 'GlobalSet_LoginSectionCoupons', handle: string } | { __typename?: 'GlobalSet_LoginSectionCreatePost', handle: string } | { __typename?: 'GlobalSet_LoginSectionDownloads', handle: string } | { __typename?: 'GlobalSet_LoginSectionLogin', handle: string } | { __typename?: 'GlobalSet_LoginSectionLotteries', text?: string | null, handle: string, title: string } | { __typename?: 'GlobalSet_LoginSectionMembership', handle: string } | { __typename?: 'GlobalSet_LoginSectionNewsletter', handle: string } | { __typename?: 'GlobalSet_LoginSectionProfile', handle: string } | { __typename?: 'GlobalSet_LoginSectionVotings', handle: string } | { __typename?: 'GlobalSet_Shopify', handle: string } | null };

export type GetLotteriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLotteriesQuery = { __typename?: 'Query', entries?: { __typename?: 'EntryInterfacePagination', data?: Array<{ __typename?: 'Entry_Events_Event', title: string, id: string, permalink?: string | null, url?: string | null, uri?: string | null, slug: string, date?: string | null, status: string, blueprint?: string | null } | { __typename?: 'Entry_Lotteries_ExternalLottery', id: string, title: string, text?: string | null, link?: string | null, permalink?: string | null, url?: string | null, uri?: string | null, slug: string, date?: string | null, status: string, blueprint?: string | null, window?: { __typename?: 'DateRange', start?: string | null, end?: string | null } | null } | { __typename?: 'Entry_Pages_Contact', title: string, id: string, permalink?: string | null, url?: string | null, uri?: string | null, slug: string, date?: string | null, status: string, blueprint?: string | null } | { __typename?: 'Entry_Pages_News', title: string, id: string, permalink?: string | null, url?: string | null, uri?: string | null, slug: string, date?: string | null, status: string, blueprint?: string | null } | { __typename?: 'Entry_Pages_Page', title: string, id: string, permalink?: string | null, url?: string | null, uri?: string | null, slug: string, date?: string | null, status: string, blueprint?: string | null } | { __typename?: 'Entry_Posts_Post', title: string, id: string, permalink?: string | null, url?: string | null, uri?: string | null, slug: string, date?: string | null, status: string, blueprint?: string | null } | { __typename?: 'Entry_Team_TeamMember', title: string, id: string, permalink?: string | null, url?: string | null, uri?: string | null, slug: string, date?: string | null, status: string, blueprint?: string | null } | { __typename?: 'Entry_Votings_ExternalVoting', title: string, id: string, permalink?: string | null, url?: string | null, uri?: string | null, slug: string, date?: string | null, status: string, blueprint?: string | null } | { __typename?: 'Entry_Votings_Voting', title: string, id: string, permalink?: string | null, url?: string | null, uri?: string | null, slug: string, date?: string | null, status: string, blueprint?: string | null } | { __typename?: 'NavEntryPage_FooterMainNavigation_Pages_Contact', title: string, id: string, permalink?: string | null, url?: string | null, uri?: string | null, slug: string, date?: string | null, status: string, blueprint?: string | null } | { __typename?: 'NavEntryPage_FooterMainNavigation_Pages_News', title: string, id: string, permalink?: string | null, url?: string | null, uri?: string | null, slug: string, date?: string | null, status: string, blueprint?: string | null } | { __typename?: 'NavEntryPage_FooterMainNavigation_Pages_Page', title: string, id: string, permalink?: string | null, url?: string | null, uri?: string | null, slug: string, date?: string | null, status: string, blueprint?: string | null } | { __typename?: 'NavEntryPage_FooterSecondaryNavigation_Pages_Contact', title: string, id: string, permalink?: string | null, url?: string | null, uri?: string | null, slug: string, date?: string | null, status: string, blueprint?: string | null } | { __typename?: 'NavEntryPage_FooterSecondaryNavigation_Pages_News', title: string, id: string, permalink?: string | null, url?: string | null, uri?: string | null, slug: string, date?: string | null, status: string, blueprint?: string | null } | { __typename?: 'NavEntryPage_FooterSecondaryNavigation_Pages_Page', title: string, id: string, permalink?: string | null, url?: string | null, uri?: string | null, slug: string, date?: string | null, status: string, blueprint?: string | null } | { __typename?: 'NavEntryPage_MainNavigation_Pages_Contact', title: string, id: string, permalink?: string | null, url?: string | null, uri?: string | null, slug: string, date?: string | null, status: string, blueprint?: string | null } | { __typename?: 'NavEntryPage_MainNavigation_Pages_News', title: string, id: string, permalink?: string | null, url?: string | null, uri?: string | null, slug: string, date?: string | null, status: string, blueprint?: string | null } | { __typename?: 'NavEntryPage_MainNavigation_Pages_Page', title: string, id: string, permalink?: string | null, url?: string | null, uri?: string | null, slug: string, date?: string | null, status: string, blueprint?: string | null } | null> | null } | null };

export type GetMembershipGlobalQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMembershipGlobalQuery = { __typename?: 'Query', globalSet?: { __typename?: 'GlobalSet_DefaultTeaser', handle: string } | { __typename?: 'GlobalSet_Emails', handle: string } | { __typename?: 'GlobalSet_Footer', handle: string } | { __typename?: 'GlobalSet_LoginSectionCoupons', handle: string } | { __typename?: 'GlobalSet_LoginSectionCreatePost', handle: string } | { __typename?: 'GlobalSet_LoginSectionDownloads', handle: string } | { __typename?: 'GlobalSet_LoginSectionLogin', handle: string } | { __typename?: 'GlobalSet_LoginSectionLotteries', handle: string } | { __typename?: 'GlobalSet_LoginSectionMembership', text?: string | null, handle: string, title: string } | { __typename?: 'GlobalSet_LoginSectionNewsletter', handle: string } | { __typename?: 'GlobalSet_LoginSectionProfile', handle: string } | { __typename?: 'GlobalSet_LoginSectionVotings', handle: string } | { __typename?: 'GlobalSet_Shopify', handle: string } | null };

export type GetNewsletterGlobalQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNewsletterGlobalQuery = { __typename?: 'Query', globalSet?: { __typename?: 'GlobalSet_DefaultTeaser', handle: string } | { __typename?: 'GlobalSet_Emails', handle: string } | { __typename?: 'GlobalSet_Footer', handle: string } | { __typename?: 'GlobalSet_LoginSectionCoupons', handle: string } | { __typename?: 'GlobalSet_LoginSectionCreatePost', handle: string } | { __typename?: 'GlobalSet_LoginSectionDownloads', handle: string } | { __typename?: 'GlobalSet_LoginSectionLogin', handle: string } | { __typename?: 'GlobalSet_LoginSectionLotteries', handle: string } | { __typename?: 'GlobalSet_LoginSectionMembership', handle: string } | { __typename?: 'GlobalSet_LoginSectionNewsletter', text?: string | null, handle: string, title: string } | { __typename?: 'GlobalSet_LoginSectionProfile', handle: string } | { __typename?: 'GlobalSet_LoginSectionVotings', handle: string } | { __typename?: 'GlobalSet_Shopify', handle: string } | null };

export type GetNewsletterListsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNewsletterListsQuery = { __typename?: 'Query', newsletterLists?: Array<{ __typename?: 'NewsletterList', id: string, name: string, subscribed: boolean } | null> | null };

export type GetNumberOfPostsByAuthorQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['String']>;
}>;


export type GetNumberOfPostsByAuthorQuery = { __typename?: 'Query', entries?: { __typename?: 'EntryInterfacePagination', total: number } | null };

export type GetPageBySlugQueryVariables = Exact<{
  uri?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<Scalars['JsonArgument']>;
}>;


export type GetPageBySlugQuery = { __typename?: 'Query', entry?: { __typename?: 'Entry_Events_Event', title: string, id: string, last_modified?: string | null, permalink?: string | null, url?: string | null, uri?: string | null, slug: string, date?: string | null, status: string, blueprint?: string | null } | { __typename?: 'Entry_Lotteries_ExternalLottery', title: string, id: string, last_modified?: string | null, permalink?: string | null, url?: string | null, uri?: string | null, slug: string, date?: string | null, status: string, blueprint?: string | null } | { __typename?: 'Entry_Pages_Contact', intro_text?: string | null, thank_you_text?: string | null, error_text?: string | null, confirm_text?: string | null, button_text?: string | null, title: string, id: string, last_modified?: string | null, permalink?: string | null, url?: string | null, uri?: string | null, slug: string, date?: string | null, status: string, blueprint?: string | null, background_color: { __typename?: 'LabeledValue', value?: string | null, label?: string | null }, form?: { __typename?: 'Form', handle: string, title: string, honeypot?: string | null, rules?: any | null, fields?: Array<{ __typename?: 'Field', type: string, display: string, handle: string, config?: any | null } | null> | null } | null, image?: { __typename?: 'Asset_Assets', alt?: string | null, id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_Downloads', id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_PostAssets', alt?: string | null, id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_UploadedAssets', id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_UserAssets', alt?: string | null, id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | null, components?: Array<{ __typename?: 'Set_Components_Events', type: string, background_color: { __typename?: 'LabeledValue', value?: string | null, label?: string | null } } | { __typename?: 'Set_Components_ImageGallery', type: string, background_color: { __typename?: 'LabeledValue', value?: string | null, label?: string | null }, images?: Array<{ __typename?: 'Asset_Assets', alt?: string | null, id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_Downloads', id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_PostAssets', alt?: string | null, id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_UploadedAssets', id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_UserAssets', alt?: string | null, id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | null> | null } | { __typename?: 'Set_Components_ImageWithText', type: string, title?: string | null, text?: string | null, button_link?: string | null, button_text?: string | null, background_color: { __typename?: 'LabeledValue', value?: string | null, label?: string | null }, image_position?: { __typename?: 'LabeledValue', value?: string | null, label?: string | null } | null, image?: { __typename?: 'Asset_Assets', alt?: string | null, id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_Downloads', id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_PostAssets', alt?: string | null, id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_UploadedAssets', id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_UserAssets', alt?: string | null, id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | null } | { __typename?: 'Set_Components_Team', type: string, background_color: { __typename?: 'LabeledValue', value?: string | null, label?: string | null } } | { __typename?: 'Set_Components_Teaser', type: string, title?: string | null, text?: string | null, link?: string | null, link_text?: string | null } | { __typename?: 'Set_Components_ThreeIconCards', type: string, background_color: { __typename?: 'LabeledValue', value?: string | null, label?: string | null }, icon_cards?: Array<{ __typename?: 'Set_IconCards_IconWithTextSection', type: string, icon_text?: string | null, title?: string | null, subtitle?: string | null, icon?: { __typename?: 'Asset_Assets', alt?: string | null, id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_Downloads', id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_PostAssets', alt?: string | null, id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_UploadedAssets', id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_UserAssets', alt?: string | null, id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | null, icon_hover?: { __typename?: 'Asset_Assets', alt?: string | null, id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_Downloads', id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_PostAssets', alt?: string | null, id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_UploadedAssets', id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_UserAssets', alt?: string | null, id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | null, background_color: { __typename?: 'LabeledValue', value?: string | null, label?: string | null }, text_components?: Array<{ __typename?: 'BardText', type: string, text?: string | null } | { __typename?: 'Set_TextComponents_Button', type: string, link?: string | null, text?: string | null, level?: { __typename?: 'LabeledValue', value?: string | null, label?: string | null } | null } | { __typename?: 'Set_TextComponents_Image', type: string, image?: { __typename?: 'Asset_Assets', alt?: string | null, id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_Downloads', id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_PostAssets', alt?: string | null, id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_UploadedAssets', id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_UserAssets', alt?: string | null, id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | null } | null> | null, text_width?: { __typename?: 'LabeledValue', value?: string | null, label?: string | null } | null } | null> | null } | { __typename?: 'Set_Components_TitleWithText', type: string, title?: string | null, subtitle?: string | null, background_color: { __typename?: 'LabeledValue', value?: string | null, label?: string | null }, text_components?: Array<{ __typename?: 'BardText', type: string, text?: string | null } | { __typename?: 'Set_TextComponents_Button', type: string, link?: string | null, text?: string | null, level?: { __typename?: 'LabeledValue', value?: string | null, label?: string | null } | null } | { __typename?: 'Set_TextComponents_Image', type: string, image?: { __typename?: 'Asset_Assets', alt?: string | null, id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_Downloads', id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_PostAssets', alt?: string | null, id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_UploadedAssets', id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_UserAssets', alt?: string | null, id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | null } | null> | null, text_width?: { __typename?: 'LabeledValue', value?: string | null, label?: string | null } | null } | null> | null } | { __typename?: 'Entry_Pages_News', title_link?: string | null, title_link_text?: string | null, seo_hidden?: boolean | null, seo_title?: string | null, seo_description?: string | null, title: string, id: string, last_modified?: string | null, permalink?: string | null, url?: string | null, uri?: string | null, slug: string, date?: string | null, status: string, blueprint?: string | null, aside_components?: Array<{ __typename?: 'Set_AsideComponents_AsideTeaser', type: string, title?: string | null, link?: string | null, link_text?: string | null, background_color?: { __typename?: 'LabeledValue', value?: string | null, label?: string | null } | null, image?: { __typename?: 'Asset_Assets', alt?: string | null, id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_Downloads', id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_PostAssets', alt?: string | null, id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_UploadedAssets', id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_UserAssets', alt?: string | null, id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | null } | { __typename?: 'Set_AsideComponents_Banner', type: string, title?: string | null, text?: string | null, button_link?: string | null, button_text?: string | null, background_color?: { __typename?: 'LabeledValue', value?: string | null, label?: string | null } | null } | { __typename?: 'Set_AsideComponents_Newsletter', type: string, title?: string | null, text?: string | null, button_text?: string | null, thank_you_text?: string | null } | { __typename?: 'Set_AsideComponents_Post', type: string, title?: string | null, post?: { __typename?: 'Entry_Events_Event', title: string, id: string, permalink?: string | null, url?: string | null, uri?: string | null, slug: string, date?: string | null, status: string, blueprint?: string | null } | { __typename?: 'Entry_Lotteries_ExternalLottery', title: string, id: string, permalink?: string | null, url?: string | null, uri?: string | null, slug: string, date?: string | null, status: string, blueprint?: string | null } | { __typename?: 'Entry_Pages_Contact', title: string, id: string, permalink?: string | null, url?: string | null, uri?: string | null, slug: string, date?: string | null, status: string, blueprint?: string | null } | { __typename?: 'Entry_Pages_News', title: string, id: string, permalink?: string | null, url?: string | null, uri?: string | null, slug: string, date?: string | null, status: string, blueprint?: string | null } | { __typename?: 'Entry_Pages_Page', title: string, id: string, permalink?: string | null, url?: string | null, uri?: string | null, slug: string, date?: string | null, status: string, blueprint?: string | null } | { __typename?: 'Entry_Posts_Post', id: string, published: boolean, date?: string | null, liked_at?: string | null, number_of_likes?: number | null, text?: string | null, title: string, permalink?: string | null, url?: string | null, uri?: string | null, slug: string, status: string, blueprint?: string | null, unpublished_reason?: { __typename?: 'LabeledValue', value?: string | null, label?: string | null } | null, content?: Array<{ __typename?: 'Set_Content_Image', type: string, image?: { __typename?: 'Asset_Assets', alt?: string | null, id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_Downloads', id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_PostAssets', alt?: string | null, id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_UploadedAssets', id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_UserAssets', alt?: string | null, id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | null, logo_color: { __typename?: 'LabeledValue', value?: string | null, label?: string | null }, logo_position: { __typename?: 'LabeledValue', value?: string | null, label?: string | null } } | { __typename?: 'Set_Content_Text', type: string, text: string, background_color: { __typename?: 'LabeledValue', value?: string | null, label?: string | null } } | { __typename?: 'Set_Content_Video', type: string, video?: string | null } | null> | null } | { __typename?: 'Entry_Team_TeamMember', title: string, id: string, permalink?: string | null, url?: string | null, uri?: string | null, slug: string, date?: string | null, status: string, blueprint?: string | null } | { __typename?: 'Entry_Votings_ExternalVoting', title: string, id: string, permalink?: string | null, url?: string | null, uri?: string | null, slug: string, date?: string | null, status: string, blueprint?: string | null } | { __typename?: 'Entry_Votings_Voting', title: string, id: string, permalink?: string | null, url?: string | null, uri?: string | null, slug: string, date?: string | null, status: string, blueprint?: string | null } | { __typename?: 'NavEntryPage_FooterMainNavigation_Pages_Contact', title: string, id: string, permalink?: string | null, url?: string | null, uri?: string | null, slug: string, date?: string | null, status: string, blueprint?: string | null } | { __typename?: 'NavEntryPage_FooterMainNavigation_Pages_News', title: string, id: string, permalink?: string | null, url?: string | null, uri?: string | null, slug: string, date?: string | null, status: string, blueprint?: string | null } | { __typename?: 'NavEntryPage_FooterMainNavigation_Pages_Page', title: string, id: string, permalink?: string | null, url?: string | null, uri?: string | null, slug: string, date?: string | null, status: string, blueprint?: string | null } | { __typename?: 'NavEntryPage_FooterSecondaryNavigation_Pages_Contact', title: string, id: string, permalink?: string | null, url?: string | null, uri?: string | null, slug: string, date?: string | null, status: string, blueprint?: string | null } | { __typename?: 'NavEntryPage_FooterSecondaryNavigation_Pages_News', title: string, id: string, permalink?: string | null, url?: string | null, uri?: string | null, slug: string, date?: string | null, status: string, blueprint?: string | null } | { __typename?: 'NavEntryPage_FooterSecondaryNavigation_Pages_Page', title: string, id: string, permalink?: string | null, url?: string | null, uri?: string | null, slug: string, date?: string | null, status: string, blueprint?: string | null } | { __typename?: 'NavEntryPage_MainNavigation_Pages_Contact', title: string, id: string, permalink?: string | null, url?: string | null, uri?: string | null, slug: string, date?: string | null, status: string, blueprint?: string | null } | { __typename?: 'NavEntryPage_MainNavigation_Pages_News', title: string, id: string, permalink?: string | null, url?: string | null, uri?: string | null, slug: string, date?: string | null, status: string, blueprint?: string | null } | { __typename?: 'NavEntryPage_MainNavigation_Pages_Page', title: string, id: string, permalink?: string | null, url?: string | null, uri?: string | null, slug: string, date?: string | null, status: string, blueprint?: string | null } | null } | null> | null, seo_image?: { __typename?: 'Asset_Assets', permalink?: string | null } | { __typename?: 'Asset_Downloads', permalink?: string | null } | { __typename?: 'Asset_PostAssets', permalink?: string | null } | { __typename?: 'Asset_UploadedAssets', permalink?: string | null } | { __typename?: 'Asset_UserAssets', permalink?: string | null } | null, insert_components?: Array<{ __typename?: 'Set_InsertComponents_Banner', type: string, posts_before_insert?: number | null, title?: string | null, text?: string | null, button_link?: string | null, button_text?: string | null, background_color?: { __typename?: 'LabeledValue', value?: string | null, label?: string | null } | null } | { __typename?: 'Set_InsertComponents_BannerWithImage', type: string, posts_before_insert?: number | null, title?: string | null, text?: string | null, button_link?: string | null, button_text?: string | null, image?: { __typename?: 'Asset_Assets', alt?: string | null, id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_Downloads', id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_PostAssets', alt?: string | null, id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_UploadedAssets', id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_UserAssets', alt?: string | null, id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | null } | { __typename?: 'Set_InsertComponents_Newsletter', type: string, posts_before_insert?: number | null, title?: string | null, text?: string | null, button_text?: string | null, thank_you_text?: string | null } | null> | null } | { __typename?: 'Entry_Pages_Page', hero_link?: string | null, hero_link_text?: string | null, title: string, id: string, last_modified?: string | null, permalink?: string | null, url?: string | null, uri?: string | null, slug: string, date?: string | null, status: string, blueprint?: string | null, background_color: { __typename?: 'LabeledValue', value?: string | null, label?: string | null }, hero_type?: { __typename?: 'LabeledValue', value?: string | null, label?: string | null } | null, hero_text?: Array<{ __typename?: 'BardText', text?: string | null, type: string } | { __typename?: 'Set_HeroText_Newsletter', title?: string | null, text?: string | null, thank_you_text?: string | null, button_text?: string | null, type: string } | null> | null, hero_image?: { __typename?: 'Asset_Assets', alt?: string | null, id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_Downloads', id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_PostAssets', alt?: string | null, id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_UploadedAssets', id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_UserAssets', alt?: string | null, id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | null, components?: Array<{ __typename?: 'Set_Components_Events', type: string, background_color: { __typename?: 'LabeledValue', value?: string | null, label?: string | null } } | { __typename?: 'Set_Components_ImageGallery', type: string, background_color: { __typename?: 'LabeledValue', value?: string | null, label?: string | null }, images?: Array<{ __typename?: 'Asset_Assets', alt?: string | null, id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_Downloads', id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_PostAssets', alt?: string | null, id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_UploadedAssets', id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_UserAssets', alt?: string | null, id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | null> | null } | { __typename?: 'Set_Components_ImageWithText', type: string, title?: string | null, text?: string | null, button_link?: string | null, button_text?: string | null, background_color: { __typename?: 'LabeledValue', value?: string | null, label?: string | null }, image_position?: { __typename?: 'LabeledValue', value?: string | null, label?: string | null } | null, image?: { __typename?: 'Asset_Assets', alt?: string | null, id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_Downloads', id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_PostAssets', alt?: string | null, id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_UploadedAssets', id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_UserAssets', alt?: string | null, id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | null } | { __typename?: 'Set_Components_Team', type: string, background_color: { __typename?: 'LabeledValue', value?: string | null, label?: string | null } } | { __typename?: 'Set_Components_Teaser', type: string, title?: string | null, text?: string | null, link?: string | null, link_text?: string | null } | { __typename?: 'Set_Components_ThreeIconCards', type: string, background_color: { __typename?: 'LabeledValue', value?: string | null, label?: string | null }, icon_cards?: Array<{ __typename?: 'Set_IconCards_IconWithTextSection', type: string, icon_text?: string | null, title?: string | null, subtitle?: string | null, icon?: { __typename?: 'Asset_Assets', alt?: string | null, id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_Downloads', id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_PostAssets', alt?: string | null, id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_UploadedAssets', id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_UserAssets', alt?: string | null, id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | null, icon_hover?: { __typename?: 'Asset_Assets', alt?: string | null, id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_Downloads', id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_PostAssets', alt?: string | null, id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_UploadedAssets', id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_UserAssets', alt?: string | null, id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | null, background_color: { __typename?: 'LabeledValue', value?: string | null, label?: string | null }, text_components?: Array<{ __typename?: 'BardText', type: string, text?: string | null } | { __typename?: 'Set_TextComponents_Button', type: string, link?: string | null, text?: string | null, level?: { __typename?: 'LabeledValue', value?: string | null, label?: string | null } | null } | { __typename?: 'Set_TextComponents_Image', type: string, image?: { __typename?: 'Asset_Assets', alt?: string | null, id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_Downloads', id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_PostAssets', alt?: string | null, id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_UploadedAssets', id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_UserAssets', alt?: string | null, id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | null } | null> | null, text_width?: { __typename?: 'LabeledValue', value?: string | null, label?: string | null } | null } | null> | null } | { __typename?: 'Set_Components_TitleWithText', type: string, title?: string | null, subtitle?: string | null, background_color: { __typename?: 'LabeledValue', value?: string | null, label?: string | null }, text_components?: Array<{ __typename?: 'BardText', type: string, text?: string | null } | { __typename?: 'Set_TextComponents_Button', type: string, link?: string | null, text?: string | null, level?: { __typename?: 'LabeledValue', value?: string | null, label?: string | null } | null } | { __typename?: 'Set_TextComponents_Image', type: string, image?: { __typename?: 'Asset_Assets', alt?: string | null, id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_Downloads', id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_PostAssets', alt?: string | null, id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_UploadedAssets', id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_UserAssets', alt?: string | null, id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | null } | null> | null, text_width?: { __typename?: 'LabeledValue', value?: string | null, label?: string | null } | null } | null> | null } | { __typename?: 'Entry_Posts_Post', id: string, published: boolean, date?: string | null, liked_at?: string | null, number_of_likes?: number | null, text?: string | null, title: string, last_modified?: string | null, permalink?: string | null, url?: string | null, uri?: string | null, slug: string, status: string, blueprint?: string | null, unpublished_reason?: { __typename?: 'LabeledValue', value?: string | null, label?: string | null } | null, author: { __typename?: 'User', id?: string | null, initials?: string | null, username?: string | null, firstname?: string | null, lastname?: string | null, name?: string | null, avatar?: { __typename?: 'Asset_Assets', alt?: string | null, id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_Downloads', id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_PostAssets', alt?: string | null, id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_UploadedAssets', id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_UserAssets', alt?: string | null, id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | null, team_member?: { __typename?: 'Entry_Team_TeamMember', id: string, title: string, permalink?: string | null, uri?: string | null, url?: string | null } | null }, format?: { __typename?: 'Term_Categories_Category', slug: string, title: string, permalink?: string | null, url?: string | null, uri?: string | null } | { __typename?: 'Term_EventTypes_EventType', slug: string, title: string, permalink?: string | null, url?: string | null, uri?: string | null } | { __typename?: 'Term_Formats_Format', slug: string, title: string, permalink?: string | null, url?: string | null, uri?: string | null } | { __typename?: 'Term_Tags_Tag', slug: string, title: string, permalink?: string | null, url?: string | null, uri?: string | null } | { __typename?: 'Term_TeamFormats_TeamFormat', slug: string, title: string, permalink?: string | null, url?: string | null, uri?: string | null } | null, categories?: Array<{ __typename?: 'Term_Categories_Category', slug: string, title: string, permalink?: string | null, url?: string | null, uri?: string | null } | { __typename?: 'Term_EventTypes_EventType', slug: string, title: string, permalink?: string | null, url?: string | null, uri?: string | null } | { __typename?: 'Term_Formats_Format', slug: string, title: string, permalink?: string | null, url?: string | null, uri?: string | null } | { __typename?: 'Term_Tags_Tag', slug: string, title: string, permalink?: string | null, url?: string | null, uri?: string | null } | { __typename?: 'Term_TeamFormats_TeamFormat', slug: string, title: string, permalink?: string | null, url?: string | null, uri?: string | null } | null> | null, tags?: Array<{ __typename?: 'Term_Categories_Category', slug: string, title: string, permalink?: string | null, url?: string | null, uri?: string | null } | { __typename?: 'Term_EventTypes_EventType', slug: string, title: string, permalink?: string | null, url?: string | null, uri?: string | null } | { __typename?: 'Term_Formats_Format', slug: string, title: string, permalink?: string | null, url?: string | null, uri?: string | null } | { __typename?: 'Term_Tags_Tag', slug: string, title: string, permalink?: string | null, url?: string | null, uri?: string | null } | { __typename?: 'Term_TeamFormats_TeamFormat', slug: string, title: string, permalink?: string | null, url?: string | null, uri?: string | null } | null> | null, content?: Array<{ __typename?: 'Set_Content_Image', type: string, image?: { __typename?: 'Asset_Assets', alt?: string | null, id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_Downloads', id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_PostAssets', alt?: string | null, id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_UploadedAssets', id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_UserAssets', alt?: string | null, id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | null, logo_color: { __typename?: 'LabeledValue', value?: string | null, label?: string | null }, logo_position: { __typename?: 'LabeledValue', value?: string | null, label?: string | null } } | { __typename?: 'Set_Content_Text', type: string, text: string, background_color: { __typename?: 'LabeledValue', value?: string | null, label?: string | null } } | { __typename?: 'Set_Content_Video', type: string, video?: string | null } | null> | null } | { __typename?: 'Entry_Team_TeamMember', id: string, quote?: string | null, biography?: string | null, member_since: string, website?: string | null, facebook?: string | null, instagram?: string | null, linkedin?: string | null, twitter?: string | null, title: string, last_modified?: string | null, permalink?: string | null, url?: string | null, uri?: string | null, slug: string, date?: string | null, status: string, blueprint?: string | null, image?: { __typename?: 'Asset_Assets', alt?: string | null, id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_Downloads', id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_PostAssets', alt?: string | null, id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_UploadedAssets', id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_UserAssets', alt?: string | null, id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | null, team_formats?: Array<{ __typename?: 'Term_Categories_Category', id: string, slug: string, title: string, url?: string | null } | { __typename?: 'Term_EventTypes_EventType', id: string, slug: string, title: string, url?: string | null } | { __typename?: 'Term_Formats_Format', id: string, slug: string, title: string, url?: string | null } | { __typename?: 'Term_Tags_Tag', id: string, slug: string, title: string, url?: string | null } | { __typename?: 'Term_TeamFormats_TeamFormat', id: string, title_female: string, title_male: string, slug: string, title: string, url?: string | null } | null> | null, author: { __typename?: 'User', id?: string | null, initials?: string | null, username?: string | null, firstname?: string | null, lastname?: string | null, name?: string | null, salutation?: { __typename?: 'LabeledValue', value?: string | null, label?: string | null } | null, avatar?: { __typename?: 'Asset_Assets', alt?: string | null, id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_Downloads', id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_PostAssets', alt?: string | null, id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_UploadedAssets', id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_UserAssets', alt?: string | null, id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | null }, team_member_components?: Array<{ __typename?: 'Set_TeamMemberComponents_ImageGallery', type: string, background_color: { __typename?: 'LabeledValue', value?: string | null, label?: string | null }, images?: Array<{ __typename?: 'Asset_Assets', alt?: string | null, id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_Downloads', id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_PostAssets', alt?: string | null, id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_UploadedAssets', id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_UserAssets', alt?: string | null, id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | null> | null } | { __typename?: 'Set_TeamMemberComponents_ImageWithText', type: string, title?: string | null, text?: string | null, button_link?: string | null, button_text?: string | null, background_color: { __typename?: 'LabeledValue', value?: string | null, label?: string | null }, image_position?: { __typename?: 'LabeledValue', value?: string | null, label?: string | null } | null, image?: { __typename?: 'Asset_Assets', alt?: string | null, id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_Downloads', id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_PostAssets', alt?: string | null, id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_UploadedAssets', id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_UserAssets', alt?: string | null, id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | null } | { __typename?: 'Set_TeamMemberComponents_Posts', type: string, background_color: { __typename?: 'LabeledValue', value?: string | null, label?: string | null } } | { __typename?: 'Set_TeamMemberComponents_Teaser', type: string, title?: string | null, text?: string | null, link?: string | null, link_text?: string | null } | { __typename?: 'Set_TeamMemberComponents_TitleWithText', type: string, title?: string | null, subtitle?: string | null, background_color: { __typename?: 'LabeledValue', value?: string | null, label?: string | null }, text_components?: Array<{ __typename?: 'BardText', type: string, text?: string | null } | { __typename?: 'Set_TextComponents_Button', type: string, link?: string | null, text?: string | null, level?: { __typename?: 'LabeledValue', value?: string | null, label?: string | null } | null } | { __typename?: 'Set_TextComponents_Image', type: string, image?: { __typename?: 'Asset_Assets', alt?: string | null, id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_Downloads', id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_PostAssets', alt?: string | null, id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_UploadedAssets', id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_UserAssets', alt?: string | null, id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | null } | null> | null, text_width?: { __typename?: 'LabeledValue', value?: string | null, label?: string | null } | null } | null> | null } | { __typename?: 'Entry_Votings_ExternalVoting', title: string, id: string, last_modified?: string | null, permalink?: string | null, url?: string | null, uri?: string | null, slug: string, date?: string | null, status: string, blueprint?: string | null } | { __typename?: 'Entry_Votings_Voting', title: string, id: string, last_modified?: string | null, permalink?: string | null, url?: string | null, uri?: string | null, slug: string, date?: string | null, status: string, blueprint?: string | null } | { __typename?: 'NavEntryPage_FooterMainNavigation_Pages_Contact', title: string, id: string, last_modified?: string | null, permalink?: string | null, url?: string | null, uri?: string | null, slug: string, date?: string | null, status: string, blueprint?: string | null } | { __typename?: 'NavEntryPage_FooterMainNavigation_Pages_News', title: string, id: string, last_modified?: string | null, permalink?: string | null, url?: string | null, uri?: string | null, slug: string, date?: string | null, status: string, blueprint?: string | null } | { __typename?: 'NavEntryPage_FooterMainNavigation_Pages_Page', title: string, id: string, last_modified?: string | null, permalink?: string | null, url?: string | null, uri?: string | null, slug: string, date?: string | null, status: string, blueprint?: string | null } | { __typename?: 'NavEntryPage_FooterSecondaryNavigation_Pages_Contact', title: string, id: string, last_modified?: string | null, permalink?: string | null, url?: string | null, uri?: string | null, slug: string, date?: string | null, status: string, blueprint?: string | null } | { __typename?: 'NavEntryPage_FooterSecondaryNavigation_Pages_News', title: string, id: string, last_modified?: string | null, permalink?: string | null, url?: string | null, uri?: string | null, slug: string, date?: string | null, status: string, blueprint?: string | null } | { __typename?: 'NavEntryPage_FooterSecondaryNavigation_Pages_Page', title: string, id: string, last_modified?: string | null, permalink?: string | null, url?: string | null, uri?: string | null, slug: string, date?: string | null, status: string, blueprint?: string | null } | { __typename?: 'NavEntryPage_MainNavigation_Pages_Contact', title: string, id: string, last_modified?: string | null, permalink?: string | null, url?: string | null, uri?: string | null, slug: string, date?: string | null, status: string, blueprint?: string | null } | { __typename?: 'NavEntryPage_MainNavigation_Pages_News', title: string, id: string, last_modified?: string | null, permalink?: string | null, url?: string | null, uri?: string | null, slug: string, date?: string | null, status: string, blueprint?: string | null } | { __typename?: 'NavEntryPage_MainNavigation_Pages_Page', title: string, id: string, last_modified?: string | null, permalink?: string | null, url?: string | null, uri?: string | null, slug: string, date?: string | null, status: string, blueprint?: string | null } | null };

export type GetPostsQueryVariables = Exact<{
  filter?: InputMaybe<Scalars['JsonArgument']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  page?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type GetPostsQuery = { __typename?: 'Query', entries?: { __typename?: 'Entry_Posts_PostPagination', total: number, from?: number | null, to?: number | null, per_page: number, current_page: number, last_page: number, has_more_pages: boolean, data?: Array<{ __typename?: 'Entry_Posts_Post', title: string, id: string, permalink?: string | null, url?: string | null, uri?: string | null, slug: string, date?: string | null, status: string, blueprint?: string | null, published: boolean, liked_at?: string | null, number_of_likes?: number | null, text?: string | null, unpublished_reason?: { __typename?: 'LabeledValue', value?: string | null, label?: string | null } | null, author: { __typename?: 'User', id?: string | null, initials?: string | null, username?: string | null, firstname?: string | null, lastname?: string | null, name?: string | null, avatar?: { __typename?: 'Asset_Assets', alt?: string | null, id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_Downloads', id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_PostAssets', alt?: string | null, id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_UploadedAssets', id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_UserAssets', alt?: string | null, id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | null, team_member?: { __typename?: 'Entry_Team_TeamMember', id: string, title: string, permalink?: string | null, uri?: string | null, url?: string | null } | null }, format?: { __typename?: 'Term_Categories_Category', slug: string, title: string, permalink?: string | null, url?: string | null, uri?: string | null } | { __typename?: 'Term_EventTypes_EventType', slug: string, title: string, permalink?: string | null, url?: string | null, uri?: string | null } | { __typename?: 'Term_Formats_Format', slug: string, title: string, permalink?: string | null, url?: string | null, uri?: string | null } | { __typename?: 'Term_Tags_Tag', slug: string, title: string, permalink?: string | null, url?: string | null, uri?: string | null } | { __typename?: 'Term_TeamFormats_TeamFormat', slug: string, title: string, permalink?: string | null, url?: string | null, uri?: string | null } | null, categories?: Array<{ __typename?: 'Term_Categories_Category', slug: string, title: string, permalink?: string | null, url?: string | null, uri?: string | null } | { __typename?: 'Term_EventTypes_EventType', slug: string, title: string, permalink?: string | null, url?: string | null, uri?: string | null } | { __typename?: 'Term_Formats_Format', slug: string, title: string, permalink?: string | null, url?: string | null, uri?: string | null } | { __typename?: 'Term_Tags_Tag', slug: string, title: string, permalink?: string | null, url?: string | null, uri?: string | null } | { __typename?: 'Term_TeamFormats_TeamFormat', slug: string, title: string, permalink?: string | null, url?: string | null, uri?: string | null } | null> | null, tags?: Array<{ __typename?: 'Term_Categories_Category', slug: string, title: string, permalink?: string | null, url?: string | null, uri?: string | null } | { __typename?: 'Term_EventTypes_EventType', slug: string, title: string, permalink?: string | null, url?: string | null, uri?: string | null } | { __typename?: 'Term_Formats_Format', slug: string, title: string, permalink?: string | null, url?: string | null, uri?: string | null } | { __typename?: 'Term_Tags_Tag', slug: string, title: string, permalink?: string | null, url?: string | null, uri?: string | null } | { __typename?: 'Term_TeamFormats_TeamFormat', slug: string, title: string, permalink?: string | null, url?: string | null, uri?: string | null } | null> | null, content?: Array<{ __typename?: 'Set_Content_Image', type: string, image?: { __typename?: 'Asset_Assets', alt?: string | null, id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_Downloads', id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_PostAssets', alt?: string | null, id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_UploadedAssets', id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_UserAssets', alt?: string | null, id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | null, logo_color: { __typename?: 'LabeledValue', value?: string | null, label?: string | null }, logo_position: { __typename?: 'LabeledValue', value?: string | null, label?: string | null } } | { __typename?: 'Set_Content_Text', type: string, text: string, background_color: { __typename?: 'LabeledValue', value?: string | null, label?: string | null } } | { __typename?: 'Set_Content_Video', type: string, video?: string | null } | null> | null } | null> | null } | null };

export type GetProfileGlobalQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProfileGlobalQuery = { __typename?: 'Query', globalSet?: { __typename?: 'GlobalSet_DefaultTeaser', handle: string } | { __typename?: 'GlobalSet_Emails', handle: string } | { __typename?: 'GlobalSet_Footer', handle: string } | { __typename?: 'GlobalSet_LoginSectionCoupons', handle: string } | { __typename?: 'GlobalSet_LoginSectionCreatePost', handle: string } | { __typename?: 'GlobalSet_LoginSectionDownloads', handle: string } | { __typename?: 'GlobalSet_LoginSectionLogin', handle: string } | { __typename?: 'GlobalSet_LoginSectionLotteries', handle: string } | { __typename?: 'GlobalSet_LoginSectionMembership', handle: string } | { __typename?: 'GlobalSet_LoginSectionNewsletter', handle: string } | { __typename?: 'GlobalSet_LoginSectionProfile', current_voting_title?: string | null, current_voting_link_text?: string | null, current_lottery_title?: string | null, current_lottery_link_text?: string | null, handle: string, title: string, current_voting_background_color?: { __typename?: 'LabeledValue', value?: string | null, label?: string | null } | null, current_lottery_background_color?: { __typename?: 'LabeledValue', value?: string | null, label?: string | null } | null } | { __typename?: 'GlobalSet_LoginSectionVotings', handle: string } | { __typename?: 'GlobalSet_Shopify', handle: string } | null };

export type GetShopifyGlobalQueryVariables = Exact<{ [key: string]: never; }>;


export type GetShopifyGlobalQuery = { __typename?: 'Query', globalSet?: { __typename?: 'GlobalSet_DefaultTeaser', handle: string } | { __typename?: 'GlobalSet_Emails', handle: string } | { __typename?: 'GlobalSet_Footer', handle: string } | { __typename?: 'GlobalSet_LoginSectionCoupons', handle: string } | { __typename?: 'GlobalSet_LoginSectionCreatePost', handle: string } | { __typename?: 'GlobalSet_LoginSectionDownloads', handle: string } | { __typename?: 'GlobalSet_LoginSectionLogin', handle: string } | { __typename?: 'GlobalSet_LoginSectionLotteries', handle: string } | { __typename?: 'GlobalSet_LoginSectionMembership', handle: string } | { __typename?: 'GlobalSet_LoginSectionNewsletter', handle: string } | { __typename?: 'GlobalSet_LoginSectionProfile', handle: string } | { __typename?: 'GlobalSet_LoginSectionVotings', handle: string } | { __typename?: 'GlobalSet_Shopify', base_url?: string | null, handle: string } | null };

export type GetSimilarPostsQueryVariables = Exact<{
  post_id: Scalars['ID'];
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  page?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type GetSimilarPostsQuery = { __typename?: 'Query', similarPosts?: { __typename?: 'Entry_Posts_PostPagination', total: number, from?: number | null, to?: number | null, per_page: number, current_page: number, last_page: number, has_more_pages: boolean, data?: Array<{ __typename?: 'Entry_Posts_Post', id: string, published: boolean, date?: string | null, liked_at?: string | null, number_of_likes?: number | null, text?: string | null, title: string, permalink?: string | null, url?: string | null, uri?: string | null, slug: string, status: string, blueprint?: string | null, unpublished_reason?: { __typename?: 'LabeledValue', value?: string | null, label?: string | null } | null, author: { __typename?: 'User', id?: string | null, initials?: string | null, username?: string | null, firstname?: string | null, lastname?: string | null, name?: string | null, avatar?: { __typename?: 'Asset_Assets', alt?: string | null, id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_Downloads', id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_PostAssets', alt?: string | null, id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_UploadedAssets', id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_UserAssets', alt?: string | null, id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | null, team_member?: { __typename?: 'Entry_Team_TeamMember', id: string, title: string, permalink?: string | null, uri?: string | null, url?: string | null } | null }, format?: { __typename?: 'Term_Categories_Category', slug: string, title: string, permalink?: string | null, url?: string | null, uri?: string | null } | { __typename?: 'Term_EventTypes_EventType', slug: string, title: string, permalink?: string | null, url?: string | null, uri?: string | null } | { __typename?: 'Term_Formats_Format', slug: string, title: string, permalink?: string | null, url?: string | null, uri?: string | null } | { __typename?: 'Term_Tags_Tag', slug: string, title: string, permalink?: string | null, url?: string | null, uri?: string | null } | { __typename?: 'Term_TeamFormats_TeamFormat', slug: string, title: string, permalink?: string | null, url?: string | null, uri?: string | null } | null, categories?: Array<{ __typename?: 'Term_Categories_Category', slug: string, title: string, permalink?: string | null, url?: string | null, uri?: string | null } | { __typename?: 'Term_EventTypes_EventType', slug: string, title: string, permalink?: string | null, url?: string | null, uri?: string | null } | { __typename?: 'Term_Formats_Format', slug: string, title: string, permalink?: string | null, url?: string | null, uri?: string | null } | { __typename?: 'Term_Tags_Tag', slug: string, title: string, permalink?: string | null, url?: string | null, uri?: string | null } | { __typename?: 'Term_TeamFormats_TeamFormat', slug: string, title: string, permalink?: string | null, url?: string | null, uri?: string | null } | null> | null, tags?: Array<{ __typename?: 'Term_Categories_Category', slug: string, title: string, permalink?: string | null, url?: string | null, uri?: string | null } | { __typename?: 'Term_EventTypes_EventType', slug: string, title: string, permalink?: string | null, url?: string | null, uri?: string | null } | { __typename?: 'Term_Formats_Format', slug: string, title: string, permalink?: string | null, url?: string | null, uri?: string | null } | { __typename?: 'Term_Tags_Tag', slug: string, title: string, permalink?: string | null, url?: string | null, uri?: string | null } | { __typename?: 'Term_TeamFormats_TeamFormat', slug: string, title: string, permalink?: string | null, url?: string | null, uri?: string | null } | null> | null, content?: Array<{ __typename?: 'Set_Content_Image', type: string, image?: { __typename?: 'Asset_Assets', alt?: string | null, id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_Downloads', id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_PostAssets', alt?: string | null, id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_UploadedAssets', id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_UserAssets', alt?: string | null, id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | null, logo_color: { __typename?: 'LabeledValue', value?: string | null, label?: string | null }, logo_position: { __typename?: 'LabeledValue', value?: string | null, label?: string | null } } | { __typename?: 'Set_Content_Text', type: string, text: string, background_color: { __typename?: 'LabeledValue', value?: string | null, label?: string | null } } | { __typename?: 'Set_Content_Video', type: string, video?: string | null } | null> | null } | null> | null } | null };

export type GetSitemapQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSitemapQuery = { __typename?: 'Query', sitemap?: Array<{ __typename?: 'SitemapEntry', path: string, url: string, lastmod?: string | null, priority?: string | null, change_frequency?: string | null, alternates?: Array<string | null> | null } | null> | null };

export type GetTagsQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type GetTagsQuery = { __typename?: 'Query', taxonomy?: { __typename?: 'Taxonomy', title: string, handle: string } | null, terms?: { __typename?: 'TermInterfacePagination', total: number, from?: number | null, to?: number | null, per_page: number, current_page: number, last_page: number, has_more_pages: boolean, data?: Array<{ __typename?: 'Term_Categories_Category', id: string, slug: string, title: string, url?: string | null } | { __typename?: 'Term_EventTypes_EventType', id: string, slug: string, title: string, url?: string | null } | { __typename?: 'Term_Formats_Format', id: string, slug: string, title: string, url?: string | null } | { __typename?: 'Term_Tags_Tag', id: string, slug: string, title: string, url?: string | null } | { __typename?: 'Term_TeamFormats_TeamFormat', id: string, slug: string, title: string, url?: string | null } | null> | null } | null };

export type GetTeamFormatsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTeamFormatsQuery = { __typename?: 'Query', taxonomy?: { __typename?: 'Taxonomy', title: string, handle: string } | null, terms?: { __typename?: 'TermInterfacePagination', total: number, from?: number | null, to?: number | null, per_page: number, current_page: number, last_page: number, has_more_pages: boolean, data?: Array<{ __typename?: 'Term_Categories_Category', id: string, slug: string, title: string, url?: string | null } | { __typename?: 'Term_EventTypes_EventType', id: string, slug: string, title: string, url?: string | null } | { __typename?: 'Term_Formats_Format', id: string, slug: string, title: string, url?: string | null } | { __typename?: 'Term_Tags_Tag', id: string, slug: string, title: string, url?: string | null } | { __typename?: 'Term_TeamFormats_TeamFormat', id: string, title_female: string, title_male: string, slug: string, title: string, url?: string | null } | null> | null } | null };

export type GetTeamMemberForAuthorQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['String']>;
}>;


export type GetTeamMemberForAuthorQuery = { __typename?: 'Query', entry?: { __typename?: 'Entry_Events_Event', id: string, title: string, slug: string, url?: string | null, permalink?: string | null } | { __typename?: 'Entry_Lotteries_ExternalLottery', id: string, title: string, slug: string, url?: string | null, permalink?: string | null } | { __typename?: 'Entry_Pages_Contact', id: string, title: string, slug: string, url?: string | null, permalink?: string | null } | { __typename?: 'Entry_Pages_News', id: string, title: string, slug: string, url?: string | null, permalink?: string | null } | { __typename?: 'Entry_Pages_Page', id: string, title: string, slug: string, url?: string | null, permalink?: string | null } | { __typename?: 'Entry_Posts_Post', id: string, title: string, slug: string, url?: string | null, permalink?: string | null } | { __typename?: 'Entry_Team_TeamMember', id: string, title: string, slug: string, url?: string | null, permalink?: string | null } | { __typename?: 'Entry_Votings_ExternalVoting', id: string, title: string, slug: string, url?: string | null, permalink?: string | null } | { __typename?: 'Entry_Votings_Voting', id: string, title: string, slug: string, url?: string | null, permalink?: string | null } | { __typename?: 'NavEntryPage_FooterMainNavigation_Pages_Contact', id: string, title: string, slug: string, url?: string | null, permalink?: string | null } | { __typename?: 'NavEntryPage_FooterMainNavigation_Pages_News', id: string, title: string, slug: string, url?: string | null, permalink?: string | null } | { __typename?: 'NavEntryPage_FooterMainNavigation_Pages_Page', id: string, title: string, slug: string, url?: string | null, permalink?: string | null } | { __typename?: 'NavEntryPage_FooterSecondaryNavigation_Pages_Contact', id: string, title: string, slug: string, url?: string | null, permalink?: string | null } | { __typename?: 'NavEntryPage_FooterSecondaryNavigation_Pages_News', id: string, title: string, slug: string, url?: string | null, permalink?: string | null } | { __typename?: 'NavEntryPage_FooterSecondaryNavigation_Pages_Page', id: string, title: string, slug: string, url?: string | null, permalink?: string | null } | { __typename?: 'NavEntryPage_MainNavigation_Pages_Contact', id: string, title: string, slug: string, url?: string | null, permalink?: string | null } | { __typename?: 'NavEntryPage_MainNavigation_Pages_News', id: string, title: string, slug: string, url?: string | null, permalink?: string | null } | { __typename?: 'NavEntryPage_MainNavigation_Pages_Page', id: string, title: string, slug: string, url?: string | null, permalink?: string | null } | null };

export type GetTeamMembersQueryVariables = Exact<{
  filter?: InputMaybe<Scalars['JsonArgument']>;
  page?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type GetTeamMembersQuery = { __typename?: 'Query', entries?: { __typename?: 'EntryInterfacePagination', total: number, from?: number | null, to?: number | null, per_page: number, current_page: number, last_page: number, has_more_pages: boolean, data?: Array<{ __typename?: 'Entry_Events_Event', title: string, id: string, permalink?: string | null, url?: string | null, uri?: string | null, slug: string, date?: string | null, status: string, blueprint?: string | null } | { __typename?: 'Entry_Lotteries_ExternalLottery', title: string, id: string, permalink?: string | null, url?: string | null, uri?: string | null, slug: string, date?: string | null, status: string, blueprint?: string | null } | { __typename?: 'Entry_Pages_Contact', title: string, id: string, permalink?: string | null, url?: string | null, uri?: string | null, slug: string, date?: string | null, status: string, blueprint?: string | null } | { __typename?: 'Entry_Pages_News', title: string, id: string, permalink?: string | null, url?: string | null, uri?: string | null, slug: string, date?: string | null, status: string, blueprint?: string | null } | { __typename?: 'Entry_Pages_Page', title: string, id: string, permalink?: string | null, url?: string | null, uri?: string | null, slug: string, date?: string | null, status: string, blueprint?: string | null } | { __typename?: 'Entry_Posts_Post', title: string, id: string, permalink?: string | null, url?: string | null, uri?: string | null, slug: string, date?: string | null, status: string, blueprint?: string | null } | { __typename?: 'Entry_Team_TeamMember', id: string, title: string, permalink?: string | null, url?: string | null, uri?: string | null, slug: string, date?: string | null, status: string, blueprint?: string | null, image?: { __typename?: 'Asset_Assets', alt?: string | null, id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_Downloads', id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_PostAssets', alt?: string | null, id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_UploadedAssets', id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_UserAssets', alt?: string | null, id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | null, team_formats?: Array<{ __typename?: 'Term_Categories_Category', id: string, slug: string, title: string, url?: string | null } | { __typename?: 'Term_EventTypes_EventType', id: string, slug: string, title: string, url?: string | null } | { __typename?: 'Term_Formats_Format', id: string, slug: string, title: string, url?: string | null } | { __typename?: 'Term_Tags_Tag', id: string, slug: string, title: string, url?: string | null } | { __typename?: 'Term_TeamFormats_TeamFormat', id: string, title_female: string, title_male: string, slug: string, title: string, url?: string | null } | null> | null, author: { __typename?: 'User', id?: string | null, name?: string | null, salutation?: { __typename?: 'LabeledValue', value?: string | null, label?: string | null } | null, avatar?: { __typename?: 'Asset_Assets', alt?: string | null, id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_Downloads', id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_PostAssets', alt?: string | null, id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_UploadedAssets', id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_UserAssets', alt?: string | null, id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | null } } | { __typename?: 'Entry_Votings_ExternalVoting', title: string, id: string, permalink?: string | null, url?: string | null, uri?: string | null, slug: string, date?: string | null, status: string, blueprint?: string | null } | { __typename?: 'Entry_Votings_Voting', title: string, id: string, permalink?: string | null, url?: string | null, uri?: string | null, slug: string, date?: string | null, status: string, blueprint?: string | null } | { __typename?: 'NavEntryPage_FooterMainNavigation_Pages_Contact', title: string, id: string, permalink?: string | null, url?: string | null, uri?: string | null, slug: string, date?: string | null, status: string, blueprint?: string | null } | { __typename?: 'NavEntryPage_FooterMainNavigation_Pages_News', title: string, id: string, permalink?: string | null, url?: string | null, uri?: string | null, slug: string, date?: string | null, status: string, blueprint?: string | null } | { __typename?: 'NavEntryPage_FooterMainNavigation_Pages_Page', title: string, id: string, permalink?: string | null, url?: string | null, uri?: string | null, slug: string, date?: string | null, status: string, blueprint?: string | null } | { __typename?: 'NavEntryPage_FooterSecondaryNavigation_Pages_Contact', title: string, id: string, permalink?: string | null, url?: string | null, uri?: string | null, slug: string, date?: string | null, status: string, blueprint?: string | null } | { __typename?: 'NavEntryPage_FooterSecondaryNavigation_Pages_News', title: string, id: string, permalink?: string | null, url?: string | null, uri?: string | null, slug: string, date?: string | null, status: string, blueprint?: string | null } | { __typename?: 'NavEntryPage_FooterSecondaryNavigation_Pages_Page', title: string, id: string, permalink?: string | null, url?: string | null, uri?: string | null, slug: string, date?: string | null, status: string, blueprint?: string | null } | { __typename?: 'NavEntryPage_MainNavigation_Pages_Contact', title: string, id: string, permalink?: string | null, url?: string | null, uri?: string | null, slug: string, date?: string | null, status: string, blueprint?: string | null } | { __typename?: 'NavEntryPage_MainNavigation_Pages_News', title: string, id: string, permalink?: string | null, url?: string | null, uri?: string | null, slug: string, date?: string | null, status: string, blueprint?: string | null } | { __typename?: 'NavEntryPage_MainNavigation_Pages_Page', title: string, id: string, permalink?: string | null, url?: string | null, uri?: string | null, slug: string, date?: string | null, status: string, blueprint?: string | null } | null> | null } | null };

export type GetVotingsGlobalQueryVariables = Exact<{ [key: string]: never; }>;


export type GetVotingsGlobalQuery = { __typename?: 'Query', globalSet?: { __typename?: 'GlobalSet_DefaultTeaser', handle: string } | { __typename?: 'GlobalSet_Emails', handle: string } | { __typename?: 'GlobalSet_Footer', handle: string } | { __typename?: 'GlobalSet_LoginSectionCoupons', handle: string } | { __typename?: 'GlobalSet_LoginSectionCreatePost', handle: string } | { __typename?: 'GlobalSet_LoginSectionDownloads', handle: string } | { __typename?: 'GlobalSet_LoginSectionLogin', handle: string } | { __typename?: 'GlobalSet_LoginSectionLotteries', handle: string } | { __typename?: 'GlobalSet_LoginSectionMembership', handle: string } | { __typename?: 'GlobalSet_LoginSectionNewsletter', handle: string } | { __typename?: 'GlobalSet_LoginSectionProfile', handle: string } | { __typename?: 'GlobalSet_LoginSectionVotings', text?: string | null, handle: string, title: string } | { __typename?: 'GlobalSet_Shopify', handle: string } | null };

export type GetVotingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetVotingsQuery = { __typename?: 'Query', entries?: { __typename?: 'EntryInterfacePagination', data?: Array<{ __typename?: 'Entry_Events_Event', title: string, id: string, permalink?: string | null, url?: string | null, uri?: string | null, slug: string, date?: string | null, status: string, blueprint?: string | null } | { __typename?: 'Entry_Lotteries_ExternalLottery', title: string, id: string, permalink?: string | null, url?: string | null, uri?: string | null, slug: string, date?: string | null, status: string, blueprint?: string | null } | { __typename?: 'Entry_Pages_Contact', title: string, id: string, permalink?: string | null, url?: string | null, uri?: string | null, slug: string, date?: string | null, status: string, blueprint?: string | null } | { __typename?: 'Entry_Pages_News', title: string, id: string, permalink?: string | null, url?: string | null, uri?: string | null, slug: string, date?: string | null, status: string, blueprint?: string | null } | { __typename?: 'Entry_Pages_Page', title: string, id: string, permalink?: string | null, url?: string | null, uri?: string | null, slug: string, date?: string | null, status: string, blueprint?: string | null } | { __typename?: 'Entry_Posts_Post', title: string, id: string, permalink?: string | null, url?: string | null, uri?: string | null, slug: string, date?: string | null, status: string, blueprint?: string | null } | { __typename?: 'Entry_Team_TeamMember', title: string, id: string, permalink?: string | null, url?: string | null, uri?: string | null, slug: string, date?: string | null, status: string, blueprint?: string | null } | { __typename?: 'Entry_Votings_ExternalVoting', id: string, title: string, text?: string | null, link?: string | null, permalink?: string | null, url?: string | null, uri?: string | null, slug: string, date?: string | null, status: string, blueprint?: string | null, window?: { __typename?: 'DateRange', start?: string | null, end?: string | null } | null } | { __typename?: 'Entry_Votings_Voting', title: string, id: string, permalink?: string | null, url?: string | null, uri?: string | null, slug: string, date?: string | null, status: string, blueprint?: string | null } | { __typename?: 'NavEntryPage_FooterMainNavigation_Pages_Contact', title: string, id: string, permalink?: string | null, url?: string | null, uri?: string | null, slug: string, date?: string | null, status: string, blueprint?: string | null } | { __typename?: 'NavEntryPage_FooterMainNavigation_Pages_News', title: string, id: string, permalink?: string | null, url?: string | null, uri?: string | null, slug: string, date?: string | null, status: string, blueprint?: string | null } | { __typename?: 'NavEntryPage_FooterMainNavigation_Pages_Page', title: string, id: string, permalink?: string | null, url?: string | null, uri?: string | null, slug: string, date?: string | null, status: string, blueprint?: string | null } | { __typename?: 'NavEntryPage_FooterSecondaryNavigation_Pages_Contact', title: string, id: string, permalink?: string | null, url?: string | null, uri?: string | null, slug: string, date?: string | null, status: string, blueprint?: string | null } | { __typename?: 'NavEntryPage_FooterSecondaryNavigation_Pages_News', title: string, id: string, permalink?: string | null, url?: string | null, uri?: string | null, slug: string, date?: string | null, status: string, blueprint?: string | null } | { __typename?: 'NavEntryPage_FooterSecondaryNavigation_Pages_Page', title: string, id: string, permalink?: string | null, url?: string | null, uri?: string | null, slug: string, date?: string | null, status: string, blueprint?: string | null } | { __typename?: 'NavEntryPage_MainNavigation_Pages_Contact', title: string, id: string, permalink?: string | null, url?: string | null, uri?: string | null, slug: string, date?: string | null, status: string, blueprint?: string | null } | { __typename?: 'NavEntryPage_MainNavigation_Pages_News', title: string, id: string, permalink?: string | null, url?: string | null, uri?: string | null, slug: string, date?: string | null, status: string, blueprint?: string | null } | { __typename?: 'NavEntryPage_MainNavigation_Pages_Page', title: string, id: string, permalink?: string | null, url?: string | null, uri?: string | null, slug: string, date?: string | null, status: string, blueprint?: string | null } | null> | null } | null };

export type CreateLikeMutationVariables = Exact<{
  entryId: Scalars['ID'];
}>;


export type CreateLikeMutation = { __typename?: 'Mutation', entry?: { __typename?: 'Entry_Posts_Post', id: string, slug: string, title: string, liked_at?: string | null, number_of_likes?: number | null } | null };

export type DeleteLikeMutationVariables = Exact<{
  entryId: Scalars['ID'];
}>;


export type DeleteLikeMutation = { __typename?: 'Mutation', entry?: { __typename?: 'Entry_Posts_Post', id: string, slug: string, title: string, liked_at?: string | null, number_of_likes?: number | null } | null };

export type SubscribeToNewsletterMutationVariables = Exact<{
  email: Scalars['String'];
  name: Scalars['String'];
}>;


export type SubscribeToNewsletterMutation = { __typename?: 'Mutation', result?: { __typename?: 'NewsletterSubscriptionResultType', success?: boolean | null, message?: string | null } | null };

export type ParseMarkdownMutationVariables = Exact<{
  text?: InputMaybe<Scalars['String']>;
}>;


export type ParseMarkdownMutation = { __typename?: 'Mutation', markdown?: string | null };

export type SubscribeToNewsletterListMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type SubscribeToNewsletterListMutation = { __typename?: 'Mutation', subscribeToNewsletterList?: { __typename?: 'NewsletterSubscriptionResultType', success?: boolean | null, message?: string | null } | null };

export type UnsubscribeFromNewsletterListMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type UnsubscribeFromNewsletterListMutation = { __typename?: 'Mutation', unsubscribeFromNewsletterList?: { __typename?: 'NewsletterSubscriptionResultType', success?: boolean | null, message?: string | null } | null };

export type UpdateUserMutationVariables = Exact<{
  salutation?: InputMaybe<Scalars['String']>;
  firstname?: InputMaybe<Scalars['String']>;
  lastname?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  street?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', user: { __typename?: 'User', id?: string | null, firstname?: string | null, lastname?: string | null, name?: string | null, email?: string | null, username?: string | null, initials?: string | null, phone?: string | null, street?: string | null, zip?: string | null, city?: string | null, created_at?: string | null, salutation?: { __typename?: 'LabeledValue', value?: string | null, label?: string | null } | null, member_category?: { __typename?: 'LabeledValue', value?: string | null, label?: string | null } | null, artist_category?: { __typename?: 'LabeledValue', value?: string | null, label?: string | null } | null, avatar?: { __typename?: 'Asset_Assets', alt?: string | null, id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_Downloads', id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_PostAssets', alt?: string | null, id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_UploadedAssets', id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_UserAssets', alt?: string | null, id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | null } };

export type UpdateUserPasswordMutationVariables = Exact<{
  username?: InputMaybe<Scalars['String']>;
  current_password?: InputMaybe<Scalars['String']>;
  new_password?: InputMaybe<Scalars['String']>;
  new_password_confirmation?: InputMaybe<Scalars['String']>;
}>;


export type UpdateUserPasswordMutation = { __typename?: 'Mutation', user: { __typename?: 'User', id?: string | null, firstname?: string | null, lastname?: string | null, name?: string | null, email?: string | null, username?: string | null, initials?: string | null, phone?: string | null, street?: string | null, zip?: string | null, city?: string | null, created_at?: string | null, salutation?: { __typename?: 'LabeledValue', value?: string | null, label?: string | null } | null, member_category?: { __typename?: 'LabeledValue', value?: string | null, label?: string | null } | null, artist_category?: { __typename?: 'LabeledValue', value?: string | null, label?: string | null } | null, avatar?: { __typename?: 'Asset_Assets', alt?: string | null, id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_Downloads', id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_PostAssets', alt?: string | null, id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_UploadedAssets', id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | { __typename?: 'Asset_UserAssets', alt?: string | null, id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } | null } };

export type UploadFileMutationVariables = Exact<{
  file?: InputMaybe<Scalars['Upload']>;
}>;


export type UploadFileMutation = { __typename?: 'Mutation', uploadFile: { __typename?: 'Asset_UploadedAssets', id: string, focus_css?: string | null, height?: number | null, ratio?: number | null, width?: number | null, permalink?: string | null, url?: string | null, extension: string, path: string, orientation?: string | null } };


export const CreatePostDocument = `
    mutation CreatePost($title: String!, $format: String!, $categories: [String], $tags: [String], $allow_sharing_with_third_parties: Boolean!, $allow_sharing_with_we_publish: Boolean!, $text: String, $media: [UploadedPostMediaWrapper]) {
  createPost(
    title: $title
    format: $format
    categories: $categories
    tags: $tags
    allow_sharing_with_third_parties: $allow_sharing_with_third_parties
    allow_sharing_with_we_publish: $allow_sharing_with_we_publish
    text: $text
    media: $media
  ) {
    id
    title
    slug
  }
}
    `;
export const useCreatePostMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreatePostMutation, TError, CreatePostMutationVariables, TContext>) =>
    useMutation<CreatePostMutation, TError, CreatePostMutationVariables, TContext>(
      ['CreatePost'],
      (variables?: CreatePostMutationVariables) => gqlFetcher<CreatePostMutation, CreatePostMutationVariables>(CreatePostDocument, variables)(),
      options
    );
export const GetAuthorPostAmountsDocument = `
    query GetAuthorPostAmounts($author: String) {
  publishedPosts: filteredPosts(filter: {author: $author, published: true}) {
    total
  }
  newPosts: filteredPosts(
    filter: {author: $author, published: false, unpublished_reason: "new"}
  ) {
    total
  }
  reservedPosts: filteredPosts(
    filter: {author: $author, published: false, unpublished_reason: "reserved"}
  ) {
    total
  }
}
    `;
export const useGetAuthorPostAmountsQuery = <
      TData = GetAuthorPostAmountsQuery,
      TError = unknown
    >(
      variables?: GetAuthorPostAmountsQueryVariables,
      options?: UseQueryOptions<GetAuthorPostAmountsQuery, TError, TData>
    ) =>
    useQuery<GetAuthorPostAmountsQuery, TError, TData>(
      variables === undefined ? ['GetAuthorPostAmounts'] : ['GetAuthorPostAmounts', variables],
      gqlFetcher<GetAuthorPostAmountsQuery, GetAuthorPostAmountsQueryVariables>(GetAuthorPostAmountsDocument, variables),
      options
    );
export const GetAuthorsDocument = `
    query GetAuthors($query: String, $limit: Int = 10) {
  entries(
    collection: "team"
    sort: "name"
    filter: {title: {contains: $query}}
    limit: $limit
  ) {
    total
    from
    to
    per_page
    current_page
    last_page
    has_more_pages
    data {
      title
      id
      permalink
      url
      uri
      slug
      date
      status
      blueprint
      ... on Entry_Team_TeamMember {
        id
        image {
          id
          focus_css
          height
          ratio
          width
          permalink
          url
          extension
          path
          orientation
          ... on Asset_Assets {
            alt
          }
          ... on Asset_UserAssets {
            alt
          }
          ... on Asset_PostAssets {
            alt
          }
        }
        team_formats {
          id
          slug
          title
          url
          ... on Term_TeamFormats_TeamFormat {
            id
            title_female
            title_male
          }
        }
        author {
          id
          name
          salutation {
            value
            label
          }
          avatar {
            id
            focus_css
            height
            ratio
            width
            permalink
            url
            extension
            path
            orientation
            ... on Asset_Assets {
              alt
            }
            ... on Asset_UserAssets {
              alt
            }
            ... on Asset_PostAssets {
              alt
            }
          }
        }
      }
    }
  }
}
    `;
export const useGetAuthorsQuery = <
      TData = GetAuthorsQuery,
      TError = unknown
    >(
      variables?: GetAuthorsQueryVariables,
      options?: UseQueryOptions<GetAuthorsQuery, TError, TData>
    ) =>
    useQuery<GetAuthorsQuery, TError, TData>(
      variables === undefined ? ['GetAuthors'] : ['GetAuthors', variables],
      gqlFetcher<GetAuthorsQuery, GetAuthorsQueryVariables>(GetAuthorsDocument, variables),
      options
    );
export const GetCategoriesDocument = `
    query GetCategories($query: String, $limit: Int = 1000) {
  taxonomy(handle: "categories") {
    title
    handle
  }
  terms(
    taxonomy: "categories"
    sort: "title"
    filter: {title: {contains: $query}}
    limit: $limit
  ) {
    total
    from
    to
    per_page
    current_page
    last_page
    has_more_pages
    data {
      id
      slug
      title
      url
    }
  }
}
    `;
export const useGetCategoriesQuery = <
      TData = GetCategoriesQuery,
      TError = unknown
    >(
      variables?: GetCategoriesQueryVariables,
      options?: UseQueryOptions<GetCategoriesQuery, TError, TData>
    ) =>
    useQuery<GetCategoriesQuery, TError, TData>(
      variables === undefined ? ['GetCategories'] : ['GetCategories', variables],
      gqlFetcher<GetCategoriesQuery, GetCategoriesQueryVariables>(GetCategoriesDocument, variables),
      options
    );
export const GetCouponsGlobalDocument = `
    query GetCouponsGlobal {
  globalSet(handle: "login_section_coupons") {
    handle
    ... on GlobalSet_LoginSectionCoupons {
      title: section_title
      text
      personal_coupon_title
      personal_coupon_text
      personal_coupon_image {
        id
        focus_css
        height
        ratio
        width
        permalink
        url
        extension
        path
        orientation
        ... on Asset_Assets {
          alt
        }
        ... on Asset_UserAssets {
          alt
        }
        ... on Asset_PostAssets {
          alt
        }
      }
    }
  }
  shopify: globalSet(handle: "shopify") {
    handle
    ... on GlobalSet_Shopify {
      base_url
    }
  }
}
    `;
export const useGetCouponsGlobalQuery = <
      TData = GetCouponsGlobalQuery,
      TError = unknown
    >(
      variables?: GetCouponsGlobalQueryVariables,
      options?: UseQueryOptions<GetCouponsGlobalQuery, TError, TData>
    ) =>
    useQuery<GetCouponsGlobalQuery, TError, TData>(
      variables === undefined ? ['GetCouponsGlobal'] : ['GetCouponsGlobal', variables],
      gqlFetcher<GetCouponsGlobalQuery, GetCouponsGlobalQueryVariables>(GetCouponsGlobalDocument, variables),
      options
    );
export const GetCreatePostGlobalDocument = `
    query GetCreatePostGlobal {
  globalSet(handle: "login_section_create_post") {
    handle
    ... on GlobalSet_LoginSectionCreatePost {
      title: section_title
      text
      show_allow_sharing_with_third_parties_field
      allow_sharing_with_third_parties_description
      show_allow_sharing_with_we_publish_field
      allow_sharing_with_we_publish_description
    }
  }
}
    `;
export const useGetCreatePostGlobalQuery = <
      TData = GetCreatePostGlobalQuery,
      TError = unknown
    >(
      variables?: GetCreatePostGlobalQueryVariables,
      options?: UseQueryOptions<GetCreatePostGlobalQuery, TError, TData>
    ) =>
    useQuery<GetCreatePostGlobalQuery, TError, TData>(
      variables === undefined ? ['GetCreatePostGlobal'] : ['GetCreatePostGlobal', variables],
      gqlFetcher<GetCreatePostGlobalQuery, GetCreatePostGlobalQueryVariables>(GetCreatePostGlobalDocument, variables),
      options
    );
export const GetCurrentUserDocument = `
    query GetCurrentUser {
  user: me {
    id
    firstname
    lastname
    name
    salutation {
      value
      label
    }
    email
    username
    initials
    phone
    street
    zip
    city
    created_at
    groups {
      handle
      title
    }
    permissions
    member_category {
      value
      label
    }
    artist_category {
      value
      label
    }
    avatar {
      id
      focus_css
      height
      ratio
      width
      permalink
      url
      extension
      path
      orientation
      ... on Asset_Assets {
        alt
      }
      ... on Asset_UserAssets {
        alt
      }
      ... on Asset_PostAssets {
        alt
      }
    }
    coupon_code
    valid_membership_until
    history {
      productId
      purchaseId
      name
      amount
      validity {
        start
        end
      }
    }
  }
}
    `;
export const useGetCurrentUserQuery = <
      TData = GetCurrentUserQuery,
      TError = unknown
    >(
      variables?: GetCurrentUserQueryVariables,
      options?: UseQueryOptions<GetCurrentUserQuery, TError, TData>
    ) =>
    useQuery<GetCurrentUserQuery, TError, TData>(
      variables === undefined ? ['GetCurrentUser'] : ['GetCurrentUser', variables],
      gqlFetcher<GetCurrentUserQuery, GetCurrentUserQueryVariables>(GetCurrentUserDocument, variables),
      options
    );
export const GetDownloadsGlobalDocument = `
    query GetDownloadsGlobal {
  globalSet(handle: "login_section_downloads") {
    handle
    ... on GlobalSet_LoginSectionDownloads {
      title: section_title
      text
    }
  }
}
    `;
export const useGetDownloadsGlobalQuery = <
      TData = GetDownloadsGlobalQuery,
      TError = unknown
    >(
      variables?: GetDownloadsGlobalQueryVariables,
      options?: UseQueryOptions<GetDownloadsGlobalQuery, TError, TData>
    ) =>
    useQuery<GetDownloadsGlobalQuery, TError, TData>(
      variables === undefined ? ['GetDownloadsGlobal'] : ['GetDownloadsGlobal', variables],
      gqlFetcher<GetDownloadsGlobalQuery, GetDownloadsGlobalQueryVariables>(GetDownloadsGlobalDocument, variables),
      options
    );
export const GetDownloadsDocument = `
    query GetDownloads {
  assets(container: "downloads", limit: 1000) {
    data {
      ... on Asset_Downloads {
        id
        title
        description
        path
        download_url
      }
    }
  }
}
    `;
export const useGetDownloadsQuery = <
      TData = GetDownloadsQuery,
      TError = unknown
    >(
      variables?: GetDownloadsQueryVariables,
      options?: UseQueryOptions<GetDownloadsQuery, TError, TData>
    ) =>
    useQuery<GetDownloadsQuery, TError, TData>(
      variables === undefined ? ['GetDownloads'] : ['GetDownloads', variables],
      gqlFetcher<GetDownloadsQuery, GetDownloadsQueryVariables>(GetDownloadsDocument, variables),
      options
    );
export const GetEventTypesDocument = `
    query GetEventTypes {
  taxonomy(handle: "event_types") {
    title
    handle
  }
  terms(taxonomy: "event_types", sort: "title") {
    total
    from
    to
    per_page
    current_page
    last_page
    has_more_pages
    data {
      id
      slug
      title
      url
    }
  }
}
    `;
export const useGetEventTypesQuery = <
      TData = GetEventTypesQuery,
      TError = unknown
    >(
      variables?: GetEventTypesQueryVariables,
      options?: UseQueryOptions<GetEventTypesQuery, TError, TData>
    ) =>
    useQuery<GetEventTypesQuery, TError, TData>(
      variables === undefined ? ['GetEventTypes'] : ['GetEventTypes', variables],
      gqlFetcher<GetEventTypesQuery, GetEventTypesQueryVariables>(GetEventTypesDocument, variables),
      options
    );
export const GetEventsDocument = `
    query GetEvents($filter: JsonArgument, $sort: [String] = "date asc", $page: Int = 1, $limit: Int = 10) {
  entries(
    collection: "events"
    sort: $sort
    filter: $filter
    limit: $limit
    page: $page
  ) {
    total
    from
    to
    per_page
    current_page
    last_page
    has_more_pages
    data {
      title
      id
      permalink
      url
      uri
      slug
      date
      status
      blueprint
      ... on Entry_Events_Event {
        id
        event_types {
          slug
          title
          permalink
          url
          uri
        }
        description
        date
        location
        location_link
        tickets_link
        image {
          id
          focus_css
          height
          ratio
          width
          permalink
          url
          extension
          path
          orientation
          ... on Asset_Assets {
            alt
          }
          ... on Asset_UserAssets {
            alt
          }
          ... on Asset_PostAssets {
            alt
          }
        }
      }
    }
  }
}
    `;
export const useGetEventsQuery = <
      TData = GetEventsQuery,
      TError = unknown
    >(
      variables?: GetEventsQueryVariables,
      options?: UseQueryOptions<GetEventsQuery, TError, TData>
    ) =>
    useQuery<GetEventsQuery, TError, TData>(
      variables === undefined ? ['GetEvents'] : ['GetEvents', variables],
      gqlFetcher<GetEventsQuery, GetEventsQueryVariables>(GetEventsDocument, variables),
      options
    );
export const GetFormatsDocument = `
    query GetFormats($query: String, $limit: Int = 1000) {
  taxonomy(handle: "formats") {
    title
    handle
  }
  terms(
    taxonomy: "formats"
    sort: "title"
    filter: {title: {contains: $query}}
    limit: $limit
  ) {
    total
    from
    to
    per_page
    current_page
    last_page
    has_more_pages
    data {
      id
      slug
      title
      url
    }
  }
}
    `;
export const useGetFormatsQuery = <
      TData = GetFormatsQuery,
      TError = unknown
    >(
      variables?: GetFormatsQueryVariables,
      options?: UseQueryOptions<GetFormatsQuery, TError, TData>
    ) =>
    useQuery<GetFormatsQuery, TError, TData>(
      variables === undefined ? ['GetFormats'] : ['GetFormats', variables],
      gqlFetcher<GetFormatsQuery, GetFormatsQueryVariables>(GetFormatsDocument, variables),
      options
    );
export const GetGlobalsDocument = `
    query GetGlobals {
  main_navigation: nav(handle: "main_navigation") {
    handle
    title
    tree {
      page {
        id
        entry_id
        title
        url
        permalink
        ... on NavBasicPage_MainNavigation {
          highlight
        }
        ... on NavEntryPage_MainNavigation_Pages_Page {
          highlight
        }
        ... on NavEntryPage_MainNavigation_Pages_News {
          highlight
        }
      }
      children {
        page {
          id
          entry_id
          title
          url
          permalink
          ... on NavBasicPage_MainNavigation {
            highlight
          }
          ... on NavEntryPage_MainNavigation_Pages_Page {
            highlight
          }
          ... on NavEntryPage_MainNavigation_Pages_News {
            highlight
          }
        }
      }
    }
  }
  footer_main_navigation: nav(handle: "footer_main_navigation") {
    handle
    title
    tree {
      page {
        id
        entry_id
        title
        url
        permalink
      }
    }
  }
  footer_secondary_navigation: nav(handle: "footer_secondary_navigation") {
    handle
    title
    tree {
      page {
        id
        entry_id
        title
        url
        permalink
      }
    }
  }
  footer: globalSet(handle: "footer") {
    handle
    ... on GlobalSet_Footer {
      copyright_text
      newsletter_title
      newsletter_button_text
      newsletter_thank_you_text
      facebook
      instagram
      linkedin
      twitter
    }
  }
}
    `;
export const useGetGlobalsQuery = <
      TData = GetGlobalsQuery,
      TError = unknown
    >(
      variables?: GetGlobalsQueryVariables,
      options?: UseQueryOptions<GetGlobalsQuery, TError, TData>
    ) =>
    useQuery<GetGlobalsQuery, TError, TData>(
      variables === undefined ? ['GetGlobals'] : ['GetGlobals', variables],
      gqlFetcher<GetGlobalsQuery, GetGlobalsQueryVariables>(GetGlobalsDocument, variables),
      options
    );
export const GetLoginGlobalDocument = `
    query GetLoginGlobal {
  globalSet(handle: "login_section_login") {
    handle
    ... on GlobalSet_LoginSectionLogin {
      login_title
      login_button_text
      register_title
      register_text {
        ... on BardText {
          type
          text
        }
        ... on Set_RegisterText_Button {
          type
          link
          text
          level {
            value
            label
          }
        }
        ... on Set_RegisterText_Image {
          type
          image {
            id
            focus_css
            height
            ratio
            width
            permalink
            url
            extension
            path
            orientation
            ... on Asset_Assets {
              alt
            }
            ... on Asset_UserAssets {
              alt
            }
            ... on Asset_PostAssets {
              alt
            }
          }
        }
      }
    }
  }
}
    `;
export const useGetLoginGlobalQuery = <
      TData = GetLoginGlobalQuery,
      TError = unknown
    >(
      variables?: GetLoginGlobalQueryVariables,
      options?: UseQueryOptions<GetLoginGlobalQuery, TError, TData>
    ) =>
    useQuery<GetLoginGlobalQuery, TError, TData>(
      variables === undefined ? ['GetLoginGlobal'] : ['GetLoginGlobal', variables],
      gqlFetcher<GetLoginGlobalQuery, GetLoginGlobalQueryVariables>(GetLoginGlobalDocument, variables),
      options
    );
export const GetLotteriesGlobalDocument = `
    query GetLotteriesGlobal {
  globalSet(handle: "login_section_lotteries") {
    handle
    ... on GlobalSet_LoginSectionLotteries {
      title: section_title
      text
    }
  }
}
    `;
export const useGetLotteriesGlobalQuery = <
      TData = GetLotteriesGlobalQuery,
      TError = unknown
    >(
      variables?: GetLotteriesGlobalQueryVariables,
      options?: UseQueryOptions<GetLotteriesGlobalQuery, TError, TData>
    ) =>
    useQuery<GetLotteriesGlobalQuery, TError, TData>(
      variables === undefined ? ['GetLotteriesGlobal'] : ['GetLotteriesGlobal', variables],
      gqlFetcher<GetLotteriesGlobalQuery, GetLotteriesGlobalQueryVariables>(GetLotteriesGlobalDocument, variables),
      options
    );
export const GetLotteriesDocument = `
    query GetLotteries {
  entries(collection: "lotteries", limit: 1000, sort: "date asc") {
    data {
      title
      id
      permalink
      url
      uri
      slug
      date
      status
      blueprint
      ... on Entry_Lotteries_ExternalLottery {
        id
        title
        text
        link
        window {
          start
          end
        }
      }
    }
  }
}
    `;
export const useGetLotteriesQuery = <
      TData = GetLotteriesQuery,
      TError = unknown
    >(
      variables?: GetLotteriesQueryVariables,
      options?: UseQueryOptions<GetLotteriesQuery, TError, TData>
    ) =>
    useQuery<GetLotteriesQuery, TError, TData>(
      variables === undefined ? ['GetLotteries'] : ['GetLotteries', variables],
      gqlFetcher<GetLotteriesQuery, GetLotteriesQueryVariables>(GetLotteriesDocument, variables),
      options
    );
export const GetMembershipGlobalDocument = `
    query GetMembershipGlobal {
  globalSet(handle: "login_section_membership") {
    handle
    ... on GlobalSet_LoginSectionMembership {
      title: section_title
      text
    }
  }
}
    `;
export const useGetMembershipGlobalQuery = <
      TData = GetMembershipGlobalQuery,
      TError = unknown
    >(
      variables?: GetMembershipGlobalQueryVariables,
      options?: UseQueryOptions<GetMembershipGlobalQuery, TError, TData>
    ) =>
    useQuery<GetMembershipGlobalQuery, TError, TData>(
      variables === undefined ? ['GetMembershipGlobal'] : ['GetMembershipGlobal', variables],
      gqlFetcher<GetMembershipGlobalQuery, GetMembershipGlobalQueryVariables>(GetMembershipGlobalDocument, variables),
      options
    );
export const GetNewsletterGlobalDocument = `
    query GetNewsletterGlobal {
  globalSet(handle: "login_section_newsletter") {
    handle
    ... on GlobalSet_LoginSectionNewsletter {
      title: section_title
      text
    }
  }
}
    `;
export const useGetNewsletterGlobalQuery = <
      TData = GetNewsletterGlobalQuery,
      TError = unknown
    >(
      variables?: GetNewsletterGlobalQueryVariables,
      options?: UseQueryOptions<GetNewsletterGlobalQuery, TError, TData>
    ) =>
    useQuery<GetNewsletterGlobalQuery, TError, TData>(
      variables === undefined ? ['GetNewsletterGlobal'] : ['GetNewsletterGlobal', variables],
      gqlFetcher<GetNewsletterGlobalQuery, GetNewsletterGlobalQueryVariables>(GetNewsletterGlobalDocument, variables),
      options
    );
export const GetNewsletterListsDocument = `
    query GetNewsletterLists {
  newsletterLists {
    id
    name
    subscribed
  }
}
    `;
export const useGetNewsletterListsQuery = <
      TData = GetNewsletterListsQuery,
      TError = unknown
    >(
      variables?: GetNewsletterListsQueryVariables,
      options?: UseQueryOptions<GetNewsletterListsQuery, TError, TData>
    ) =>
    useQuery<GetNewsletterListsQuery, TError, TData>(
      variables === undefined ? ['GetNewsletterLists'] : ['GetNewsletterLists', variables],
      gqlFetcher<GetNewsletterListsQuery, GetNewsletterListsQueryVariables>(GetNewsletterListsDocument, variables),
      options
    );
export const GetNumberOfPostsByAuthorDocument = `
    query GetNumberOfPostsByAuthor($userId: String) {
  entries(collection: "posts", filter: {author: {is: $userId}}) {
    total
  }
}
    `;
export const useGetNumberOfPostsByAuthorQuery = <
      TData = GetNumberOfPostsByAuthorQuery,
      TError = unknown
    >(
      variables?: GetNumberOfPostsByAuthorQueryVariables,
      options?: UseQueryOptions<GetNumberOfPostsByAuthorQuery, TError, TData>
    ) =>
    useQuery<GetNumberOfPostsByAuthorQuery, TError, TData>(
      variables === undefined ? ['GetNumberOfPostsByAuthor'] : ['GetNumberOfPostsByAuthor', variables],
      gqlFetcher<GetNumberOfPostsByAuthorQuery, GetNumberOfPostsByAuthorQueryVariables>(GetNumberOfPostsByAuthorDocument, variables),
      options
    );
export const GetPageBySlugDocument = `
    query GetPageBySlug($uri: String, $filter: JsonArgument) {
  entry(uri: $uri, filter: $filter) {
    title
    id
    last_modified
    permalink
    url
    uri
    slug
    date
    status
    blueprint
    ... on Entry_Pages_Page {
      background_color {
        value
        label
      }
      hero_type {
        value
        label
      }
      hero_text {
        ... on Set_HeroText_Newsletter {
          title
          text
          thank_you_text
          button_text
          type
        }
        ... on BardText {
          text
          type
        }
      }
      hero_link
      hero_link_text
      hero_image {
        id
        focus_css
        height
        ratio
        width
        permalink
        url
        extension
        path
        orientation
        ... on Asset_Assets {
          alt
        }
        ... on Asset_UserAssets {
          alt
        }
        ... on Asset_PostAssets {
          alt
        }
      }
      components {
        ... on Set_Components_TitleWithText {
          type
          background_color {
            value
            label
          }
          title
          subtitle
          text_components {
            ... on BardText {
              type
              text
            }
            ... on Set_TextComponents_Button {
              type
              link
              text
              level {
                value
                label
              }
            }
            ... on Set_TextComponents_Image {
              type
              image {
                id
                focus_css
                height
                ratio
                width
                permalink
                url
                extension
                path
                orientation
                ... on Asset_Assets {
                  alt
                }
                ... on Asset_UserAssets {
                  alt
                }
                ... on Asset_PostAssets {
                  alt
                }
              }
            }
          }
          text_width {
            value
            label
          }
        }
        ... on Set_Components_ImageWithText {
          type
          background_color {
            value
            label
          }
          title
          text
          button_link
          button_text
          image_position {
            value
            label
          }
          image {
            id
            focus_css
            height
            ratio
            width
            permalink
            url
            extension
            path
            orientation
            ... on Asset_Assets {
              alt
            }
            ... on Asset_UserAssets {
              alt
            }
            ... on Asset_PostAssets {
              alt
            }
          }
        }
        ... on Set_Components_Teaser {
          type
          title
          text
          link
          link_text
        }
        ... on Set_Components_ImageGallery {
          type
          background_color {
            value
            label
          }
          images {
            id
            focus_css
            height
            ratio
            width
            permalink
            url
            extension
            path
            orientation
            ... on Asset_Assets {
              alt
            }
            ... on Asset_UserAssets {
              alt
            }
            ... on Asset_PostAssets {
              alt
            }
          }
        }
        ... on Set_Components_ThreeIconCards {
          type
          background_color {
            value
            label
          }
          icon_cards {
            ... on Set_IconCards_IconWithTextSection {
              type
              icon_text
              icon {
                id
                focus_css
                height
                ratio
                width
                permalink
                url
                extension
                path
                orientation
                ... on Asset_Assets {
                  alt
                }
                ... on Asset_UserAssets {
                  alt
                }
                ... on Asset_PostAssets {
                  alt
                }
              }
              icon_hover {
                id
                focus_css
                height
                ratio
                width
                permalink
                url
                extension
                path
                orientation
                ... on Asset_Assets {
                  alt
                }
                ... on Asset_UserAssets {
                  alt
                }
                ... on Asset_PostAssets {
                  alt
                }
              }
              background_color {
                value
                label
              }
              title
              subtitle
              text_components {
                ... on BardText {
                  type
                  text
                }
                ... on Set_TextComponents_Button {
                  type
                  link
                  text
                  level {
                    value
                    label
                  }
                }
                ... on Set_TextComponents_Image {
                  type
                  image {
                    id
                    focus_css
                    height
                    ratio
                    width
                    permalink
                    url
                    extension
                    path
                    orientation
                    ... on Asset_Assets {
                      alt
                    }
                    ... on Asset_UserAssets {
                      alt
                    }
                    ... on Asset_PostAssets {
                      alt
                    }
                  }
                }
              }
              text_width {
                value
                label
              }
            }
          }
        }
        ... on Set_Components_Events {
          type
          background_color {
            value
            label
          }
        }
        ... on Set_Components_Team {
          type
          background_color {
            value
            label
          }
        }
      }
    }
    ... on Entry_Pages_News {
      title_link
      title_link_text
      aside_components {
        ... on Set_AsideComponents_Banner {
          type
          background_color {
            value
            label
          }
          title
          text
          button_link
          button_text
        }
        ... on Set_AsideComponents_Post {
          type
          title
          post {
            title
            id
            permalink
            url
            uri
            slug
            date
            status
            blueprint
            ... on Entry_Posts_Post {
              id
              published
              date
              unpublished_reason {
                value
                label
              }
              liked_at
              number_of_likes
              text
              content {
                ... on Set_Content_Image {
                  type
                  image {
                    id
                    focus_css
                    height
                    ratio
                    width
                    permalink
                    url
                    extension
                    path
                    orientation
                    ... on Asset_Assets {
                      alt
                    }
                    ... on Asset_UserAssets {
                      alt
                    }
                    ... on Asset_PostAssets {
                      alt
                    }
                  }
                  logo_color {
                    value
                    label
                  }
                  logo_position {
                    value
                    label
                  }
                }
                ... on Set_Content_Text {
                  type
                  text
                  background_color {
                    value
                    label
                  }
                }
                ... on Set_Content_Video {
                  type
                  video
                }
              }
            }
          }
        }
        ... on Set_AsideComponents_Newsletter {
          type
          title
          text
          button_text
          thank_you_text
        }
        ... on Set_AsideComponents_AsideTeaser {
          type
          title
          link
          link_text
          background_color {
            value
            label
          }
          image {
            id
            focus_css
            height
            ratio
            width
            permalink
            url
            extension
            path
            orientation
            ... on Asset_Assets {
              alt
            }
            ... on Asset_UserAssets {
              alt
            }
            ... on Asset_PostAssets {
              alt
            }
          }
        }
      }
      seo_hidden
      seo_title
      seo_description
      seo_image {
        permalink
      }
      insert_components {
        ... on Set_InsertComponents_Banner {
          type
          posts_before_insert
          background_color {
            value
            label
          }
          title
          text
          button_link
          button_text
        }
        ... on Set_InsertComponents_BannerWithImage {
          type
          posts_before_insert
          title
          text
          button_link
          button_text
          image {
            id
            focus_css
            height
            ratio
            width
            permalink
            url
            extension
            path
            orientation
            ... on Asset_Assets {
              alt
            }
            ... on Asset_UserAssets {
              alt
            }
            ... on Asset_PostAssets {
              alt
            }
          }
        }
        ... on Set_InsertComponents_Newsletter {
          type
          posts_before_insert
          title
          text
          button_text
          thank_you_text
        }
      }
      seo_hidden
      seo_title
      seo_description
      seo_image {
        permalink
      }
    }
    ... on Entry_Team_TeamMember {
      id
      quote
      biography
      image {
        id
        focus_css
        height
        ratio
        width
        permalink
        url
        extension
        path
        orientation
        ... on Asset_Assets {
          alt
        }
        ... on Asset_UserAssets {
          alt
        }
        ... on Asset_PostAssets {
          alt
        }
      }
      team_formats {
        id
        slug
        title
        url
        ... on Term_TeamFormats_TeamFormat {
          id
          title_female
          title_male
        }
      }
      member_since
      website
      facebook
      instagram
      linkedin
      twitter
      author {
        id
        initials
        username
        firstname
        lastname
        name
        salutation {
          value
          label
        }
        avatar {
          id
          focus_css
          height
          ratio
          width
          permalink
          url
          extension
          path
          orientation
          ... on Asset_Assets {
            alt
          }
          ... on Asset_UserAssets {
            alt
          }
          ... on Asset_PostAssets {
            alt
          }
        }
      }
      team_member_components {
        ... on Set_TeamMemberComponents_Posts {
          type
          background_color {
            value
            label
          }
        }
        ... on Set_TeamMemberComponents_TitleWithText {
          type
          background_color {
            value
            label
          }
          title
          subtitle
          text_components {
            ... on BardText {
              type
              text
            }
            ... on Set_TextComponents_Button {
              type
              link
              text
              level {
                value
                label
              }
            }
            ... on Set_TextComponents_Image {
              type
              image {
                id
                focus_css
                height
                ratio
                width
                permalink
                url
                extension
                path
                orientation
                ... on Asset_Assets {
                  alt
                }
                ... on Asset_UserAssets {
                  alt
                }
                ... on Asset_PostAssets {
                  alt
                }
              }
            }
          }
          text_width {
            value
            label
          }
        }
        ... on Set_TeamMemberComponents_ImageWithText {
          type
          background_color {
            value
            label
          }
          title
          text
          button_link
          button_text
          image_position {
            value
            label
          }
          image {
            id
            focus_css
            height
            ratio
            width
            permalink
            url
            extension
            path
            orientation
            ... on Asset_Assets {
              alt
            }
            ... on Asset_UserAssets {
              alt
            }
            ... on Asset_PostAssets {
              alt
            }
          }
        }
        ... on Set_TeamMemberComponents_Teaser {
          type
          title
          text
          link
          link_text
        }
        ... on Set_TeamMemberComponents_ImageGallery {
          type
          background_color {
            value
            label
          }
          images {
            id
            focus_css
            height
            ratio
            width
            permalink
            url
            extension
            path
            orientation
            ... on Asset_Assets {
              alt
            }
            ... on Asset_UserAssets {
              alt
            }
            ... on Asset_PostAssets {
              alt
            }
          }
        }
      }
    }
    ... on Entry_Pages_Contact {
      background_color {
        value
        label
      }
      form {
        handle
        title
        honeypot
        rules
        fields {
          type
          display
          handle
          config
        }
      }
      intro_text
      thank_you_text
      error_text
      confirm_text
      button_text
      image {
        id
        focus_css
        height
        ratio
        width
        permalink
        url
        extension
        path
        orientation
        ... on Asset_Assets {
          alt
        }
        ... on Asset_UserAssets {
          alt
        }
        ... on Asset_PostAssets {
          alt
        }
      }
      components {
        ... on Set_Components_TitleWithText {
          type
          background_color {
            value
            label
          }
          title
          subtitle
          text_components {
            ... on BardText {
              type
              text
            }
            ... on Set_TextComponents_Button {
              type
              link
              text
              level {
                value
                label
              }
            }
            ... on Set_TextComponents_Image {
              type
              image {
                id
                focus_css
                height
                ratio
                width
                permalink
                url
                extension
                path
                orientation
                ... on Asset_Assets {
                  alt
                }
                ... on Asset_UserAssets {
                  alt
                }
                ... on Asset_PostAssets {
                  alt
                }
              }
            }
          }
          text_width {
            value
            label
          }
        }
        ... on Set_Components_ImageWithText {
          type
          background_color {
            value
            label
          }
          title
          text
          button_link
          button_text
          image_position {
            value
            label
          }
          image {
            id
            focus_css
            height
            ratio
            width
            permalink
            url
            extension
            path
            orientation
            ... on Asset_Assets {
              alt
            }
            ... on Asset_UserAssets {
              alt
            }
            ... on Asset_PostAssets {
              alt
            }
          }
        }
        ... on Set_Components_Teaser {
          type
          title
          text
          link
          link_text
        }
        ... on Set_Components_ImageGallery {
          type
          background_color {
            value
            label
          }
          images {
            id
            focus_css
            height
            ratio
            width
            permalink
            url
            extension
            path
            orientation
            ... on Asset_Assets {
              alt
            }
            ... on Asset_UserAssets {
              alt
            }
            ... on Asset_PostAssets {
              alt
            }
          }
        }
        ... on Set_Components_ThreeIconCards {
          type
          background_color {
            value
            label
          }
          icon_cards {
            ... on Set_IconCards_IconWithTextSection {
              type
              icon_text
              icon {
                id
                focus_css
                height
                ratio
                width
                permalink
                url
                extension
                path
                orientation
                ... on Asset_Assets {
                  alt
                }
                ... on Asset_UserAssets {
                  alt
                }
                ... on Asset_PostAssets {
                  alt
                }
              }
              icon_hover {
                id
                focus_css
                height
                ratio
                width
                permalink
                url
                extension
                path
                orientation
                ... on Asset_Assets {
                  alt
                }
                ... on Asset_UserAssets {
                  alt
                }
                ... on Asset_PostAssets {
                  alt
                }
              }
              background_color {
                value
                label
              }
              title
              subtitle
              text_components {
                ... on BardText {
                  type
                  text
                }
                ... on Set_TextComponents_Button {
                  type
                  link
                  text
                  level {
                    value
                    label
                  }
                }
                ... on Set_TextComponents_Image {
                  type
                  image {
                    id
                    focus_css
                    height
                    ratio
                    width
                    permalink
                    url
                    extension
                    path
                    orientation
                    ... on Asset_Assets {
                      alt
                    }
                    ... on Asset_UserAssets {
                      alt
                    }
                    ... on Asset_PostAssets {
                      alt
                    }
                  }
                }
              }
              text_width {
                value
                label
              }
            }
          }
        }
        ... on Set_Components_Events {
          type
          background_color {
            value
            label
          }
        }
        ... on Set_Components_Team {
          type
          background_color {
            value
            label
          }
        }
      }
    }
    ... on Entry_Posts_Post {
      id
      published
      date
      unpublished_reason {
        value
        label
      }
      liked_at
      number_of_likes
      text
      author {
        id
        initials
        username
        firstname
        lastname
        name
        avatar {
          id
          focus_css
          height
          ratio
          width
          permalink
          url
          extension
          path
          orientation
          ... on Asset_Assets {
            alt
          }
          ... on Asset_UserAssets {
            alt
          }
          ... on Asset_PostAssets {
            alt
          }
        }
        team_member {
          id
          title
          permalink
          uri
          url
        }
      }
      format {
        slug
        title
        permalink
        url
        uri
      }
      categories {
        slug
        title
        permalink
        url
        uri
      }
      tags {
        slug
        title
        permalink
        url
        uri
      }
      content {
        ... on Set_Content_Image {
          type
          image {
            id
            focus_css
            height
            ratio
            width
            permalink
            url
            extension
            path
            orientation
            ... on Asset_Assets {
              alt
            }
            ... on Asset_UserAssets {
              alt
            }
            ... on Asset_PostAssets {
              alt
            }
          }
          logo_color {
            value
            label
          }
          logo_position {
            value
            label
          }
        }
        ... on Set_Content_Text {
          type
          text
          background_color {
            value
            label
          }
        }
        ... on Set_Content_Video {
          type
          video
        }
      }
    }
  }
}
    `;
export const useGetPageBySlugQuery = <
      TData = GetPageBySlugQuery,
      TError = unknown
    >(
      variables?: GetPageBySlugQueryVariables,
      options?: UseQueryOptions<GetPageBySlugQuery, TError, TData>
    ) =>
    useQuery<GetPageBySlugQuery, TError, TData>(
      variables === undefined ? ['GetPageBySlug'] : ['GetPageBySlug', variables],
      gqlFetcher<GetPageBySlugQuery, GetPageBySlugQueryVariables>(GetPageBySlugDocument, variables),
      options
    );
export const GetPostsDocument = `
    query GetPosts($filter: JsonArgument, $sort: [String], $page: Int = 1, $limit: Int = 10) {
  entries: filteredPosts(filter: $filter, limit: $limit, page: $page, sort: $sort) {
    total
    from
    to
    per_page
    current_page
    last_page
    has_more_pages
    data {
      title
      id
      permalink
      url
      uri
      slug
      date
      status
      blueprint
      id
      published
      date
      unpublished_reason {
        value
        label
      }
      liked_at
      number_of_likes
      text
      author {
        id
        initials
        username
        firstname
        lastname
        name
        avatar {
          id
          focus_css
          height
          ratio
          width
          permalink
          url
          extension
          path
          orientation
          ... on Asset_Assets {
            alt
          }
          ... on Asset_UserAssets {
            alt
          }
          ... on Asset_PostAssets {
            alt
          }
        }
        team_member {
          id
          title
          permalink
          uri
          url
        }
      }
      format {
        slug
        title
        permalink
        url
        uri
      }
      categories {
        slug
        title
        permalink
        url
        uri
      }
      tags {
        slug
        title
        permalink
        url
        uri
      }
      content {
        ... on Set_Content_Image {
          type
          image {
            id
            focus_css
            height
            ratio
            width
            permalink
            url
            extension
            path
            orientation
            ... on Asset_Assets {
              alt
            }
            ... on Asset_UserAssets {
              alt
            }
            ... on Asset_PostAssets {
              alt
            }
          }
          logo_color {
            value
            label
          }
          logo_position {
            value
            label
          }
        }
        ... on Set_Content_Text {
          type
          text
          background_color {
            value
            label
          }
        }
        ... on Set_Content_Video {
          type
          video
        }
      }
    }
  }
}
    `;
export const useGetPostsQuery = <
      TData = GetPostsQuery,
      TError = unknown
    >(
      variables?: GetPostsQueryVariables,
      options?: UseQueryOptions<GetPostsQuery, TError, TData>
    ) =>
    useQuery<GetPostsQuery, TError, TData>(
      variables === undefined ? ['GetPosts'] : ['GetPosts', variables],
      gqlFetcher<GetPostsQuery, GetPostsQueryVariables>(GetPostsDocument, variables),
      options
    );
export const GetProfileGlobalDocument = `
    query GetProfileGlobal {
  globalSet(handle: "login_section_profile") {
    handle
    ... on GlobalSet_LoginSectionProfile {
      title: section_title
      current_voting_background_color {
        value
        label
      }
      current_voting_title
      current_voting_link_text
      current_lottery_background_color {
        value
        label
      }
      current_lottery_title
      current_lottery_link_text
    }
  }
}
    `;
export const useGetProfileGlobalQuery = <
      TData = GetProfileGlobalQuery,
      TError = unknown
    >(
      variables?: GetProfileGlobalQueryVariables,
      options?: UseQueryOptions<GetProfileGlobalQuery, TError, TData>
    ) =>
    useQuery<GetProfileGlobalQuery, TError, TData>(
      variables === undefined ? ['GetProfileGlobal'] : ['GetProfileGlobal', variables],
      gqlFetcher<GetProfileGlobalQuery, GetProfileGlobalQueryVariables>(GetProfileGlobalDocument, variables),
      options
    );
export const GetShopifyGlobalDocument = `
    query GetShopifyGlobal {
  globalSet(handle: "shopify") {
    handle
    ... on GlobalSet_Shopify {
      base_url
    }
  }
}
    `;
export const useGetShopifyGlobalQuery = <
      TData = GetShopifyGlobalQuery,
      TError = unknown
    >(
      variables?: GetShopifyGlobalQueryVariables,
      options?: UseQueryOptions<GetShopifyGlobalQuery, TError, TData>
    ) =>
    useQuery<GetShopifyGlobalQuery, TError, TData>(
      variables === undefined ? ['GetShopifyGlobal'] : ['GetShopifyGlobal', variables],
      gqlFetcher<GetShopifyGlobalQuery, GetShopifyGlobalQueryVariables>(GetShopifyGlobalDocument, variables),
      options
    );
export const GetSimilarPostsDocument = `
    query GetSimilarPosts($post_id: ID!, $sort: [String], $page: Int = 1, $limit: Int = 10) {
  similarPosts(post_id: $post_id, limit: $limit, page: $page, sort: $sort) {
    total
    from
    to
    per_page
    current_page
    last_page
    has_more_pages
    data {
      title
      id
      permalink
      url
      uri
      slug
      date
      status
      blueprint
      ... on Entry_Posts_Post {
        id
        published
        date
        unpublished_reason {
          value
          label
        }
        liked_at
        number_of_likes
        text
        author {
          id
          initials
          username
          firstname
          lastname
          name
          avatar {
            id
            focus_css
            height
            ratio
            width
            permalink
            url
            extension
            path
            orientation
            ... on Asset_Assets {
              alt
            }
            ... on Asset_UserAssets {
              alt
            }
            ... on Asset_PostAssets {
              alt
            }
          }
          team_member {
            id
            title
            permalink
            uri
            url
          }
        }
        format {
          slug
          title
          permalink
          url
          uri
        }
        categories {
          slug
          title
          permalink
          url
          uri
        }
        tags {
          slug
          title
          permalink
          url
          uri
        }
        content {
          ... on Set_Content_Image {
            type
            image {
              id
              focus_css
              height
              ratio
              width
              permalink
              url
              extension
              path
              orientation
              ... on Asset_Assets {
                alt
              }
              ... on Asset_UserAssets {
                alt
              }
              ... on Asset_PostAssets {
                alt
              }
            }
            logo_color {
              value
              label
            }
            logo_position {
              value
              label
            }
          }
          ... on Set_Content_Text {
            type
            text
            background_color {
              value
              label
            }
          }
          ... on Set_Content_Video {
            type
            video
          }
        }
      }
    }
  }
}
    `;
export const useGetSimilarPostsQuery = <
      TData = GetSimilarPostsQuery,
      TError = unknown
    >(
      variables: GetSimilarPostsQueryVariables,
      options?: UseQueryOptions<GetSimilarPostsQuery, TError, TData>
    ) =>
    useQuery<GetSimilarPostsQuery, TError, TData>(
      ['GetSimilarPosts', variables],
      gqlFetcher<GetSimilarPostsQuery, GetSimilarPostsQueryVariables>(GetSimilarPostsDocument, variables),
      options
    );
export const GetSitemapDocument = `
    query GetSitemap {
  sitemap {
    path
    url
    lastmod
    priority
    change_frequency
    alternates
  }
}
    `;
export const useGetSitemapQuery = <
      TData = GetSitemapQuery,
      TError = unknown
    >(
      variables?: GetSitemapQueryVariables,
      options?: UseQueryOptions<GetSitemapQuery, TError, TData>
    ) =>
    useQuery<GetSitemapQuery, TError, TData>(
      variables === undefined ? ['GetSitemap'] : ['GetSitemap', variables],
      gqlFetcher<GetSitemapQuery, GetSitemapQueryVariables>(GetSitemapDocument, variables),
      options
    );
export const GetTagsDocument = `
    query GetTags($query: String, $limit: Int = 1000) {
  taxonomy(handle: "tags") {
    title
    handle
  }
  terms(
    taxonomy: "tags"
    sort: "title"
    filter: {title: {contains: $query}}
    limit: $limit
  ) {
    total
    from
    to
    per_page
    current_page
    last_page
    has_more_pages
    data {
      id
      slug
      title
      url
    }
  }
}
    `;
export const useGetTagsQuery = <
      TData = GetTagsQuery,
      TError = unknown
    >(
      variables?: GetTagsQueryVariables,
      options?: UseQueryOptions<GetTagsQuery, TError, TData>
    ) =>
    useQuery<GetTagsQuery, TError, TData>(
      variables === undefined ? ['GetTags'] : ['GetTags', variables],
      gqlFetcher<GetTagsQuery, GetTagsQueryVariables>(GetTagsDocument, variables),
      options
    );
export const GetTeamFormatsDocument = `
    query GetTeamFormats {
  taxonomy(handle: "team_formats") {
    title
    handle
  }
  terms(taxonomy: "team_formats") {
    total
    from
    to
    per_page
    current_page
    last_page
    has_more_pages
    data {
      id
      slug
      title
      url
      ... on Term_TeamFormats_TeamFormat {
        id
        title_female
        title_male
      }
    }
  }
}
    `;
export const useGetTeamFormatsQuery = <
      TData = GetTeamFormatsQuery,
      TError = unknown
    >(
      variables?: GetTeamFormatsQueryVariables,
      options?: UseQueryOptions<GetTeamFormatsQuery, TError, TData>
    ) =>
    useQuery<GetTeamFormatsQuery, TError, TData>(
      variables === undefined ? ['GetTeamFormats'] : ['GetTeamFormats', variables],
      gqlFetcher<GetTeamFormatsQuery, GetTeamFormatsQueryVariables>(GetTeamFormatsDocument, variables),
      options
    );
export const GetTeamMemberForAuthorDocument = `
    query GetTeamMemberForAuthor($userId: String) {
  entry(collection: "team", filter: {author: {is: $userId}}) {
    id
    title
    slug
    url
    permalink
  }
}
    `;
export const useGetTeamMemberForAuthorQuery = <
      TData = GetTeamMemberForAuthorQuery,
      TError = unknown
    >(
      variables?: GetTeamMemberForAuthorQueryVariables,
      options?: UseQueryOptions<GetTeamMemberForAuthorQuery, TError, TData>
    ) =>
    useQuery<GetTeamMemberForAuthorQuery, TError, TData>(
      variables === undefined ? ['GetTeamMemberForAuthor'] : ['GetTeamMemberForAuthor', variables],
      gqlFetcher<GetTeamMemberForAuthorQuery, GetTeamMemberForAuthorQueryVariables>(GetTeamMemberForAuthorDocument, variables),
      options
    );
export const GetTeamMembersDocument = `
    query GetTeamMembers($filter: JsonArgument, $page: Int = 1, $limit: Int = 10) {
  entries(
    collection: "team"
    sort: "order"
    filter: $filter
    limit: $limit
    page: $page
  ) {
    total
    from
    to
    per_page
    current_page
    last_page
    has_more_pages
    data {
      title
      id
      permalink
      url
      uri
      slug
      date
      status
      blueprint
      ... on Entry_Team_TeamMember {
        id
        image {
          id
          focus_css
          height
          ratio
          width
          permalink
          url
          extension
          path
          orientation
          ... on Asset_Assets {
            alt
          }
          ... on Asset_UserAssets {
            alt
          }
          ... on Asset_PostAssets {
            alt
          }
        }
        team_formats {
          id
          slug
          title
          url
          ... on Term_TeamFormats_TeamFormat {
            id
            title_female
            title_male
          }
        }
        author {
          id
          name
          salutation {
            value
            label
          }
          avatar {
            id
            focus_css
            height
            ratio
            width
            permalink
            url
            extension
            path
            orientation
            ... on Asset_Assets {
              alt
            }
            ... on Asset_UserAssets {
              alt
            }
            ... on Asset_PostAssets {
              alt
            }
          }
        }
      }
    }
  }
}
    `;
export const useGetTeamMembersQuery = <
      TData = GetTeamMembersQuery,
      TError = unknown
    >(
      variables?: GetTeamMembersQueryVariables,
      options?: UseQueryOptions<GetTeamMembersQuery, TError, TData>
    ) =>
    useQuery<GetTeamMembersQuery, TError, TData>(
      variables === undefined ? ['GetTeamMembers'] : ['GetTeamMembers', variables],
      gqlFetcher<GetTeamMembersQuery, GetTeamMembersQueryVariables>(GetTeamMembersDocument, variables),
      options
    );
export const GetVotingsGlobalDocument = `
    query GetVotingsGlobal {
  globalSet(handle: "login_section_votings") {
    handle
    ... on GlobalSet_LoginSectionVotings {
      title: section_title
      text
    }
  }
}
    `;
export const useGetVotingsGlobalQuery = <
      TData = GetVotingsGlobalQuery,
      TError = unknown
    >(
      variables?: GetVotingsGlobalQueryVariables,
      options?: UseQueryOptions<GetVotingsGlobalQuery, TError, TData>
    ) =>
    useQuery<GetVotingsGlobalQuery, TError, TData>(
      variables === undefined ? ['GetVotingsGlobal'] : ['GetVotingsGlobal', variables],
      gqlFetcher<GetVotingsGlobalQuery, GetVotingsGlobalQueryVariables>(GetVotingsGlobalDocument, variables),
      options
    );
export const GetVotingsDocument = `
    query GetVotings {
  entries(collection: "votings", limit: 1000, sort: "date asc") {
    data {
      title
      id
      permalink
      url
      uri
      slug
      date
      status
      blueprint
      ... on Entry_Votings_ExternalVoting {
        id
        title
        text
        link
        window {
          start
          end
        }
      }
    }
  }
}
    `;
export const useGetVotingsQuery = <
      TData = GetVotingsQuery,
      TError = unknown
    >(
      variables?: GetVotingsQueryVariables,
      options?: UseQueryOptions<GetVotingsQuery, TError, TData>
    ) =>
    useQuery<GetVotingsQuery, TError, TData>(
      variables === undefined ? ['GetVotings'] : ['GetVotings', variables],
      gqlFetcher<GetVotingsQuery, GetVotingsQueryVariables>(GetVotingsDocument, variables),
      options
    );
export const CreateLikeDocument = `
    mutation CreateLike($entryId: ID!) {
  entry: createLike(entry_id: $entryId) {
    id
    slug
    title
    liked_at
    number_of_likes
  }
}
    `;
export const useCreateLikeMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateLikeMutation, TError, CreateLikeMutationVariables, TContext>) =>
    useMutation<CreateLikeMutation, TError, CreateLikeMutationVariables, TContext>(
      ['CreateLike'],
      (variables?: CreateLikeMutationVariables) => gqlFetcher<CreateLikeMutation, CreateLikeMutationVariables>(CreateLikeDocument, variables)(),
      options
    );
export const DeleteLikeDocument = `
    mutation DeleteLike($entryId: ID!) {
  entry: deleteLike(entry_id: $entryId) {
    id
    slug
    title
    liked_at
    number_of_likes
  }
}
    `;
export const useDeleteLikeMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteLikeMutation, TError, DeleteLikeMutationVariables, TContext>) =>
    useMutation<DeleteLikeMutation, TError, DeleteLikeMutationVariables, TContext>(
      ['DeleteLike'],
      (variables?: DeleteLikeMutationVariables) => gqlFetcher<DeleteLikeMutation, DeleteLikeMutationVariables>(DeleteLikeDocument, variables)(),
      options
    );
export const SubscribeToNewsletterDocument = `
    mutation SubscribeToNewsletter($email: String!, $name: String!) {
  result: subscribeToNewsletter(email: $email, name: $name) {
    success
    message
  }
}
    `;
export const useSubscribeToNewsletterMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SubscribeToNewsletterMutation, TError, SubscribeToNewsletterMutationVariables, TContext>) =>
    useMutation<SubscribeToNewsletterMutation, TError, SubscribeToNewsletterMutationVariables, TContext>(
      ['SubscribeToNewsletter'],
      (variables?: SubscribeToNewsletterMutationVariables) => gqlFetcher<SubscribeToNewsletterMutation, SubscribeToNewsletterMutationVariables>(SubscribeToNewsletterDocument, variables)(),
      options
    );
export const ParseMarkdownDocument = `
    mutation ParseMarkdown($text: String) {
  markdown: parseMarkdown(text: $text)
}
    `;
export const useParseMarkdownMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ParseMarkdownMutation, TError, ParseMarkdownMutationVariables, TContext>) =>
    useMutation<ParseMarkdownMutation, TError, ParseMarkdownMutationVariables, TContext>(
      ['ParseMarkdown'],
      (variables?: ParseMarkdownMutationVariables) => gqlFetcher<ParseMarkdownMutation, ParseMarkdownMutationVariables>(ParseMarkdownDocument, variables)(),
      options
    );
export const SubscribeToNewsletterListDocument = `
    mutation SubscribeToNewsletterList($id: String!) {
  subscribeToNewsletterList(id: $id) {
    success
    message
  }
}
    `;
export const useSubscribeToNewsletterListMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SubscribeToNewsletterListMutation, TError, SubscribeToNewsletterListMutationVariables, TContext>) =>
    useMutation<SubscribeToNewsletterListMutation, TError, SubscribeToNewsletterListMutationVariables, TContext>(
      ['SubscribeToNewsletterList'],
      (variables?: SubscribeToNewsletterListMutationVariables) => gqlFetcher<SubscribeToNewsletterListMutation, SubscribeToNewsletterListMutationVariables>(SubscribeToNewsletterListDocument, variables)(),
      options
    );
export const UnsubscribeFromNewsletterListDocument = `
    mutation UnsubscribeFromNewsletterList($id: String!) {
  unsubscribeFromNewsletterList(id: $id) {
    success
    message
  }
}
    `;
export const useUnsubscribeFromNewsletterListMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UnsubscribeFromNewsletterListMutation, TError, UnsubscribeFromNewsletterListMutationVariables, TContext>) =>
    useMutation<UnsubscribeFromNewsletterListMutation, TError, UnsubscribeFromNewsletterListMutationVariables, TContext>(
      ['UnsubscribeFromNewsletterList'],
      (variables?: UnsubscribeFromNewsletterListMutationVariables) => gqlFetcher<UnsubscribeFromNewsletterListMutation, UnsubscribeFromNewsletterListMutationVariables>(UnsubscribeFromNewsletterListDocument, variables)(),
      options
    );
export const UpdateUserDocument = `
    mutation UpdateUser($salutation: String, $firstname: String, $lastname: String, $phone: String, $street: String, $zip: String, $city: String) {
  user: updateUser(
    salutation: $salutation
    firstname: $firstname
    lastname: $lastname
    phone: $phone
    street: $street
    zip: $zip
    city: $city
  ) {
    id
    firstname
    lastname
    name
    salutation {
      value
      label
    }
    email
    username
    initials
    phone
    street
    zip
    city
    created_at
    member_category {
      value
      label
    }
    artist_category {
      value
      label
    }
    avatar {
      id
      focus_css
      height
      ratio
      width
      permalink
      url
      extension
      path
      orientation
      ... on Asset_Assets {
        alt
      }
      ... on Asset_UserAssets {
        alt
      }
      ... on Asset_PostAssets {
        alt
      }
    }
  }
}
    `;
export const useUpdateUserMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateUserMutation, TError, UpdateUserMutationVariables, TContext>) =>
    useMutation<UpdateUserMutation, TError, UpdateUserMutationVariables, TContext>(
      ['UpdateUser'],
      (variables?: UpdateUserMutationVariables) => gqlFetcher<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, variables)(),
      options
    );
export const UpdateUserPasswordDocument = `
    mutation UpdateUserPassword($username: String, $current_password: String, $new_password: String, $new_password_confirmation: String) {
  user: updateUserPassword(
    username: $username
    current_password: $current_password
    new_password: $new_password
    new_password_confirmation: $new_password_confirmation
  ) {
    id
    firstname
    lastname
    name
    salutation {
      value
      label
    }
    email
    username
    initials
    phone
    street
    zip
    city
    created_at
    member_category {
      value
      label
    }
    artist_category {
      value
      label
    }
    avatar {
      id
      focus_css
      height
      ratio
      width
      permalink
      url
      extension
      path
      orientation
      ... on Asset_Assets {
        alt
      }
      ... on Asset_UserAssets {
        alt
      }
      ... on Asset_PostAssets {
        alt
      }
    }
  }
}
    `;
export const useUpdateUserPasswordMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateUserPasswordMutation, TError, UpdateUserPasswordMutationVariables, TContext>) =>
    useMutation<UpdateUserPasswordMutation, TError, UpdateUserPasswordMutationVariables, TContext>(
      ['UpdateUserPassword'],
      (variables?: UpdateUserPasswordMutationVariables) => gqlFetcher<UpdateUserPasswordMutation, UpdateUserPasswordMutationVariables>(UpdateUserPasswordDocument, variables)(),
      options
    );
export const UploadFileDocument = `
    mutation UploadFile($file: Upload) {
  uploadFile(file: $file) {
    id
    focus_css
    height
    ratio
    width
    permalink
    url
    extension
    path
    orientation
  }
}
    `;
export const useUploadFileMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UploadFileMutation, TError, UploadFileMutationVariables, TContext>) =>
    useMutation<UploadFileMutation, TError, UploadFileMutationVariables, TContext>(
      ['UploadFile'],
      (variables?: UploadFileMutationVariables) => gqlFetcher<UploadFileMutation, UploadFileMutationVariables>(UploadFileDocument, variables)(),
      options
    );